var items = {
  "block.minecraft.acacia_button": "Ակացիայի փայտից կոճակ",
  "block.minecraft.acacia_door": "Ակացիայի դուռ",
  "block.minecraft.acacia_fence": "Ակացիայի ծառի ցանկապատ",
  "block.minecraft.acacia_fence_gate": "Ակացիայի փայտից ցանկապատի դարպաս",
  "block.minecraft.acacia_hanging_sign": "Ակացիայից կախովի ցուցանակ",
  "block.minecraft.acacia_leaves": "Ակացիայի տերեւներ",
  "block.minecraft.acacia_log": "Ակացիայի գերան",
  "block.minecraft.acacia_planks": "Ակացիայի տախտակներ",
  "block.minecraft.acacia_pressure_plate": "Ակացիայի փայտից ճնշաթիթեղ",
  "block.minecraft.acacia_sapling": "Ակացիայի տնկի",
  "block.minecraft.acacia_shelf": "Ակացիայի դարակ",
  "block.minecraft.acacia_sign": "Ակացիայի ցուցանակ",
  "block.minecraft.acacia_slab": "Ակացիայի սալիկ",
  "block.minecraft.acacia_stairs": "Ակացիայի աստիճաններ",
  "block.minecraft.acacia_trapdoor": "Ակացիայի փայտից ծուղակե դռնակ",
  "block.minecraft.acacia_wall_hanging_sign": "Ակացիայից պատի կախովի ցուցանակ",
  "block.minecraft.acacia_wall_sign": "Ակացիայից պատի ցուցանակ",
  "block.minecraft.acacia_wood": "Ակացիայի փայտ",
  "block.minecraft.activator_rail": "Ակտիվացնող Ռելս",
  "block.minecraft.air": "Օդ",
  "block.minecraft.allium": "Սոխի ծաղիկ",
  "block.minecraft.amethyst_block": "Մեղեսիկե բլոկ",
  "block.minecraft.amethyst_cluster": " Մեղեսիկային բյուրեղաբույլ",
  "block.minecraft.ancient_debris": "Հնագույն Ավերակներ",
  "block.minecraft.andesite": "Անդեզիտ",
  "block.minecraft.andesite_slab": "Անդեզիտե սալիկ",
  "block.minecraft.andesite_stairs": "Անդեզիտե աստիճաններ",
  "block.minecraft.andesite_wall": "Անդեզիտե Պատ",
  "block.minecraft.anvil": "Զնդան",
  "block.minecraft.attached_melon_stem": "Կցված դդմի ցողուն",
  "block.minecraft.attached_pumpkin_stem": "Կցված դդմի ցողուն",
  "block.minecraft.azalea": "Լեռնավարդ",
  "block.minecraft.azalea_leaves": "Լեռնավարդի տերևներ",
  "block.minecraft.azure_bluet": "Կապույտ Տերեփուկ",
  "block.minecraft.bamboo": "Հնդկեղեգ",
  "block.minecraft.bamboo_block": "Բամբուկի Բլոկ",
  "block.minecraft.bamboo_button": "Բամբուկից կոճակ",
  "block.minecraft.bamboo_door": "Բամբուկից դուռ",
  "block.minecraft.bamboo_fence": "Բանմուկյա դարպաս",
  "block.minecraft.bamboo_fence_gate": "Բանբուկյա դարպասի մուտք",
  "block.minecraft.bamboo_hanging_sign": "Կախովի ցուցանակ բամբուկից",
  "block.minecraft.bamboo_mosaic": "Հնդկեղեգի խճանկար",
  "block.minecraft.bamboo_mosaic_slab": "Հնդկեղեգի Խճանկանրից Սալիկ",
  "block.minecraft.bamboo_mosaic_stairs": "Հնդկեղեգի խճանկարից աստիճաններ",
  "block.minecraft.bamboo_planks": "Հնդկեղեգի տախտակներ",
  "block.minecraft.bamboo_pressure_plate": "Բամբուկային Ճնշաթիթեղ",
  "block.minecraft.bamboo_sapling": "Բամբուկի Կտոր",
  "block.minecraft.bamboo_shelf": "Հնդկեղեգից դարակ",
  "block.minecraft.bamboo_sign": "Բամբուկից ցուցանակ",
  "block.minecraft.bamboo_slab": "Հնդկեղեգից Սալիկ",
  "block.minecraft.bamboo_stairs": "Հնդկեղեգից աստճաններ",
  "block.minecraft.bamboo_trapdoor": "Բամբուկից թակարդ-դուռ",
  "block.minecraft.bamboo_wall_hanging_sign": "Բամբուկից պատից կախովի ցուցանակ",
  "block.minecraft.bamboo_wall_sign": "Բամբուկից պատի ցուցանակ",
  "block.minecraft.banner.base.black": "Ամբողջովին սեւ դաշտ",
  "block.minecraft.banner.base.blue": "Ամբողջովին կապույտ դաշտ",
  "block.minecraft.banner.base.brown": "Ամբողջովին շագանակագույն դաշտ",
  "block.minecraft.banner.base.cyan": "Ամբողջովին փիրուզագույն դաշտ",
  "block.minecraft.banner.base.gray": "Ամբողջովին մոխրագույն դաշտ",
  "block.minecraft.banner.base.green": "Ամբողջովին կանաչ դաշտ",
  "block.minecraft.banner.base.light_blue": "Ամբողջովին բաց կապույտ դաշտ",
  "block.minecraft.banner.base.light_gray": "Ամբողջովին բաց մոխրագույն դաշտ",
  "block.minecraft.banner.base.lime": "Ամբողջությամբ լայմ դաշտ",
  "block.minecraft.banner.base.magenta": "Ամբողջովին մանուշակագույն դաշտ",
  "block.minecraft.banner.base.orange": "Ամբողջովին նարնջագույն դաշտ",
  "block.minecraft.banner.base.pink": "Ամբողջովին վարդագույն դաշտ",
  "block.minecraft.banner.base.purple": "Ամբողջովին մանուշակագույն դաշտ",
  "block.minecraft.banner.base.red": "Ամբողջովին կարմիր դաշտ",
  "block.minecraft.banner.base.white": "Ամբողջովին սպիտակ դաշտ",
  "block.minecraft.banner.base.yellow": "Ամբողջովին դեղին դաշտ",
  "block.minecraft.banner.border.black": "Սեւ եզրաքար",
  "block.minecraft.banner.border.blue": "Կապույտ եզրաքար",
  "block.minecraft.banner.border.brown": "Շականակագույն եզրաքար",
  "block.minecraft.banner.border.cyan": "Փիրուզ եզրաքար",
  "block.minecraft.banner.border.gray": "Մոխրագույն եզրաքար",
  "block.minecraft.banner.border.green": "Կանաչ եզրաքար",
  "block.minecraft.banner.border.light_blue": "Բաց կապույտ եզրաքար",
  "block.minecraft.banner.border.light_gray": "Բաց մոխրագույն եզրաքար",
  "block.minecraft.banner.border.lime": "Լայմ եզրաքար",
  "block.minecraft.banner.border.magenta": "Մորեգույն Կապանք",
  "block.minecraft.banner.border.orange": "Նարնջագույն եզրաքար",
  "block.minecraft.banner.border.pink": "Վարդագույն եզրաքար",
  "block.minecraft.banner.border.purple": "Մանուշակագույն եզրաքար",
  "block.minecraft.banner.border.red": "Կարմիր եզրաքար",
  "block.minecraft.banner.border.white": "Սպիտակ եզրաքար",
  "block.minecraft.banner.border.yellow": "Դեղին եզրաքար",
  "block.minecraft.banner.bricks.black": "Սև աղյուս",
  "block.minecraft.banner.bricks.blue": "Կապույտ աղյուս",
  "block.minecraft.banner.bricks.brown": "Շագանակագույն աղյուս",
  "block.minecraft.banner.bricks.cyan": "Փիրուզագույն աղյուս",
  "block.minecraft.banner.bricks.gray": "Մոխրագույն աղյուս",
  "block.minecraft.banner.bricks.green": "Կանաչ աղյուս",
  "block.minecraft.banner.bricks.light_blue": "Բաց կապույտ աղյուս",
  "block.minecraft.banner.bricks.light_gray": "Բաց մոխրագույն աղյուս",
  "block.minecraft.banner.bricks.lime": "Բաց կանաչ աղյուս",
  "block.minecraft.banner.bricks.magenta": "Մորեգույն աղյուս",
  "block.minecraft.banner.bricks.orange": "Նարնջագույն աղյուս",
  "block.minecraft.banner.bricks.pink": "Վարդագույն աղյուս",
  "block.minecraft.banner.bricks.purple": "Մանուշակագույն աղյուս",
  "block.minecraft.banner.bricks.red": "Կարմիր աղյուս",
  "block.minecraft.banner.bricks.white": "Սպիտակ աղյուս",
  "block.minecraft.banner.bricks.yellow": "Դեղին աղյուս",
  "block.minecraft.banner.circle.black": "Սև շրջան",
  "block.minecraft.banner.circle.blue": "Կապույտ շրջան",
  "block.minecraft.banner.circle.brown": "Շականակագույն շրջան",
  "block.minecraft.banner.circle.cyan": "Փիրուզագույն շրջան",
  "block.minecraft.banner.circle.gray": "Մոխրագույն շրջան",
  "block.minecraft.banner.circle.green": "Կանաչ շրջան",
  "block.minecraft.banner.circle.light_blue": "Բաց կապույտ շրջան",
  "block.minecraft.banner.circle.light_gray": "Բաց մոխրագույն շրջան",
  "block.minecraft.banner.circle.lime": "Բաց կանաչ շրջան",
  "block.minecraft.banner.circle.magenta": "Մորեգույն շրջան",
  "block.minecraft.banner.circle.orange": "Նարնջագույն շրջան",
  "block.minecraft.banner.circle.pink": "Վարդագույն շրջան",
  "block.minecraft.banner.circle.purple": "Մանուշակագույն շրջան",
  "block.minecraft.banner.circle.red": "Կարմիր շրջան",
  "block.minecraft.banner.circle.white": "Սպիտակ շրջան",
  "block.minecraft.banner.circle.yellow": "Դեղին շրջան",
  "block.minecraft.banner.creeper.black": "Քրիփերի սև լիցք",
  "block.minecraft.banner.creeper.blue": "Կապույտ սողացող լիցք",
  "block.minecraft.banner.creeper.brown": "Շագանակագույն քրիփերի լիցք",
  "block.minecraft.banner.creeper.cyan": "Փիրուզագույն քրիփերի լիցք",
  "block.minecraft.banner.creeper.gray": "Մոխրագույն քրիփերի լիցք",
  "block.minecraft.banner.creeper.green": "Կանաչ քրիփերի լիցք",
  "block.minecraft.banner.creeper.light_blue": "Բաց կապույտ քրիփերի լիցք",
  "block.minecraft.banner.creeper.light_gray": "Բաց մոխրագույն քրիփերի լիցք",
  "block.minecraft.banner.creeper.lime": "Բաց Կանաչ սողացող լիցք",
  "block.minecraft.banner.creeper.magenta": "Մագնետա սողացող լիցք",
  "block.minecraft.banner.creeper.orange": "Նարնջագույն սողացող լիցք",
  "block.minecraft.banner.creeper.pink": "Վարդագույն սողացող լիցք",
  "block.minecraft.banner.creeper.purple": "Մանուշակագույն սողացող լիցք",
  "block.minecraft.banner.creeper.red": "Կարմիր սողացող լիցք",
  "block.minecraft.banner.creeper.white": "Սպիտակ սողացող լիցք",
  "block.minecraft.banner.creeper.yellow": "Դեղին սողացող լիցք",
  "block.minecraft.banner.cross.black": "Սև շեղ խաչ",
  "block.minecraft.banner.cross.blue": "Կապույտ շեղ խաչ",
  "block.minecraft.banner.cross.brown": "Շագանակագույն շեղ խաչ",
  "block.minecraft.banner.cross.cyan": "Փիրուզագույն շեղ խաչ",
  "block.minecraft.banner.cross.gray": "Մոխրագույն շեղ խաչ",
  "block.minecraft.banner.cross.green": "Կանաչ շեղ խաչ",
  "block.minecraft.banner.cross.light_blue": "Բաց կապույտ շեղ խաչ",
  "block.minecraft.banner.cross.light_gray": "Բաց մոխրագույն շեղ խաչ",
  "block.minecraft.banner.cross.lime": "Բաց կանաչ շեղ խաչ",
  "block.minecraft.banner.cross.magenta": "Մորեգույն շեղ խաչ",
  "block.minecraft.banner.cross.orange": "Նարնջագույն շեղ խաչ",
  "block.minecraft.banner.cross.pink": "Վարդագույն շեղ խաչ",
  "block.minecraft.banner.cross.purple": "Մանուշակագույն շեղ խաչ",
  "block.minecraft.banner.cross.red": "Կարմիր շեղ խաչ",
  "block.minecraft.banner.cross.white": "Սպիտակ շեղ խաչ",
  "block.minecraft.banner.cross.yellow": "Դեղին շեղ խաչ",
  "block.minecraft.banner.curly_border.black": "Սեւ ատամնավոր եզրաքար",
  "block.minecraft.banner.curly_border.blue": "Կապույտ բլոկք շեղված",
  "block.minecraft.banner.curly_border.brown": "Շականակագույն ատամնավոր եզրաքար",
  "block.minecraft.banner.curly_border.cyan": "Ցիան բլոկք շեղված",
  "block.minecraft.banner.curly_border.gray": "Մոխրագույն բլոկք շեղված",
  "block.minecraft.banner.curly_border.green": "Կանաչ ատամնավոր եզրաքար",
  "block.minecraft.banner.curly_border.light_blue": "Բաց Կապույտ բլոկք շեղված",
  "block.minecraft.banner.curly_border.light_gray": "Բաց Մոխրագույն բլոկք շեղված",
  "block.minecraft.banner.curly_border.lime": "Բաց Կանաչ բլոկք շեղված",
  "block.minecraft.banner.curly_border.magenta": "Մորեգույն բլոկք շեղված",
  "block.minecraft.banner.curly_border.orange": "Նարնջագույն բլոկք շեղված",
  "block.minecraft.banner.curly_border.pink": "Վարդագույն բլոկք շեղված",
  "block.minecraft.banner.curly_border.purple": "Մանուշակագույն բլոկք շեղված",
  "block.minecraft.banner.curly_border.red": "Կարմիր ատամնավոր եզրաքար",
  "block.minecraft.banner.curly_border.white": "Սպիտակ բլոկք շեղված",
  "block.minecraft.banner.curly_border.yellow": "Դեղին բլոկք շեղված",
  "block.minecraft.banner.diagonal_left.black": "Սև ձախ կես",
  "block.minecraft.banner.diagonal_left.blue": "Կապույտ ձախ կես",
  "block.minecraft.banner.diagonal_left.brown": "Շականակագույն ձախ կես",
  "block.minecraft.banner.diagonal_left.cyan": "Փիրուզագույն ձախ կես",
  "block.minecraft.banner.diagonal_left.gray": "Մոխրագույն ձախ կես",
  "block.minecraft.banner.diagonal_left.green": "Կանաչ ձախ կես",
  "block.minecraft.banner.diagonal_left.light_blue": "Բաց կապույտ ձախ կես",
  "block.minecraft.banner.diagonal_left.light_gray": "Բաց մոխրագույն ձախ կես",
  "block.minecraft.banner.diagonal_left.lime": "Բաց կանաչ ձախ կես",
  "block.minecraft.banner.diagonal_left.magenta": "Մորեգույն ձախ կես",
  "block.minecraft.banner.diagonal_left.orange": "Նարնջագույն ձախ կես",
  "block.minecraft.banner.diagonal_left.pink": "Վարդագույն ձախ կես",
  "block.minecraft.banner.diagonal_left.purple": "Մանուշակագույն ձախ կես",
  "block.minecraft.banner.diagonal_left.red": "Կարմիր ձախ կես",
  "block.minecraft.banner.diagonal_left.white": "Սպիտակ ձախ կես",
  "block.minecraft.banner.diagonal_left.yellow": "Դեղին ձախ կես",
  "block.minecraft.banner.diagonal_right.black": "Սև մեկ թեքում",
  "block.minecraft.banner.diagonal_right.blue": "Կապույտ մեկ թեքում",
  "block.minecraft.banner.diagonal_right.brown": "Շականակագույն մեկ թեքում",
  "block.minecraft.banner.diagonal_right.cyan": "Ցիան մեկ թեքում",
  "block.minecraft.banner.diagonal_right.gray": "Շականակագույն մեկ թեքում",
  "block.minecraft.banner.diagonal_right.green": "Կանաչ մեկ թեքում",
  "block.minecraft.banner.diagonal_right.light_blue": "Բաց Կապույտ մեկ թեքում",
  "block.minecraft.banner.diagonal_right.light_gray": "Բաց Շականակագույն մեկ թեքում",
  "block.minecraft.banner.diagonal_right.lime": "Բաց Կանաչ մեկ թեքում",
  "block.minecraft.banner.diagonal_right.magenta": "Մորեգույն մեկ թեքում",
  "block.minecraft.banner.diagonal_right.orange": "Նարնջագույն մեկ թեքում",
  "block.minecraft.banner.diagonal_right.pink": "Վարդագույն մեկ թեքում",
  "block.minecraft.banner.diagonal_right.purple": "Մանուշակագույն մեկ թեքում",
  "block.minecraft.banner.diagonal_right.red": "Կարմիր մեկ թեքում",
  "block.minecraft.banner.diagonal_right.white": "Սպիտակ մեկ թեքում",
  "block.minecraft.banner.diagonal_right.yellow": "Դեղին մեկ թեքում",
  "block.minecraft.banner.diagonal_up_left.black": "Սև մեկ թեքում շրջված ",
  "block.minecraft.banner.diagonal_up_left.blue": "Կապույտ մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_left.brown": "Շականակագույն մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_left.cyan": "Ցիան մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_left.gray": "Մոխրագույն մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_left.green": "Կանաչ մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Բաց Կապույտ մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Բաց Մոխրագույն մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_left.lime": "Բաց Կանաչ մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_left.magenta": "Մորեգույն մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_left.orange": "Նարնջագույն մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_left.pink": "Վարդագույն մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_left.purple": "Մանուշակագույն մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_left.red": "Կարմիր մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_left.white": "Սպիտակ մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_left.yellow": "Դեղին մեկ թեքում շրջված",
  "block.minecraft.banner.diagonal_up_right.black": "Սև  մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.blue": "Կապույտ  մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.brown": "Շականակագույն  մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.cyan": "Ցիան մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.gray": "Շականակագույն մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.green": "Կանաչ  մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Բաց Կապույտ մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Բաց Մոխրագույն մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.lime": "Բաց Կանաչ մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.magenta": "Մագնետա մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.orange": "Նարնջագույն մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.pink": "Վարդագույն մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.purple": "Մանուշակագույն  մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.red": "Կարմիր  մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.white": "Սպիտակ մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.diagonal_up_right.yellow": "Դեղին մեկ թեքում չարիք Հակադարձ",
  "block.minecraft.banner.flow.black": "Սև հոսք",
  "block.minecraft.banner.flow.blue": "Կապույտ հոսք",
  "block.minecraft.banner.flow.brown": "Դարչնագույն հոսք",
  "block.minecraft.banner.flow.cyan": "Cyan հոսք",
  "block.minecraft.banner.flow.gray": "Մոխրագույն հոսք",
  "block.minecraft.banner.flow.green": "Կանաչ հոսք",
  "block.minecraft.banner.flow.light_blue": "Բաց կապույտ հոսք",
  "block.minecraft.banner.flow.light_gray": "Բաց մոխրագույն հոսք",
  "block.minecraft.banner.flow.lime": "Կրաքարի հոսք",
  "block.minecraft.banner.flow.magenta": "Magenta Flow",
  "block.minecraft.banner.flow.orange": "Նարնջագույն հոսք",
  "block.minecraft.banner.flow.pink": "Վարդագույն հոսք",
  "block.minecraft.banner.flow.purple": "Մանուշակագույն հոսք",
  "block.minecraft.banner.flow.red": "Կարմիր հոսք",
  "block.minecraft.banner.flow.white": "Սպիտակ հոսք",
  "block.minecraft.banner.flow.yellow": "Դեղին հոսք",
  "block.minecraft.banner.flower.black": "Սև ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.blue": "Կապույտ ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.brown": "Շականակագույն ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.cyan": "Ցիան ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.gray": "Մոխրագույն ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.green": "Կանաչ ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.light_blue": "Բաց Կապույտ ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.light_gray": "Բաց Մոխրագույն ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.lime": "Բաց Կանաչ ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.magenta": "Մորեգույն ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.orange": "Նարնջագույն ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.pink": "Վարդագույն ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.purple": "Մանուշակագույն ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.red": "Կարմիր ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.white": "Սպիտակ ծաղիկների լիցքավորում",
  "block.minecraft.banner.flower.yellow": "Դեղին ծաղիկների լիցքավորում",
  "block.minecraft.banner.globe.black": "Սեւ երկրագունդ",
  "block.minecraft.banner.globe.blue": "Կապույտ երկրագունդ",
  "block.minecraft.banner.globe.brown": "Շագանակագույն երկրագունդ",
  "block.minecraft.banner.globe.cyan": "Փիրուզագույն երկրագունդ",
  "block.minecraft.banner.globe.gray": "Մոխրագույն Գլոբուսը",
  "block.minecraft.banner.globe.green": "Կանաչ երկրագունդ",
  "block.minecraft.banner.globe.light_blue": "Բաց կապույտ երկրագունդ",
  "block.minecraft.banner.globe.light_gray": "Բաց մոխրագույն երկրագունդ",
  "block.minecraft.banner.globe.lime": "Լայմ երկրագունդ",
  "block.minecraft.banner.globe.magenta": "Մորեգույն երկրագունդ",
  "block.minecraft.banner.globe.orange": "Նարնջագույն աշխարհը",
  "block.minecraft.banner.globe.pink": "Վարդագույն երկրագունդ",
  "block.minecraft.banner.globe.purple": "Մանուշակագույն երկրագունդ",
  "block.minecraft.banner.globe.red": "Կարմիր երկրագունդ",
  "block.minecraft.banner.globe.white": "Սպիտակ երկրագունդ",
  "block.minecraft.banner.globe.yellow": "Դեղին երկրագունդ",
  "block.minecraft.banner.gradient.black": "Սև սահանցում",
  "block.minecraft.banner.gradient.blue": "Կապույտ սահանցում",
  "block.minecraft.banner.gradient.brown": "Շականակագույն սահանցում",
  "block.minecraft.banner.gradient.cyan": "Ցիան սահանցում",
  "block.minecraft.banner.gradient.gray": "Մոխրագույն սահանցում",
  "block.minecraft.banner.gradient.green": "Կանաչ սահանցում",
  "block.minecraft.banner.gradient.light_blue": "Բաց Կապույտ սահանցում",
  "block.minecraft.banner.gradient.light_gray": "Բաց Մոխրագույն սահանցում",
  "block.minecraft.banner.gradient.lime": "Բաց Կանաչ սահանցում",
  "block.minecraft.banner.gradient.magenta": "Մորեգույն սահանցում",
  "block.minecraft.banner.gradient.orange": "Նարնջագույն սահանցում",
  "block.minecraft.banner.gradient.pink": "Վարդագույն սահանցում",
  "block.minecraft.banner.gradient.purple": "Մանուշակագույն սահանցում",
  "block.minecraft.banner.gradient.red": "Կարմիր սահանցում",
  "block.minecraft.banner.gradient.white": "Սպիտակ սահանցում",
  "block.minecraft.banner.gradient.yellow": "Դեղին սահանցում",
  "block.minecraft.banner.gradient_up.black": "Սև տակի սահանցում",
  "block.minecraft.banner.gradient_up.blue": "Կապույտ տակի սահանցում",
  "block.minecraft.banner.gradient_up.brown": "Շականակագույն տակի սահանցում",
  "block.minecraft.banner.gradient_up.cyan": "Ցիան տակի սահանցում",
  "block.minecraft.banner.gradient_up.gray": "Մոխրագույն տակի սահանցում",
  "block.minecraft.banner.gradient_up.green": "Կանաչ տակի սահանցում",
  "block.minecraft.banner.gradient_up.light_blue": "Բաց Կապույտ տակի սահանցում",
  "block.minecraft.banner.gradient_up.light_gray": "Բաց Մոխրագույն տակի սահանցում",
  "block.minecraft.banner.gradient_up.lime": "Լայմ տակի սահանցում",
  "block.minecraft.banner.gradient_up.magenta": "Մորեգույն տակի սահանցում",
  "block.minecraft.banner.gradient_up.orange": "Նարնջագույն տակի սահանցում",
  "block.minecraft.banner.gradient_up.pink": "Վարդագույն տակի սահանցում",
  "block.minecraft.banner.gradient_up.purple": "Մանուշակագույն տակի սահանցում",
  "block.minecraft.banner.gradient_up.red": "Կարմիր տակի սահանցում",
  "block.minecraft.banner.gradient_up.white": "Սպիտակ տակի սահանցում",
  "block.minecraft.banner.gradient_up.yellow": "Դեղին տակի սահանցում",
  "block.minecraft.banner.guster.black": "Black Guster",
  "block.minecraft.banner.guster.blue": "Կապույտ Գաստեր",
  "block.minecraft.banner.guster.brown": "Շագանակագույն մրրիկ",
  "block.minecraft.banner.guster.cyan": "Փիրուզագույն մրրիկ",
  "block.minecraft.banner.guster.gray": "Գորշ Մրրիկ",
  "block.minecraft.banner.guster.green": "Կանաչ Մրրիկ",
  "block.minecraft.banner.guster.light_blue": "Բաց Կապույտ Մրրիկ",
  "block.minecraft.banner.guster.light_gray": "Բաց Մոխրագույն Մրրիկ",
  "block.minecraft.banner.guster.lime": "Բաց Կանաչ Մրրիկ",
  "block.minecraft.banner.guster.magenta": "Ծիրանեգույն Մրրիկ",
  "block.minecraft.banner.guster.orange": "Նարնջագույն Մրրիկ",
  "block.minecraft.banner.guster.pink": "Վարդագույն Մրրիկ",
  "block.minecraft.banner.guster.purple": "Մանուշակագույն Մրրիկ",
  "block.minecraft.banner.guster.red": "Կարմիր Մրրիկ",
  "block.minecraft.banner.guster.white": "Սպիտակ Մրրիկ",
  "block.minecraft.banner.guster.yellow": "Դեղին Մրրիկ",
  "block.minecraft.banner.half_horizontal.black": "Սև մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.blue": "Կապույտ մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.brown": "Շականակագույն մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.cyan": "Ցիան մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.gray": "Մոխրագույն մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.green": "Կանաչ մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.light_blue": "Բաց Կապույտ մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.light_gray": "Բաց Մոխրագույն մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.lime": "Բաց Կանաչ մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.magenta": "Մորեգույն մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.orange": "Նարնջագույն մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.pink": "Վարդագույն մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.purple": "Մանուշակագույն մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.red": "Կարմիր մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.white": "Սպիտակ մեկ ճեղք",
  "block.minecraft.banner.half_horizontal.yellow": "Դեղին մեկ ճեղք",
  "block.minecraft.banner.half_horizontal_bottom.black": "Սև մեկ ճեղք շրջված ",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Կապույտ մեկ ճեղք շրջված",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Շականակագույն մեկ ճեղք շրջված",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Ցիան մեկ ճեղք շրջված",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Մոխրագույն մեկ ճեղք շրջված",
  "block.minecraft.banner.half_horizontal_bottom.green": "Կանաչ մեկ ճեղք շրջված",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Բաց Կապույտ մեկ ճեղքում Հակադարձ",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Բաց Մոխրագույն մեկ ճեղք շրջված",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Բաց Կանաչ մեկ ճեղքում Հակադարձ",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Մագնետա  մեկ ճեղքում Հակադարձ",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Նարնջագույն  մեկ ճեղքում Հակադարձ",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Վարդագույն մեկ ճեղք շրջված",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Մանուշակագույն մեկ ճեղք շրջված",
  "block.minecraft.banner.half_horizontal_bottom.red": "Կարմիր մեկ ճեղք շրջված",
  "block.minecraft.banner.half_horizontal_bottom.white": "Սպիտակ  մեկ ճեղքում Հակադարձ",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Դեղին  մեկ ճեղքում Հակադարձ",
  "block.minecraft.banner.half_vertical.black": "Սև մեկ գունատ",
  "block.minecraft.banner.half_vertical.blue": "Կապույտ մեկ գունատ",
  "block.minecraft.banner.half_vertical.brown": "Շականակագույն մեկ գունատ",
  "block.minecraft.banner.half_vertical.cyan": "Ցիան մեկ գունատ",
  "block.minecraft.banner.half_vertical.gray": "Մոխրագույն  մեկ գունատ",
  "block.minecraft.banner.half_vertical.green": "Կանաչ մեկ գունատ",
  "block.minecraft.banner.half_vertical.light_blue": "Բաց Կապույտ  մեկ գունատ",
  "block.minecraft.banner.half_vertical.light_gray": "Բաց Մոխրագույն մեկ գունատ",
  "block.minecraft.banner.half_vertical.lime": "Բաց Կանաչ  մեկ գունատ",
  "block.minecraft.banner.half_vertical.magenta": "Մորեգույն  մեկ գունատ",
  "block.minecraft.banner.half_vertical.orange": "Նարնջագույն  մեկ գունատ",
  "block.minecraft.banner.half_vertical.pink": "Վարդագույն  մեկ գունատ",
  "block.minecraft.banner.half_vertical.purple": "Մանուշակագույն մեկ գունատ",
  "block.minecraft.banner.half_vertical.red": "Կարմիր մեկ գունատ",
  "block.minecraft.banner.half_vertical.white": "Սպիտակ  մեկ գունատ",
  "block.minecraft.banner.half_vertical.yellow": "Դեղին  մեկ գունատ",
  "block.minecraft.banner.half_vertical_right.black": "Սև ձախ կես",
  "block.minecraft.banner.half_vertical_right.blue": "Կապույտ ձախ կես",
  "block.minecraft.banner.half_vertical_right.brown": "Շականակագույն ձախ կես",
  "block.minecraft.banner.half_vertical_right.cyan": "Ցիան ձախ կես",
  "block.minecraft.banner.half_vertical_right.gray": "Մոխրագույն ձախ կես",
  "block.minecraft.banner.half_vertical_right.green": "Կանաչ ձախ կես",
  "block.minecraft.banner.half_vertical_right.light_blue": "Բաց Կապույտ մեկ գունատ փոխարկված",
  "block.minecraft.banner.half_vertical_right.light_gray": "Բաց Մոխրագույն մեկ գունատ փոխարկված",
  "block.minecraft.banner.half_vertical_right.lime": "Բաց Կանաչ մեկ գունատ փոխարկված",
  "block.minecraft.banner.half_vertical_right.magenta": "Մորեգույն մեկ գունատ փոխարկված",
  "block.minecraft.banner.half_vertical_right.orange": "Նարնջագույն մեկ գունատ փոխարկված",
  "block.minecraft.banner.half_vertical_right.pink": "Վարդագույն մեկ գունատ փոխարկված",
  "block.minecraft.banner.half_vertical_right.purple": "Մանուշակագույն մեկ գունատ փոխարկված",
  "block.minecraft.banner.half_vertical_right.red": "Կարմիր մեկ գունատ փոխարկված",
  "block.minecraft.banner.half_vertical_right.white": "Սպիտակ մեկ գունատ փոխարկված",
  "block.minecraft.banner.half_vertical_right.yellow": "Դեղին մեկ գունատ փոխարկված",
  "block.minecraft.banner.mojang.black": "Սև բան",
  "block.minecraft.banner.mojang.blue": "Կապույտ բան",
  "block.minecraft.banner.mojang.brown": "Շականակագույն բան",
  "block.minecraft.banner.mojang.cyan": "Փիրուզագույն բան",
  "block.minecraft.banner.mojang.gray": "Մոխրագույն բան",
  "block.minecraft.banner.mojang.green": "Կանաչ բան",
  "block.minecraft.banner.mojang.light_blue": "Բաց կապույտ բան",
  "block.minecraft.banner.mojang.light_gray": "Բաց մոխրագույն բան",
  "block.minecraft.banner.mojang.lime": "Բաց կանաչ բան",
  "block.minecraft.banner.mojang.magenta": "Մորեգույն բան",
  "block.minecraft.banner.mojang.orange": "Նարնջագույն բան",
  "block.minecraft.banner.mojang.pink": "Վարդագույն բան",
  "block.minecraft.banner.mojang.purple": "Մանուշակագույն բան",
  "block.minecraft.banner.mojang.red": "Կարմիր բան",
  "block.minecraft.banner.mojang.white": "Սպիտակ բան",
  "block.minecraft.banner.mojang.yellow": "Դեղին բան",
  "block.minecraft.banner.piglin.black": "Սև կնճիթ",
  "block.minecraft.banner.piglin.blue": "Կապույտ Դունչ",
  "block.minecraft.banner.piglin.brown": "Շագանակագույն Դունչ",
  "block.minecraft.banner.piglin.cyan": "Կապտականաչ Դունչ",
  "block.minecraft.banner.piglin.gray": "Մոխրագույն Դունչ",
  "block.minecraft.banner.piglin.green": "Կանաչ Դունչ",
  "block.minecraft.banner.piglin.light_blue": "Բաց կապույտ դունչ",
  "block.minecraft.banner.piglin.light_gray": "Բաց Մոխրագույն Դունչ",
  "block.minecraft.banner.piglin.lime": "Կրաքարի խորտիկ",
  "block.minecraft.banner.piglin.magenta": "Մանուշակագույն դեմք",
  "block.minecraft.banner.piglin.orange": "Նարնջագույն դունչ",
  "block.minecraft.banner.piglin.pink": "Վարդագույն Դունչ",
  "block.minecraft.banner.piglin.purple": "Մանուշակագույն Դունչ",
  "block.minecraft.banner.piglin.red": "Կարմիր Դունչ",
  "block.minecraft.banner.piglin.white": "Սպիտակ դունչ",
  "block.minecraft.banner.piglin.yellow": "Դեղին խորտակ",
  "block.minecraft.banner.rhombus.black": "Սև լոզենջ",
  "block.minecraft.banner.rhombus.blue": "Կապույտ լոզենջ",
  "block.minecraft.banner.rhombus.brown": "Շականակագույն լոզենջ",
  "block.minecraft.banner.rhombus.cyan": "Ցիան լոզենջ",
  "block.minecraft.banner.rhombus.gray": "Մոխրագույն լոզենջ",
  "block.minecraft.banner.rhombus.green": "Կանաչ լոզենջ",
  "block.minecraft.banner.rhombus.light_blue": "Բաց կապույտ լոզենջ",
  "block.minecraft.banner.rhombus.light_gray": "Բաց Մոխրագույն լոզենջ",
  "block.minecraft.banner.rhombus.lime": "Բաց Կանաչ լոզենջ",
  "block.minecraft.banner.rhombus.magenta": "Մագնետա լոզենջ",
  "block.minecraft.banner.rhombus.orange": "Նարնջագույն լոզենջ",
  "block.minecraft.banner.rhombus.pink": "Վարդագույն լոզենջ",
  "block.minecraft.banner.rhombus.purple": "Մանուշակագույն լոզենջ",
  "block.minecraft.banner.rhombus.red": "Կարմիր լոզենջ",
  "block.minecraft.banner.rhombus.white": "Սպիտակ լոզենջ",
  "block.minecraft.banner.rhombus.yellow": "Դեղին լոզենջ",
  "block.minecraft.banner.skull.black": "Սև գանգի լիցքավորում",
  "block.minecraft.banner.skull.blue": "Կապույտ գանգի լիցքավորում",
  "block.minecraft.banner.skull.brown": "Շականակագույն գանգի լիցքավորում",
  "block.minecraft.banner.skull.cyan": "Ցիան գանգի լիցքավորում",
  "block.minecraft.banner.skull.gray": "Մոխրագույն գանգի լիցքավորում",
  "block.minecraft.banner.skull.green": "Կանաչ գանգի լիցքավորում",
  "block.minecraft.banner.skull.light_blue": "Բաց Կապույտ գանգի լիցքավորում",
  "block.minecraft.banner.skull.light_gray": "Բաց Մոխրագույն գանգի լիցքավորում",
  "block.minecraft.banner.skull.lime": "Բաց Կանաչ գանգի լիցքավորում",
  "block.minecraft.banner.skull.magenta": "Մորեգույն գանգի լիցքավորում",
  "block.minecraft.banner.skull.orange": "Նարնջագույն գանգի լիցքավորում",
  "block.minecraft.banner.skull.pink": "Վարդագույն գանգի լիցքավորում",
  "block.minecraft.banner.skull.purple": "Մանուշակագույն գանգի լիցքավորում",
  "block.minecraft.banner.skull.red": "Կարմիր գանգի լիցքավորում",
  "block.minecraft.banner.skull.white": "Սպիտակ գանգի լիցքավորում",
  "block.minecraft.banner.skull.yellow": "Դեղին գանգի լիցքավորում",
  "block.minecraft.banner.small_stripes.black": "Սև սյուն",
  "block.minecraft.banner.small_stripes.blue": "Կապույտ սյուն",
  "block.minecraft.banner.small_stripes.brown": "Շագանակագույն սյուն",
  "block.minecraft.banner.small_stripes.cyan": "Փիրուզագույն սյուն",
  "block.minecraft.banner.small_stripes.gray": "Մոխրագույն սյուն",
  "block.minecraft.banner.small_stripes.green": "Կանաչ սյուն",
  "block.minecraft.banner.small_stripes.light_blue": "Բաց կապույտ սյուն",
  "block.minecraft.banner.small_stripes.light_gray": "Բաց մոխրագույն սյուն",
  "block.minecraft.banner.small_stripes.lime": "Բաց կանաչ սյուն",
  "block.minecraft.banner.small_stripes.magenta": "Մորեգույն սյուններ",
  "block.minecraft.banner.small_stripes.orange": "Նարնջագույն սյուն",
  "block.minecraft.banner.small_stripes.pink": "Վարդագույն սյուն",
  "block.minecraft.banner.small_stripes.purple": "Մանուշակագույն սյուն",
  "block.minecraft.banner.small_stripes.red": "Կարմիր սյուն",
  "block.minecraft.banner.small_stripes.white": "Սպիտակ Սյուն",
  "block.minecraft.banner.small_stripes.yellow": "Դեղին սյուն",
  "block.minecraft.banner.square_bottom_left.black": "Տակի սեւ աջակողմյա անկյուն",
  "block.minecraft.banner.square_bottom_left.blue": "Տակի կապույտ աջակողմյա անկյուն",
  "block.minecraft.banner.square_bottom_left.brown": "Տակի շագանակագույն աջակողմյա անկյուն",
  "block.minecraft.banner.square_bottom_left.cyan": "Ստորին աջ՝ փիրուզագույն քառորդ ",
  "block.minecraft.banner.square_bottom_left.gray": "Ստորին աջ՝ մոխրագույն քառորդ",
  "block.minecraft.banner.square_bottom_left.green": "Տակի կանաչ աջակողմյա անկյուն",
  "block.minecraft.banner.square_bottom_left.light_blue": "Ստորին աջ՝ բաց կապույտ քառորդ",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ստորին աջ՝ բաց մոխրագույն քառորդ",
  "block.minecraft.banner.square_bottom_left.lime": "Ստորին աջ՝ լայմ քառորդ",
  "block.minecraft.banner.square_bottom_left.magenta": "Տակի մորեգույն աջակողմյա անկյուն",
  "block.minecraft.banner.square_bottom_left.orange": "Ստորին աջ՝ նարինջ քառորդ ",
  "block.minecraft.banner.square_bottom_left.pink": "Ստորին աջ՝ վարդագույն քառորդ",
  "block.minecraft.banner.square_bottom_left.purple": "Տակի մանուշակագույն աջակողմյա անկյուն",
  "block.minecraft.banner.square_bottom_left.red": "Տակի կարմիր աջակողմյա անկյուն",
  "block.minecraft.banner.square_bottom_left.white": "Ստորին աջ՝ սպիտակ քառորդ ",
  "block.minecraft.banner.square_bottom_left.yellow": "Ստորին աջ՝ դեղին քառորդ",
  "block.minecraft.banner.square_bottom_right.black": "Ստորին ձախ՝ սեւ քառորդ ",
  "block.minecraft.banner.square_bottom_right.blue": "Ստորին ձախ՝ կապույտ քառորդ",
  "block.minecraft.banner.square_bottom_right.brown": "Ստորին ձախ՝ շականակագույն քառորդ",
  "block.minecraft.banner.square_bottom_right.cyan": "Ստորին ձախ՝ փիրուզագույն քառորդ",
  "block.minecraft.banner.square_bottom_right.gray": "Ստորին ձախ՝ մոխրագույն քառորդ",
  "block.minecraft.banner.square_bottom_right.green": "Ստորին ձախ՝ կանաչ քառորդ",
  "block.minecraft.banner.square_bottom_right.light_blue": "Ստորին ձախ՝ բաց կապույտ քառորդ",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ստորին ձախ՝ բաց մոխրագույն քառորդ",
  "block.minecraft.banner.square_bottom_right.lime": "Ստորին ձախ՝ լայմ քառորդ",
  "block.minecraft.banner.square_bottom_right.magenta": "Ստորին ձախ՝ մորեգույն քառորդ",
  "block.minecraft.banner.square_bottom_right.orange": "Ստորին ձախ՝ նարնջագույն քառորդ",
  "block.minecraft.banner.square_bottom_right.pink": "Ստորին ձախ՝ վարդագույն քառորդ",
  "block.minecraft.banner.square_bottom_right.purple": "Ստորին ձախ՝ մանուշակագույն քառորդ",
  "block.minecraft.banner.square_bottom_right.red": "Ստորին ձախ՝ կարմիր քառորդ ",
  "block.minecraft.banner.square_bottom_right.white": "Ստորին ձախ՝ սպիտակ քառորդ",
  "block.minecraft.banner.square_bottom_right.yellow": "Ստորին ձախ՝ դեղին քառորդ",
  "block.minecraft.banner.square_top_left.black": "Վերին աջ՝ սեւ քառորդ",
  "block.minecraft.banner.square_top_left.blue": "Վերին աջ՝ կապույտ քառորդ",
  "block.minecraft.banner.square_top_left.brown": "Վերին աջ՝ շագանակագույն քառորդ",
  "block.minecraft.banner.square_top_left.cyan": "Վերին աջ՝ փիրուզագույն քառորդ",
  "block.minecraft.banner.square_top_left.gray": "Վերին աջ՝ մոխրագույն քառորդ",
  "block.minecraft.banner.square_top_left.green": "Վերին աջ՝ կանաչ քառորդ",
  "block.minecraft.banner.square_top_left.light_blue": "Վերին աջ՝ բաց կապույտ քառորդ",
  "block.minecraft.banner.square_top_left.light_gray": "Վերին աջ՝ բաց մոխրագույն քառորդ",
  "block.minecraft.banner.square_top_left.lime": "Վերին աջ՝ լայմ քառորդ",
  "block.minecraft.banner.square_top_left.magenta": "Վերին աջ՝ մորեգույն քառորդ",
  "block.minecraft.banner.square_top_left.orange": "Վերին աջ՝ նարնջագույն քառորդ",
  "block.minecraft.banner.square_top_left.pink": "Վերին աջ՝ վարդագույն քառորդ",
  "block.minecraft.banner.square_top_left.purple": "Վերին աջ՝ մանուշակագույն քառորդ",
  "block.minecraft.banner.square_top_left.red": "Վերին աջ՝ կարմիր քառորդ",
  "block.minecraft.banner.square_top_left.white": "Վերին աջ՝ սպիտակ քառորդ",
  "block.minecraft.banner.square_top_left.yellow": "Վերին աջ՝ դեղին քառորդ",
  "block.minecraft.banner.square_top_right.black": "Վերևի ձախ սև խաչ",
  "block.minecraft.banner.square_top_right.blue": "Վերևի ձախ կապույտ խաչ",
  "block.minecraft.banner.square_top_right.brown": "Վերևի ձախ դարչնագույն խաչ",
  "block.minecraft.banner.square_top_right.cyan": "Վերևի ձախ փիրուզագույն խաչ",
  "block.minecraft.banner.square_top_right.gray": "Վերևի ձախ մոխրագույն խաչ",
  "block.minecraft.banner.square_top_right.green": "Վերևի ձախ կանաչ խաչ",
  "block.minecraft.banner.square_top_right.light_blue": "Վերևի ձախ բաց կապույտ խաչ",
  "block.minecraft.banner.square_top_right.light_gray": "Վերևի ձախ բաց մոխրագույն խաչ",
  "block.minecraft.banner.square_top_right.lime": "Վերևի ձախ բաց կանաչ խաչ",
  "block.minecraft.banner.square_top_right.magenta": "Վերևի ձախ մորեգույն խաչ",
  "block.minecraft.banner.square_top_right.orange": "Վերևի ձախ նարնջագույն խաչ",
  "block.minecraft.banner.square_top_right.pink": "Վերևի ձախ վարդագույն խաչ",
  "block.minecraft.banner.square_top_right.purple": "Վերևի ձախ մանուշակագույն խաչ",
  "block.minecraft.banner.square_top_right.red": "Վերևի ձախ կարմիր խաչ",
  "block.minecraft.banner.square_top_right.white": "Վերևի ձախ սպիտակ խաչ",
  "block.minecraft.banner.square_top_right.yellow": "Վերևի ձախ դեղին խաչ",
  "block.minecraft.banner.straight_cross.black": "Սև խաչ",
  "block.minecraft.banner.straight_cross.blue": "Կապույտ խաչ",
  "block.minecraft.banner.straight_cross.brown": "Դարչագույն խաչ",
  "block.minecraft.banner.straight_cross.cyan": "Փիրուզագույն խաչ",
  "block.minecraft.banner.straight_cross.gray": "Մոխրագույն խաչ",
  "block.minecraft.banner.straight_cross.green": "Կանաչ խաչ",
  "block.minecraft.banner.straight_cross.light_blue": "Բաց կապույտ խաչ",
  "block.minecraft.banner.straight_cross.light_gray": "Բաց մոխրագույն խաչ",
  "block.minecraft.banner.straight_cross.lime": "Բաց կանաչ խաչ",
  "block.minecraft.banner.straight_cross.magenta": "Մորեգույն խաչ",
  "block.minecraft.banner.straight_cross.orange": "Նարնջագույն խաչ",
  "block.minecraft.banner.straight_cross.pink": "Վարդագույն խաչ",
  "block.minecraft.banner.straight_cross.purple": "Մանուշակագույն խաչ",
  "block.minecraft.banner.straight_cross.red": "Կարմիր խաչ",
  "block.minecraft.banner.straight_cross.white": "Սպիտակ խաչ",
  "block.minecraft.banner.straight_cross.yellow": "Դեղին խաչ ",
  "block.minecraft.banner.stripe_bottom.black": "Սև հիմք",
  "block.minecraft.banner.stripe_bottom.blue": "Կապույտ հիմք",
  "block.minecraft.banner.stripe_bottom.brown": "Շագանակագույն հիմք",
  "block.minecraft.banner.stripe_bottom.cyan": "Փիրուզագույն հիմք",
  "block.minecraft.banner.stripe_bottom.gray": "Մոխրագույն հիմք",
  "block.minecraft.banner.stripe_bottom.green": "Կանաչ հիմք",
  "block.minecraft.banner.stripe_bottom.light_blue": "Բաց կապույտ հիմք",
  "block.minecraft.banner.stripe_bottom.light_gray": "Բաց մոխրագույն հիմք",
  "block.minecraft.banner.stripe_bottom.lime": "Լայմ հիմք",
  "block.minecraft.banner.stripe_bottom.magenta": "Մորեգույն հիմք",
  "block.minecraft.banner.stripe_bottom.orange": "Նարնջագույն հիմք",
  "block.minecraft.banner.stripe_bottom.pink": "Վարդագույն հիմք",
  "block.minecraft.banner.stripe_bottom.purple": "Մանուշակագույն հիմք",
  "block.minecraft.banner.stripe_bottom.red": "Կարմիր հիմք",
  "block.minecraft.banner.stripe_bottom.white": "Սպիտակ հիմք",
  "block.minecraft.banner.stripe_bottom.yellow": "Դեղին հիմք",
  "block.minecraft.banner.stripe_center.black": "Սև սյուն",
  "block.minecraft.banner.stripe_center.blue": "Կապույտ սյուն",
  "block.minecraft.banner.stripe_center.brown": "Դարչնագույն սյուն",
  "block.minecraft.banner.stripe_center.cyan": "Փիրուզագույն սյուն",
  "block.minecraft.banner.stripe_center.gray": "Մոխրագույն սյուն",
  "block.minecraft.banner.stripe_center.green": "Կանաչ սյուն",
  "block.minecraft.banner.stripe_center.light_blue": "Բաց կապույտ սյուն",
  "block.minecraft.banner.stripe_center.light_gray": "Բաց մոխրագույն սյուն",
  "block.minecraft.banner.stripe_center.lime": "Բաց կանաչ սյուն",
  "block.minecraft.banner.stripe_center.magenta": "Մորեգույն սյուն",
  "block.minecraft.banner.stripe_center.orange": "Նարնջագույն սյուն",
  "block.minecraft.banner.stripe_center.pink": "Վարդագույն սյուն",
  "block.minecraft.banner.stripe_center.purple": "Մանուշակագույն սյուն",
  "block.minecraft.banner.stripe_center.red": "Կարմիր սյուն",
  "block.minecraft.banner.stripe_center.white": "Սպիտակ սյուն",
  "block.minecraft.banner.stripe_center.yellow": "Դեղին սյուն",
  "block.minecraft.banner.stripe_downleft.black": "Սև ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.blue": "Կապույտ ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.brown": "Դարչնագույն ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.cyan": "Փիրուզագույն ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.gray": "Մոխրագույն ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.green": "Կանաչ ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.light_blue": "Բաց կապույտ ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.light_gray": "Բաց մոխրագույն ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.lime": "Լայմ ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.magenta": "Մորեգույն ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.orange": "Նարնջագույն ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.pink": "Վարդագույն ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.purple": "Մանուշակագույն ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.red": "Կարմիր ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.white": "Սպիտակ ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downleft.yellow": "Դեղին ձախակողմյա կապ",
  "block.minecraft.banner.stripe_downright.black": "Սեւ կապ",
  "block.minecraft.banner.stripe_downright.blue": "Կապույտ կապ",
  "block.minecraft.banner.stripe_downright.brown": "Շագանակագույն կապ",
  "block.minecraft.banner.stripe_downright.cyan": "Փիրուզագույն կապ",
  "block.minecraft.banner.stripe_downright.gray": "Մոխրագույն կապ",
  "block.minecraft.banner.stripe_downright.green": "Կանաչ կապ",
  "block.minecraft.banner.stripe_downright.light_blue": "Բաց կապույտ կապ",
  "block.minecraft.banner.stripe_downright.light_gray": "Բաց մոխրագույն կապ",
  "block.minecraft.banner.stripe_downright.lime": "\nԼայմ կապ",
  "block.minecraft.banner.stripe_downright.magenta": "Մորեգույն կապ",
  "block.minecraft.banner.stripe_downright.orange": "Նարնջագույն կապ",
  "block.minecraft.banner.stripe_downright.pink": "Վարդագուն կապ",
  "block.minecraft.banner.stripe_downright.purple": "Մանուշակագույն կապ",
  "block.minecraft.banner.stripe_downright.red": "Կարմիր կապ",
  "block.minecraft.banner.stripe_downright.white": "Սպիտակ կապ",
  "block.minecraft.banner.stripe_downright.yellow": "Դեղին կապ",
  "block.minecraft.banner.stripe_left.black": "Սև աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.blue": "Կապույտ աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.brown": "Շագանակագույն աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.cyan": "Փիրուզագույն աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.gray": "Մոխրագույն աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.green": "Կանաչ աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.light_blue": "Բաց կապույտ աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.light_gray": "Բաց մոխրագույն աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.lime": "Լայմ աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.magenta": "Մորեգույն աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.orange": "Նարնջագույն աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.pink": "Վարդագույն աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.purple": "Մանուշակագույն աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.red": "Կարմիր աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.white": "Սպիտակ աջակողմյա սյուն",
  "block.minecraft.banner.stripe_left.yellow": "Դեղին աջակողմյա սյուն",
  "block.minecraft.banner.stripe_middle.black": "Սև գոտի",
  "block.minecraft.banner.stripe_middle.blue": "Կապույտ գոտի",
  "block.minecraft.banner.stripe_middle.brown": "Շագանակագույն գոտի",
  "block.minecraft.banner.stripe_middle.cyan": "Փիրուզագույն գոտի",
  "block.minecraft.banner.stripe_middle.gray": "Մոխրագույն գոտի",
  "block.minecraft.banner.stripe_middle.green": "Կանաչ գոտի",
  "block.minecraft.banner.stripe_middle.light_blue": "Բաց կապույտ գոտի",
  "block.minecraft.banner.stripe_middle.light_gray": "Բաց մոխրագույն գոտի",
  "block.minecraft.banner.stripe_middle.lime": "Լայմ գոտի",
  "block.minecraft.banner.stripe_middle.magenta": "Մորեգույն գոտի",
  "block.minecraft.banner.stripe_middle.orange": "Նարնջագույն գոտի",
  "block.minecraft.banner.stripe_middle.pink": "Վարդագույն գոտի",
  "block.minecraft.banner.stripe_middle.purple": "Մանուշակագույն գոտի",
  "block.minecraft.banner.stripe_middle.red": "Կարմիր գոտի",
  "block.minecraft.banner.stripe_middle.white": "Սպիտակ գոտի",
  "block.minecraft.banner.stripe_middle.yellow": "Դեղին գոտի",
  "block.minecraft.banner.stripe_right.black": "Սև ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.blue": "Կապույտ ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.brown": "Շագանակագույն ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.cyan": "Փիրուզագույն ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.gray": "Մոխրագույն ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.green": "Կանաչ ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.light_blue": "Բաց կապույտ ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.light_gray": "Բաց մոխրագույն ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.lime": "Լայմ ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.magenta": "Մորեգույն ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.orange": "Նարնջագույն ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.pink": "Վարդագույն ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.purple": "Մանուշակագույն ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.red": "Կարմիր ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.white": "Սպիտակ ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_right.yellow": "Դեղին ձախակողմյա սյուն",
  "block.minecraft.banner.stripe_top.black": "Սև գլուխ",
  "block.minecraft.banner.stripe_top.blue": "Կապույտ գլուխ",
  "block.minecraft.banner.stripe_top.brown": "Դարչնագույն գլուխ",
  "block.minecraft.banner.stripe_top.cyan": "Փիրուզագույն գլուխ",
  "block.minecraft.banner.stripe_top.gray": "Մոխրագույն գլուխ",
  "block.minecraft.banner.stripe_top.green": "Կանաչ գլուխ",
  "block.minecraft.banner.stripe_top.light_blue": "Բաց կապույտ գլուխ",
  "block.minecraft.banner.stripe_top.light_gray": "Բաց մոխրագույն գլուխ",
  "block.minecraft.banner.stripe_top.lime": "Բաց կանաչ գլուխ",
  "block.minecraft.banner.stripe_top.magenta": "Մորեգույն գլուխ",
  "block.minecraft.banner.stripe_top.orange": "Նարնջագույն գլուխ",
  "block.minecraft.banner.stripe_top.pink": "Վարդագույն գլուխ",
  "block.minecraft.banner.stripe_top.purple": "Մանուշակագույն գլուխ",
  "block.minecraft.banner.stripe_top.red": "Կարմիր գլուխ",
  "block.minecraft.banner.stripe_top.white": "Սպիտակ գլուխ",
  "block.minecraft.banner.stripe_top.yellow": "Դեղին գլուխ",
  "block.minecraft.banner.triangle_bottom.black": "Սև շևրոն",
  "block.minecraft.banner.triangle_bottom.blue": "Կապույտ ծպեղ",
  "block.minecraft.banner.triangle_bottom.brown": "Շականակագույն ծպեղ",
  "block.minecraft.banner.triangle_bottom.cyan": "Փիրուզագույն ծպեղ",
  "block.minecraft.banner.triangle_bottom.gray": "Մոխրագույն ծպեղ",
  "block.minecraft.banner.triangle_bottom.green": "Կանաչ ծպեղ",
  "block.minecraft.banner.triangle_bottom.light_blue": "Բաց կապույտ ծպեղ",
  "block.minecraft.banner.triangle_bottom.light_gray": "Բաց մոխրագույն ծպեղ",
  "block.minecraft.banner.triangle_bottom.lime": "Լայմ ծպեղ",
  "block.minecraft.banner.triangle_bottom.magenta": "Մորեգույն ծպեղ",
  "block.minecraft.banner.triangle_bottom.orange": "Նարնջագույն ծպեղ",
  "block.minecraft.banner.triangle_bottom.pink": "Վարդագույն ծպեղ",
  "block.minecraft.banner.triangle_bottom.purple": "Մանուշակագույն ծպեղ",
  "block.minecraft.banner.triangle_bottom.red": "Կարմիր Շևրոն",
  "block.minecraft.banner.triangle_bottom.white": "Սպիտակ ծպեղ",
  "block.minecraft.banner.triangle_bottom.yellow": "Դեղին ծպեղ",
  "block.minecraft.banner.triangle_top.black": "Սև շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.blue": "Կապույտ շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.brown": "Շականակագույն շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.cyan": "Փիրուզագույն շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.gray": "Մոխրագույն շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.green": "Կանաչ շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.light_blue": "Բաց կապույտ շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.light_gray": "Բաց մոխրագույն շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.lime": "Լայմ շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.magenta": "Մորեգույն շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.orange": "Նարնջագույն շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.pink": "Վարդագույն շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.purple": "Մանուշակագույն շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.red": "Կարմիր շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.white": "Սպիտակ շրջված ծպեղ",
  "block.minecraft.banner.triangle_top.yellow": "Դեղին շրջված ծպեղ",
  "block.minecraft.banner.triangles_bottom.black": "Սև հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.blue": "Կապույտ հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.brown": "Շականակագույն հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.cyan": "Ցիան հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.gray": "Մոխրագույն հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.green": "Կանաչ հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.light_blue": "Բաց Կապույտ հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.light_gray": "Բաց Սեռի հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.lime": "Բաց Կանաչ հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.magenta": "Մագնետա հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.orange": "Նարնջագույն հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.pink": "Վարդագույն հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.purple": "Մանուշակագույն հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.red": "Կարմիր հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.white": "Սպիտակ հիմքը շեղված",
  "block.minecraft.banner.triangles_bottom.yellow": "Դեղին հիմքը շեղված",
  "block.minecraft.banner.triangles_top.black": "Սև ղեկավար",
  "block.minecraft.banner.triangles_top.blue": "Կապույտ Ղեկավար",
  "block.minecraft.banner.triangles_top.brown": "Շականակագույն Ղեկավար",
  "block.minecraft.banner.triangles_top.cyan": "Ցիան Ղեկավար",
  "block.minecraft.banner.triangles_top.gray": "Մոխրագույն Ղեկավար",
  "block.minecraft.banner.triangles_top.green": "Կանաչ Ղեկավար",
  "block.minecraft.banner.triangles_top.light_blue": "Բաց Կապույտ Ղեկավար",
  "block.minecraft.banner.triangles_top.light_gray": "Բաց Մոխրագույն Ղեկավար",
  "block.minecraft.banner.triangles_top.lime": "Բաց Կանաչ Ղեկավար",
  "block.minecraft.banner.triangles_top.magenta": "Մագնետա Ղեկավար",
  "block.minecraft.banner.triangles_top.orange": "Նարնջագույն Ղեկավար",
  "block.minecraft.banner.triangles_top.pink": "Վարդագույն Ղեկավար",
  "block.minecraft.banner.triangles_top.purple": " Մանուշակագույն Ղեկավար",
  "block.minecraft.banner.triangles_top.red": "Կարմիր Ղեկավար",
  "block.minecraft.banner.triangles_top.white": "Սպիտակ Ղեկավար",
  "block.minecraft.banner.triangles_top.yellow": "Դեղին Ղեկավար",
  "block.minecraft.barrel": "Տակառ",
  "block.minecraft.barrier": "Խոչընդոտ",
  "block.minecraft.basalt": "Բազալտ",
  "block.minecraft.beacon": "Փարոս",
  "block.minecraft.beacon.primary": "Առաջնային Հզորություն",
  "block.minecraft.beacon.secondary": "Երկրորդական Հզորություն",
  "block.minecraft.bed.no_sleep": "Դուք կարող եք քնել միայն գիշերը կամ ամպրոպի ժամանակ։",
  "block.minecraft.bed.not_safe": "Դուք գուցե հիմա հանգստանաք. մոտակայքում կան հրեշներ",
  "block.minecraft.bed.obstructed": "մահճակալ",
  "block.minecraft.bed.occupied": "Այս մահճակալը զբաղված է",
  "block.minecraft.bed.too_far_away": "Դուք գուցե հիմա հանգստանաք, մահճակալը շատ հեռու է",
  "block.minecraft.bedrock": "Բեդրոկ",
  "block.minecraft.bee_nest": "Մեղվի բույն",
  "block.minecraft.beehive": "Մեղվաբույն",
  "block.minecraft.beetroots": "Բողկեր",
  "block.minecraft.bell": "Զանգ",
  "block.minecraft.big_dripleaf": "Մեծ կաթլատերեւ",
  "block.minecraft.big_dripleaf_stem": "Մեծ կաթլատերեւի ցողուն",
  "block.minecraft.birch_button": "Կեչու փայտից կոճակ",
  "block.minecraft.birch_door": "Կեչու դուռ",
  "block.minecraft.birch_fence": "Կեչու ցանկապատ",
  "block.minecraft.birch_fence_gate": "Կեչու փայտից ցանկապատի դարպաս",
  "block.minecraft.birch_hanging_sign": "Կեչուց կախովի ցուցանակ",
  "block.minecraft.birch_leaves": "Կեչու տերեւներ",
  "block.minecraft.birch_log": "Կեչու գերան",
  "block.minecraft.birch_planks": "Կեչու տախտակներ",
  "block.minecraft.birch_pressure_plate": "Կեչու փայտից ճնշաթիթեղ",
  "block.minecraft.birch_sapling": "Կեչու տնկի",
  "block.minecraft.birch_shelf": "Կեչուց դարակ",
  "block.minecraft.birch_sign": "Կեչու ցուցանակ",
  "block.minecraft.birch_slab": "Կեչու սալիկ",
  "block.minecraft.birch_stairs": "Կեչու աստիճաններ",
  "block.minecraft.birch_trapdoor": "Կեչու փայտից ծուղակե դռնակ",
  "block.minecraft.birch_wall_hanging_sign": "Կեչուց պատից կախովի ցուցանակ",
  "block.minecraft.birch_wall_sign": "Կեչուց պատի ցուցանակ",
  "block.minecraft.birch_wood": "Կեչու փայտ",
  "block.minecraft.black_banner": "Սև դրոշակ",
  "block.minecraft.black_bed": "Սեւ մահճակալ",
  "block.minecraft.black_candle": "Սեւ մոմ",
  "block.minecraft.black_candle_cake": "Թխվածք Սեւ Մոմով",
  "block.minecraft.black_carpet": "Սև Գորգ",
  "block.minecraft.black_concrete": "Սև բետոն",
  "block.minecraft.black_concrete_powder": "Սեւ փոշի բետոն",
  "block.minecraft.black_glazed_terracotta": "Սև Թռծած Տեռակոտա",
  "block.minecraft.black_shulker_box": "Սև Շալքերի Տուփ",
  "block.minecraft.black_stained_glass": "Սև ապակի",
  "block.minecraft.black_stained_glass_pane": "Սեւ ապակու շերտ",
  "block.minecraft.black_terracotta": "Սև Տեռակոտա",
  "block.minecraft.black_wool": "Սև բուրդ",
  "block.minecraft.blackstone": "Սեւքար",
  "block.minecraft.blackstone_slab": "Սեւքարե Սալիկ",
  "block.minecraft.blackstone_stairs": "Սևքարե աստիճաններ",
  "block.minecraft.blackstone_wall": "Սևքարե պատ",
  "block.minecraft.blast_furnace": "Հալման վառարան",
  "block.minecraft.blue_banner": "Կապույտ դրոշակ",
  "block.minecraft.blue_bed": "Կապույտ մահճակալ",
  "block.minecraft.blue_candle": "Կապույտ մոմ",
  "block.minecraft.blue_candle_cake": "Թխվածք Կապույտ Մոմով",
  "block.minecraft.blue_carpet": "Կապույտ Գորգ",
  "block.minecraft.blue_concrete": "Կապույտ բետոն",
  "block.minecraft.blue_concrete_powder": "Կապույտ փոշի բետոն",
  "block.minecraft.blue_glazed_terracotta": "Կապույտ Թրծած Տեռակոտա",
  "block.minecraft.blue_ice": "Կապույտ սառույց",
  "block.minecraft.blue_orchid": "Կապույտ օրխիդեա",
  "block.minecraft.blue_shulker_box": "Կապույտ Շալքերի Տուփ",
  "block.minecraft.blue_stained_glass": "Կապույտ ապակի",
  "block.minecraft.blue_stained_glass_pane": "Կապույտ ապակու պատուհան",
  "block.minecraft.blue_terracotta": "Կապույտ Տեռակոտա",
  "block.minecraft.blue_wool": "Կապույտ բուրդ",
  "block.minecraft.bone_block": "Ոսկրային բլոկ",
  "block.minecraft.bookshelf": "Գրադարակ",
  "block.minecraft.brain_coral": "Ուղեղային մարջան",
  "block.minecraft.brain_coral_block": "Ուղեղային մարջանի բլոկ",
  "block.minecraft.brain_coral_fan": "Հովհարային ուղեղային մարջան",
  "block.minecraft.brain_coral_wall_fan": "Պատի հովհարային ուղեղային մարջան",
  "block.minecraft.brewing_stand": "Թուրմի կայանք",
  "block.minecraft.brick_slab": "Աղյուսի Սալիկ",
  "block.minecraft.brick_stairs": "Աղյուսե Աստիճաններ",
  "block.minecraft.brick_wall": "Աղյուսե պատ",
  "block.minecraft.bricks": "Աղյուսներ",
  "block.minecraft.brown_banner": "Դառչագույն դրոշակ",
  "block.minecraft.brown_bed": "Շագանակագույն մահճակալ",
  "block.minecraft.brown_candle": "Դարչնագույն մոմ",
  "block.minecraft.brown_candle_cake": "Թխվածք Շականակագույն Մոմով",
  "block.minecraft.brown_carpet": "Դարչնագույն Գորգ",
  "block.minecraft.brown_concrete": "Դարչնագույն բետոն",
  "block.minecraft.brown_concrete_powder": "Շագանակագույն փոշի բետոն",
  "block.minecraft.brown_glazed_terracotta": "Դարչնագույն Թրծած Տեռակոտա",
  "block.minecraft.brown_mushroom": "Շագանակագույն Ճանճասպան",
  "block.minecraft.brown_mushroom_block": "Դարչնագույն Սնկի բլոկ",
  "block.minecraft.brown_shulker_box": "Դարչնագույն Շալքերի Տուփ",
  "block.minecraft.brown_stained_glass": "Դարչնագույն ապակի",
  "block.minecraft.brown_stained_glass_pane": "Դարչնագույն ապակու պատուհան",
  "block.minecraft.brown_terracotta": "Շագանակագույն Տեռակոտա",
  "block.minecraft.brown_wool": "Դարչնագույն բուրդ",
  "block.minecraft.bubble_column": "Պղպջակների սյուն",
  "block.minecraft.bubble_coral": "Պղպջակային մարջան",
  "block.minecraft.bubble_coral_block": "Պղպջակային մարջանի բլոկ",
  "block.minecraft.bubble_coral_fan": "Հովհարային պղպջակավոր մարջան",
  "block.minecraft.bubble_coral_wall_fan": "Պատի հովհարային պղպջակավոր մարջան",
  "block.minecraft.budding_amethyst": "Պտղավետ մեղեսիկ",
  "block.minecraft.bush": "Թուփ",
  "block.minecraft.cactus": "Կակտուս",
  "block.minecraft.cactus_flower": "Կակտուսի ծաղիկ",
  "block.minecraft.cake": "Թխվածք",
  "block.minecraft.calcite": "Կալցիտ",
  "block.minecraft.calibrated_sculk_sensor": "Կալիբրացված Սկուլկ սենսոր",
  "block.minecraft.campfire": "Խարույկ",
  "block.minecraft.candle": "Մոմ",
  "block.minecraft.candle_cake": "Մոմով թխվածք",
  "block.minecraft.carrots": "Գազար",
  "block.minecraft.cartography_table": "Քարտեզագրի Սեղան",
  "block.minecraft.carved_pumpkin": "Փորագրված դդում",
  "block.minecraft.cauldron": "Կաթսա",
  "block.minecraft.cave_air": "Քարանձավի օդ",
  "block.minecraft.cave_vines": "Քարանձավային պատատուկներ",
  "block.minecraft.cave_vines_plant": "Քարանձավային որթատունկ",
  "block.minecraft.chain": "Շղթա",
  "block.minecraft.chain_command_block": "Շղթայած Հրամանների բլոկ",
  "block.minecraft.cherry_button": "Բալենու կոճակ",
  "block.minecraft.cherry_door": "Բալենու դուռ",
  "block.minecraft.cherry_fence": "Բալենու ցանկապատ",
  "block.minecraft.cherry_fence_gate": "Բալենու ցանկապատի դարպաս",
  "block.minecraft.cherry_hanging_sign": "Բալենու կախվով ցուցանակ",
  "block.minecraft.cherry_leaves": "Բալենու տերեւ",
  "block.minecraft.cherry_log": "Բալենու գերան",
  "block.minecraft.cherry_planks": "Բալենու տախտակներ",
  "block.minecraft.cherry_pressure_plate": "Բալենու ճնշաթիթեղ",
  "block.minecraft.cherry_sapling": "Բալենու տնկի",
  "block.minecraft.cherry_shelf": "Բալենուց դարակ",
  "block.minecraft.cherry_sign": "Բալենու ցուցանակ",
  "block.minecraft.cherry_slab": "Բալենու սալիկ",
  "block.minecraft.cherry_stairs": "Բալենու աստիճաններ",
  "block.minecraft.cherry_trapdoor": "Բալենու դռնակ",
  "block.minecraft.cherry_wall_hanging_sign": "Բալենու պատից կախվով ցուցանակ",
  "block.minecraft.cherry_wall_sign": "Բալենու պատի ցուցանակ",
  "block.minecraft.cherry_wood": "Բալենու փայտ",
  "block.minecraft.chest": "Գանձարկղ",
  "block.minecraft.chipped_anvil": "Վնասված զնդան",
  "block.minecraft.chiseled_bookshelf": "Փորագրված գրապահարան",
  "block.minecraft.chiseled_copper": "Տաշած պղինձ",
  "block.minecraft.chiseled_deepslate": "Փորագրված խորը շերտաքար",
  "block.minecraft.chiseled_nether_bricks": "Փորագրված դժոխքի աղյուսներ",
  "block.minecraft.chiseled_polished_blackstone": "Փորագրված հարթեցված սևքար",
  "block.minecraft.chiseled_quartz_block": "Փորագրված Կվարցի Բլոկ",
  "block.minecraft.chiseled_red_sandstone": "Փորագրված կարմիր ավազաքար",
  "block.minecraft.chiseled_resin_bricks": "Փորագրված խեժի աղյուսներ",
  "block.minecraft.chiseled_sandstone": "Փորագրված Ավազաքար",
  "block.minecraft.chiseled_stone_bricks": "Փորագրված Քարաղյուս",
  "block.minecraft.chiseled_tuff": "Շերտավոր տուֆ",
  "block.minecraft.chiseled_tuff_bricks": "Կտրտած տուֆե աղյուսներ",
  "block.minecraft.chorus_flower": "Քորուզի ծաղիկ",
  "block.minecraft.chorus_plant": "Քորուզի բույս",
  "block.minecraft.clay": "Կավ",
  "block.minecraft.closed_eyeblossom": "Փակ ակնածաղիկ",
  "block.minecraft.coal_block": "Ածուխի բլոկ",
  "block.minecraft.coal_ore": "Ածուխի հանքաքար",
  "block.minecraft.coarse_dirt": "Քարքարոտ հող",
  "block.minecraft.cobbled_deepslate": "Սալարկված Խորը Շերտաքար",
  "block.minecraft.cobbled_deepslate_slab": "Սալարկված Խորը Շերտաքարի Սալիկ",
  "block.minecraft.cobbled_deepslate_stairs": "Սալարկված խորը շերտաքարի աստիճաններ",
  "block.minecraft.cobbled_deepslate_wall": "Սալարկված խորը շերտաքարի պատ",
  "block.minecraft.cobblestone": "Սալաքար",
  "block.minecraft.cobblestone_slab": "Սալաքարե Սալիկ",
  "block.minecraft.cobblestone_stairs": "Սալաքարե Աստիճաններ",
  "block.minecraft.cobblestone_wall": "Սալաքարե Պատ",
  "block.minecraft.cobweb": "Սարդոստայն",
  "block.minecraft.cocoa": "Կակաո",
  "block.minecraft.command_block": "Հրամանների բլոկ",
  "block.minecraft.comparator": "Ռեդստունե համեմատիչ",
  "block.minecraft.composter": "Հողի մնացորդների տարա",
  "block.minecraft.conduit": "Ծովային սկզբնաղբյուր",
  "block.minecraft.copper_bars": "Պղնձե ճաղեր",
  "block.minecraft.copper_block": "Պղնձե բլոկ",
  "block.minecraft.copper_bulb": "Պղնձե լամպ",
  "block.minecraft.copper_chain": "Պղնձե շղթա",
  "block.minecraft.copper_chest": "Պղնձե սնդուկ",
  "block.minecraft.copper_door": "Պղնձե դուռ",
  "block.minecraft.copper_golem_statue": "Պղնձե գոլեմի քանդակ",
  "block.minecraft.copper_grate": "Պղնձե ցանց",
  "block.minecraft.copper_lantern": "Պղնձե լապտեր",
  "block.minecraft.copper_ore": "Պղնձե հանքաքար",
  "block.minecraft.copper_torch": "Պղնձե ջահ",
  "block.minecraft.copper_trapdoor": "Copper Trapdoor",
  "block.minecraft.copper_wall_torch": "Պատի պղնձե ջահ",
  "block.minecraft.cornflower": "Տերեփուկ",
  "block.minecraft.cracked_deepslate_bricks": "Ճեղքված խորը շերտաքարի աղյուսներ",
  "block.minecraft.cracked_deepslate_tiles": "Փորագրված խորը շերտաքարի սալիկներ",
  "block.minecraft.cracked_nether_bricks": "Դժոխքե ճաքած աղյուսներ",
  "block.minecraft.cracked_polished_blackstone_bricks": "Ճաքած հարթեցված սևքարե աղյուս",
  "block.minecraft.cracked_stone_bricks": "Ճաքած Քարաղյուս",
  "block.minecraft.crafter": "Կերտիչ",
  "block.minecraft.crafting_table": "Կերտոց",
  "block.minecraft.creaking_heart": "Ճռինչի սիրտ",
  "block.minecraft.creeper_head": "Քրիփերի Գլուխ",
  "block.minecraft.creeper_wall_head": "Կրիպերի պատի գլուխ",
  "block.minecraft.crimson_button": "Բոսորային կոճակ",
  "block.minecraft.crimson_door": "Բոսորային Դուռ",
  "block.minecraft.crimson_fence": "Բոսորային Ցանկապատ",
  "block.minecraft.crimson_fence_gate": "Բոսորային  Ցանկապատի Դարպաս",
  "block.minecraft.crimson_fungus": "Բոսորագույն Սունկ",
  "block.minecraft.crimson_hanging_sign": "Բոսորային կախովի ցուցանակ",
  "block.minecraft.crimson_hyphae": "Ալ կարմիր հիֆեր",
  "block.minecraft.crimson_nylium": "Ալ կարմիր նիլիում",
  "block.minecraft.crimson_planks": "Բոսորային Տախտակներ",
  "block.minecraft.crimson_pressure_plate": "Բոսորային Ճնշաթիթեղ",
  "block.minecraft.crimson_roots": "Բոսորագույն Արմատներ",
  "block.minecraft.crimson_shelf": "Բոսոր դարակ",
  "block.minecraft.crimson_sign": "Բոսորային Ցուցանակ",
  "block.minecraft.crimson_slab": "Բոսորային Ծառի Սալիկ",
  "block.minecraft.crimson_stairs": "Բոսորային Ծառից Աստիճաններ",
  "block.minecraft.crimson_stem": "Ալ կարմիր ծառի գերան",
  "block.minecraft.crimson_trapdoor": "Բոսորային Դռնակ",
  "block.minecraft.crimson_wall_hanging_sign": "Բոսորային պատից կախովի ցուցանակ",
  "block.minecraft.crimson_wall_sign": "Բոսորային Պատի Ցուցանակ",
  "block.minecraft.crying_obsidian": "Լացող օբսիդիան",
  "block.minecraft.cut_copper": "Կտրտված պղինձ",
  "block.minecraft.cut_copper_slab": "Կտրտված պղնձե սալիկ",
  "block.minecraft.cut_copper_stairs": "Կտրտված պղինձից աստիճաններ",
  "block.minecraft.cut_red_sandstone": "Հարթ կարմիր ավազաքար",
  "block.minecraft.cut_red_sandstone_slab": "Հարթ կարմիր ավազաքարե սալիկ",
  "block.minecraft.cut_sandstone": "Կտրտված ավազաքար",
  "block.minecraft.cut_sandstone_slab": "Հարթ Ավազաքարե Սալիկ",
  "block.minecraft.cyan_banner": "Փիրուզագույն դրոշակ",
  "block.minecraft.cyan_bed": "Բաց կապույտ մահճակալ",
  "block.minecraft.cyan_candle": "Փիրուզագույն մոմ",
  "block.minecraft.cyan_candle_cake": "Թխվածք փիրուզագույն մոմով",
  "block.minecraft.cyan_carpet": "Փիրուզագույն գորգ",
  "block.minecraft.cyan_concrete": "Փիրուզագույն բետոն",
  "block.minecraft.cyan_concrete_powder": "Փիրուզագույն փոշի բետոն",
  "block.minecraft.cyan_glazed_terracotta": "Փիրուզագույն Թրծած Տեռակոտա",
  "block.minecraft.cyan_shulker_box": "Փիրուզագույն Շալքերի Տուփ",
  "block.minecraft.cyan_stained_glass": "Փիրուզագույն ապակի",
  "block.minecraft.cyan_stained_glass_pane": "Փիրուզագույն ապակու պատուհան",
  "block.minecraft.cyan_terracotta": "Փիրուզագույն Տեռակոտա",
  "block.minecraft.cyan_wool": "Փիրուզագույն բուրդ",
  "block.minecraft.damaged_anvil": "Կոտրված զնդան",
  "block.minecraft.dandelion": "Խատուտիկ",
  "block.minecraft.dark_oak_button": "Մուգ Կաղնու փայտից կոճակ",
  "block.minecraft.dark_oak_door": "Մուգ կաղնե դուռ",
  "block.minecraft.dark_oak_fence": "Մուգ կաղնու ցանկապատ",
  "block.minecraft.dark_oak_fence_gate": "Մուգ Կաղնու փայտից ցանկապատի դարպաս",
  "block.minecraft.dark_oak_hanging_sign": "Կախովի ափսե մուգ կաղնու փայտից",
  "block.minecraft.dark_oak_leaves": "Մուգ կաղնու տերեւներ",
  "block.minecraft.dark_oak_log": "Մուգ կաղնու գերան",
  "block.minecraft.dark_oak_planks": "Մուգ կաղնու տախտակներ",
  "block.minecraft.dark_oak_pressure_plate": "Մուգ կաղնու փայտից ճնշաթիթեղ",
  "block.minecraft.dark_oak_sapling": "Մուգ կաղնու տնկի",
  "block.minecraft.dark_oak_shelf": "Մուգ կաղնու դարակ",
  "block.minecraft.dark_oak_sign": "Մուգ կաղնու ցուցանակ",
  "block.minecraft.dark_oak_slab": "Մուգ Կաղնու Սալիկ",
  "block.minecraft.dark_oak_stairs": "Մուգ կաղնու աստիճաններ",
  "block.minecraft.dark_oak_trapdoor": "Մուգ կաղնու փայտից ծուղակե դռնակ",
  "block.minecraft.dark_oak_wall_hanging_sign": "Մուգ կաղնու պատից կախովի ցուցանակ",
  "block.minecraft.dark_oak_wall_sign": "Պատի ափսե մուգ կաղնու փայտից\n",
  "block.minecraft.dark_oak_wood": "Մուգ կաղնու փայտ",
  "block.minecraft.dark_prismarine": "Մուգ Պրիզմարին",
  "block.minecraft.dark_prismarine_slab": "Մուգ Պրիզմարինե Սալիկ",
  "block.minecraft.dark_prismarine_stairs": "Մուգ պրիզմարինե աստիճաններ",
  "block.minecraft.daylight_detector": "Ցերեկային Լույսի Ցուցիչ",
  "block.minecraft.dead_brain_coral": "Մահացած ուղեղային մարջան",
  "block.minecraft.dead_brain_coral_block": "Մահացած ուղեղային մարջանի բլոկ",
  "block.minecraft.dead_brain_coral_fan": "Մահացած հովհարային ուղեղային մարջան",
  "block.minecraft.dead_brain_coral_wall_fan": "Պատի մահացած հովհարային ուղեղային մարջան",
  "block.minecraft.dead_bubble_coral": "Մահացած խողովակային մարջան",
  "block.minecraft.dead_bubble_coral_block": "Մահացած պղպջակային մարջանի բլոկ",
  "block.minecraft.dead_bubble_coral_fan": "Մահացած հովհարային պղպջակային մարջան",
  "block.minecraft.dead_bubble_coral_wall_fan": "Պատի մահացած հովհարային պղպջակային մարջան",
  "block.minecraft.dead_bush": "Մեռյալ Թուփ",
  "block.minecraft.dead_fire_coral": "Մահացած կրակոտ մարջան",
  "block.minecraft.dead_fire_coral_block": "Մահացած կրակոտ մարջանի բլոկ",
  "block.minecraft.dead_fire_coral_fan": "Մահացած հովհարային կրակոտ մարջան",
  "block.minecraft.dead_fire_coral_wall_fan": "Մահացած հրդեհի մարջան Պատի երկրպագու",
  "block.minecraft.dead_horn_coral": "Մահացած կոտոշավոր մարջան",
  "block.minecraft.dead_horn_coral_block": "Մահացած կոտոշային մարջանի բլոկ",
  "block.minecraft.dead_horn_coral_fan": "Մահացած հովհարային կոտոշավոր մարջան",
  "block.minecraft.dead_horn_coral_wall_fan": "Մեռած եղջյուրի մարջան պատի երկրպագու",
  "block.minecraft.dead_tube_coral": "Մահացած խողովակային մարջան",
  "block.minecraft.dead_tube_coral_block": "Մահացած գլանային մարջանի բլոկ",
  "block.minecraft.dead_tube_coral_fan": "Մահացած հովհարային խողովակային մարջան",
  "block.minecraft.dead_tube_coral_wall_fan": "Պատի մահացած հովհարային խողովակային մարջան",
  "block.minecraft.decorated_pot": "Զարդաման",
  "block.minecraft.deepslate": "Խորը շերտաքար",
  "block.minecraft.deepslate_brick_slab": "Խորը շերտաքարի աղյուսե սալիկ",
  "block.minecraft.deepslate_brick_stairs": "Խորը շերտաքարի աղյուսե աստիճաններ",
  "block.minecraft.deepslate_brick_wall": "Խորը շերտաքարի աղյուսե պատ",
  "block.minecraft.deepslate_bricks": "Խորը շերտաքարի  աղյուսներ",
  "block.minecraft.deepslate_coal_ore": "Խորը շերտաքարի ածխե հանքաքար",
  "block.minecraft.deepslate_copper_ore": "Խորը շերտաքարի պղնձե հանքաքար",
  "block.minecraft.deepslate_diamond_ore": "Խորը շերտաքարի ադամանդե հանքաքար",
  "block.minecraft.deepslate_emerald_ore": "Խորը շերտաքարի զմրուխտե հանքաքար",
  "block.minecraft.deepslate_gold_ore": "Խորը շերտաքարի ոսկե հանքաքար",
  "block.minecraft.deepslate_iron_ore": "Խորը շերտաքարի երկաթե հանքաքար",
  "block.minecraft.deepslate_lapis_ore": "Խորը շերտաքարի լաջվարդե հանքաքար",
  "block.minecraft.deepslate_redstone_ore": "Խորը շերտաքարի կարմրաքարե հանքաքար",
  "block.minecraft.deepslate_tile_slab": "Խորը շերտաքարի կղմինդրից սալիկ",
  "block.minecraft.deepslate_tile_stairs": "Խորը շերտաքարի կղմինդրից աստիճան",
  "block.minecraft.deepslate_tile_wall": "Խորը շերտաքարի կղմինդրից պատ",
  "block.minecraft.deepslate_tiles": "Խորը շերտաքարի կղմինդրներ",
  "block.minecraft.detector_rail": "Հայտնաբերող Ռելս",
  "block.minecraft.diamond_block": "Ադամանդե բլոկ",
  "block.minecraft.diamond_ore": "Ադամանդի Հանքաքար",
  "block.minecraft.diorite": "Դիորիտ",
  "block.minecraft.diorite_slab": "Դիորիտե Սալիկ",
  "block.minecraft.diorite_stairs": "Դիորիտե աստիճաններ",
  "block.minecraft.diorite_wall": "Դիորիտե պատ",
  "block.minecraft.dirt": "Կեղտ",
  "block.minecraft.dirt_path": "Հողի արահետ",
  "block.minecraft.dispenser": "Բաշխիչ",
  "block.minecraft.dragon_egg": "Վիշապի Ձու",
  "block.minecraft.dragon_head": "Վիշապի Գլուխ",
  "block.minecraft.dragon_wall_head": "Վիշապի գլուխ",
  "block.minecraft.dried_ghast": "Չորացած գաստ",
  "block.minecraft.dried_kelp_block": "Չորացրած լամինարիայի բլոկ",
  "block.minecraft.dripstone_block": "Շթաքարի բլոկ",
  "block.minecraft.dropper": "Բաշխիչ",
  "block.minecraft.emerald_block": "Զմրուխտի բլոկ",
  "block.minecraft.emerald_ore": "Զմրուխտի Հանքաքար",
  "block.minecraft.enchanting_table": "Կախարդանքի Սեղան",
  "block.minecraft.end_gateway": "Էնդի դարպասներ",
  "block.minecraft.end_portal": "Էնդի Դարպաս",
  "block.minecraft.end_portal_frame": "Էնդ պորտալի շրջանակ",
  "block.minecraft.end_rod": "Էնդի ձող",
  "block.minecraft.end_stone": "Վերջնաքար",
  "block.minecraft.end_stone_brick_slab": "Վերջնաքարի Աղյուսե Սալիկ",
  "block.minecraft.end_stone_brick_stairs": "Վերջնաքարե աղյուսե Աստիճաններ",
  "block.minecraft.end_stone_brick_wall": "Վերջնաքարի աղյուսե պատ",
  "block.minecraft.end_stone_bricks": "Վերջնաքարի Աղյուսներ",
  "block.minecraft.ender_chest": "Էնդերի Գանձարկղ",
  "block.minecraft.exposed_chiseled_copper": "Մգացած մանրացված պղինձ",
  "block.minecraft.exposed_copper": "Մգացած պղինձ",
  "block.minecraft.exposed_copper_bars": "Մգացած պղնձե ճաղեր",
  "block.minecraft.exposed_copper_bulb": "Մգացած պղնձե լամպ",
  "block.minecraft.exposed_copper_chain": "Մգացած պղնձե շղթա",
  "block.minecraft.exposed_copper_chest": "Մգացած պղնձե սնդուկ",
  "block.minecraft.exposed_copper_door": "Բացահայտված պղնձե դուռ",
  "block.minecraft.exposed_copper_golem_statue": "Սևացած պղնձե գոլեմի քանդակ",
  "block.minecraft.exposed_copper_grate": "Մգացած պղնձե ցանց",
  "block.minecraft.exposed_copper_lantern": "Մգացած պղնձե լապտեր",
  "block.minecraft.exposed_copper_trapdoor": "Բացահայտված Copper Trapdoor",
  "block.minecraft.exposed_cut_copper": "Մգացած կտրտված պղինձ",
  "block.minecraft.exposed_cut_copper_slab": "Մգացած կտրտված պղնձե սալիկ",
  "block.minecraft.exposed_cut_copper_stairs": "Մգացած կտրտված պղնձե աստիճաններ",
  "block.minecraft.exposed_lightning_rod": "Մգացած շանթարգել",
  "block.minecraft.farmland": "Մշակահող",
  "block.minecraft.fern": "Պտեր",
  "block.minecraft.fire": "Կրակ",
  "block.minecraft.fire_coral": "Կրակոտ մարջան",
  "block.minecraft.fire_coral_block": "Կրակոտ մարջանի բլոկ",
  "block.minecraft.fire_coral_fan": "Հովհարային կրակոտ մարջան",
  "block.minecraft.fire_coral_wall_fan": "Պատի հովհարային կրակոտ մարջան",
  "block.minecraft.firefly_bush": "Լուսատտիկներով թուփ",
  "block.minecraft.fletching_table": "Նետաձգի սեղան",
  "block.minecraft.flower_pot": "Ծաղկաման",
  "block.minecraft.flowering_azalea": "Ծաղկող լեռնավարդ",
  "block.minecraft.flowering_azalea_leaves": "Ծաղկող լեռնավարդի տերևներ",
  "block.minecraft.frogspawn": "Գորտի խավիար",
  "block.minecraft.frosted_ice": "Ալեխառն Սառույց",
  "block.minecraft.furnace": "Վառարան",
  "block.minecraft.gilded_blackstone": "Ոսկիացված սևքար",
  "block.minecraft.glass": "Ապակի",
  "block.minecraft.glass_pane": "Ապակու պատուհան",
  "block.minecraft.glow_lichen": "Փայլփլուն քոս",
  "block.minecraft.glowstone": "Լուսարձակող Քար",
  "block.minecraft.gold_block": "Ոսկուց բլոկ",
  "block.minecraft.gold_ore": "Ոսկու հանքաքար",
  "block.minecraft.golden_dandelion": "Ոսկե խատուտիկ",
  "block.minecraft.granite": "Գրանիտ",
  "block.minecraft.granite_slab": "Գրանիտե Սալիկ",
  "block.minecraft.granite_stairs": "Գրանիտե աստիճաններ",
  "block.minecraft.granite_wall": "Գրանիտե պատ",
  "block.minecraft.grass": "Խոտ",
  "block.minecraft.grass_block": "Ճիմ",
  "block.minecraft.gravel": "Կոպիճ",
  "block.minecraft.gray_banner": "Մոխրագույն դրոշակ",
  "block.minecraft.gray_bed": "Մոխրագույն մահճակալ",
  "block.minecraft.gray_candle": "Մոխրագույն մոմ",
  "block.minecraft.gray_candle_cake": "Թխվածք մոխրագույն մոմով",
  "block.minecraft.gray_carpet": "Մոխրագույն Գորգ",
  "block.minecraft.gray_concrete": "Մոխրագույն բետոն",
  "block.minecraft.gray_concrete_powder": "Մոխրագույն փոշի բետոն",
  "block.minecraft.gray_glazed_terracotta": "Մոխրագույն Թրծած Տեռակոտա",
  "block.minecraft.gray_shulker_box": "Մոխրագույն Շալքերի Տուփ",
  "block.minecraft.gray_stained_glass": "Մոխրագույն ապակի",
  "block.minecraft.gray_stained_glass_pane": "Մոխրագոյն գունաւոր պատուհան",
  "block.minecraft.gray_terracotta": "Մոխրագույն Տեռակոտա",
  "block.minecraft.gray_wool": "Մոխրագույն բուրդ",
  "block.minecraft.green_banner": "Կանաչ դրոշակ",
  "block.minecraft.green_bed": "Կանաչ մահճակալ",
  "block.minecraft.green_candle": "Կանաչ մոմ",
  "block.minecraft.green_candle_cake": "Թխվածք Կանաչ Մոմով",
  "block.minecraft.green_carpet": "Կանաչ Գորգ",
  "block.minecraft.green_concrete": "Կանաչ բետոն",
  "block.minecraft.green_concrete_powder": "Կանաչ փոշի բետոն",
  "block.minecraft.green_glazed_terracotta": "Կանաչ Թրծած Տեռակոտա",
  "block.minecraft.green_shulker_box": "Կանաչ Շալքերի Տուփ",
  "block.minecraft.green_stained_glass": "Կանաչ բծերով ապակի",
  "block.minecraft.green_stained_glass_pane": "Կանաչ ապակու պատուհան",
  "block.minecraft.green_terracotta": "Կանաչ Տեռակոտա",
  "block.minecraft.green_wool": "Կանաչ բուրդ",
  "block.minecraft.grindstone": "Սրոց",
  "block.minecraft.hanging_roots": "Կախված արմատներ",
  "block.minecraft.hay_block": "Ցորենի խուրց",
  "block.minecraft.heavy_core": "Ծանր Միջուկ",
  "block.minecraft.heavy_weighted_pressure_plate": "Ծանր կշռված ճնշաթիթեղ",
  "block.minecraft.honey_block": "Մեղրի բլոկ",
  "block.minecraft.honeycomb_block": "Մեղրամոմի բլոկ",
  "block.minecraft.hopper": "Ձագար",
  "block.minecraft.horn_coral": "Կոտոշավոր մարջան",
  "block.minecraft.horn_coral_block": "Կոտոշավոր մարջանի բլոկ",
  "block.minecraft.horn_coral_fan": "Հովհարային կոտոշավոր մարջան",
  "block.minecraft.horn_coral_wall_fan": "Պատի հովհարային կոտոշավոր մարջան",
  "block.minecraft.ice": "Սառույց",
  "block.minecraft.infested_chiseled_stone_bricks": "Վարակված փորագրված քարաղյուս",
  "block.minecraft.infested_cobblestone": "Վարակված սալաքար",
  "block.minecraft.infested_cracked_stone_bricks": "Վարակված ճաքած քարաղյուս",
  "block.minecraft.infested_deepslate": "Վարակված խորը շերտաքար",
  "block.minecraft.infested_mossy_stone_bricks": "Վարակված մամռակալած քարաղյուս",
  "block.minecraft.infested_stone": "Վարակված քար",
  "block.minecraft.infested_stone_bricks": "Վարակված Քարաղյուս",
  "block.minecraft.iron_bars": "Երկաթե Ճաղեր",
  "block.minecraft.iron_block": "Երկաթի բլոկ",
  "block.minecraft.iron_chain": "Երկաթե շղթա",
  "block.minecraft.iron_door": "Երկաթե Դուռ",
  "block.minecraft.iron_ore": "Երկաթի հանքաքար",
  "block.minecraft.iron_trapdoor": "Երկաթե Դռնակ",
  "block.minecraft.jack_o_lantern": "Ջեկի Լամպը",
  "block.minecraft.jigsaw": "Փազլ",
  "block.minecraft.jukebox": "Նվագարկիչ",
  "block.minecraft.jungle_button": "Արևադարձային ծառի փայտից կոճակ",
  "block.minecraft.jungle_door": "Արևադարձային ծառի դուռ",
  "block.minecraft.jungle_fence": "Արևադարձային ծառի ցանկապատ",
  "block.minecraft.jungle_fence_gate": "Արևադարձային ծառի փայտից ցանկապատի դարպաս",
  "block.minecraft.jungle_hanging_sign": "Ջունգլիային կախովի ցուցանակ",
  "block.minecraft.jungle_leaves": "Արևադարձային ծառի տերեւներ",
  "block.minecraft.jungle_log": "Արևադարձային ծառի գերան",
  "block.minecraft.jungle_planks": "Ջունգլու տախտակներ",
  "block.minecraft.jungle_pressure_plate": "Արևադարձային ծառի փայտից ճնշաթիթեղ",
  "block.minecraft.jungle_sapling": "Ջունգլու տնկի",
  "block.minecraft.jungle_shelf": "Արևադարձային ծառի փայտից դարակ",
  "block.minecraft.jungle_sign": "Արևադարձային ծառի ցուցանակ",
  "block.minecraft.jungle_slab": "Արևադարձային ծառի սալիկ",
  "block.minecraft.jungle_stairs": "Արևադարձային ծառի աստիճաններ",
  "block.minecraft.jungle_trapdoor": "Արևադարձային ծառի փայտից ծուղակե դռնակ",
  "block.minecraft.jungle_wall_hanging_sign": "Ջունգլիային փայտից պատի կախովի ցուցանակ",
  "block.minecraft.jungle_wall_sign": "Ջունգլիներում պատի ափսե\n",
  "block.minecraft.jungle_wood": "Արևադարձային ծառի փայտ",
  "block.minecraft.kelp": "Լամինարիա",
  "block.minecraft.kelp_plant": "Լամինարիայի բույս",
  "block.minecraft.ladder": "Սանդուղք",
  "block.minecraft.lantern": "Լապտեր",
  "block.minecraft.lapis_block": "Լաջվարդից բլոկ",
  "block.minecraft.lapis_ore": "Լաջվարդի հանքաքար",
  "block.minecraft.large_amethyst_bud": "Մեծ մեղեսիկային բողբոջ",
  "block.minecraft.large_fern": "Մեծ Պտեր",
  "block.minecraft.lava": "Լավա",
  "block.minecraft.lava_cauldron": "Լավայով կաթսա",
  "block.minecraft.leaf_litter": "Չորացած տերևներ",
  "block.minecraft.lectern": "Ամբիոն",
  "block.minecraft.lever": "Լծակ",
  "block.minecraft.light": "Լույս",
  "block.minecraft.light_blue_banner": "Բաց կապույտ դրոշակ",
  "block.minecraft.light_blue_bed": "Բաց կապույտ մահճակալ",
  "block.minecraft.light_blue_candle": "Երկնագույն մոմ",
  "block.minecraft.light_blue_candle_cake": "Թխվածք Բաց Կապույտ Մոմով",
  "block.minecraft.light_blue_carpet": "Բաց Կապույտ Գորգ",
  "block.minecraft.light_blue_concrete": "Բաց կապույտ բետոն",
  "block.minecraft.light_blue_concrete_powder": "Բաց կապույտ փոշի բետոն",
  "block.minecraft.light_blue_glazed_terracotta": "Բաց Կապույտ Թրծած Տեռակոտա",
  "block.minecraft.light_blue_shulker_box": "Բաց Կապույտ Շալքերի Տուփ",
  "block.minecraft.light_blue_stained_glass": "Բաց կապույտ ապակի",
  "block.minecraft.light_blue_stained_glass_pane": "Բաց կապույտ ապակու շերտ",
  "block.minecraft.light_blue_terracotta": "Բաց Կապույտ Տեռակոտա",
  "block.minecraft.light_blue_wool": "Բաց Կապույտ Բուրդ",
  "block.minecraft.light_gray_banner": "Բաց մոխրագույն դրոշակ",
  "block.minecraft.light_gray_bed": "Բաց մոխրագույն մահճակալ",
  "block.minecraft.light_gray_candle": "Բաց մոխրագույն մոմ",
  "block.minecraft.light_gray_candle_cake": "Թխվածք բաց մոխրագույն մոմով",
  "block.minecraft.light_gray_carpet": "Բաց Մոխրագույն Գորգ",
  "block.minecraft.light_gray_concrete": "Բաց մոխրագույն բետոն",
  "block.minecraft.light_gray_concrete_powder": "Բաց մոխրագույն փոշի բետոն",
  "block.minecraft.light_gray_glazed_terracotta": "Բաց Մոխրագույն Թրծած Տեռակոտա",
  "block.minecraft.light_gray_shulker_box": "Բաց Մոխրագույն Շալքերի Տուփ",
  "block.minecraft.light_gray_stained_glass": "Բաց մոխրագույն ապակի",
  "block.minecraft.light_gray_stained_glass_pane": "Բաց մոխրագույն ապակու պատուհան",
  "block.minecraft.light_gray_terracotta": "Բաց Մոխրագույն Տեռակոտա",
  "block.minecraft.light_gray_wool": "Բաց մոխրագույն բուրդ",
  "block.minecraft.light_weighted_pressure_plate": "Թեթև կշռված ճնշաթիթեղ",
  "block.minecraft.lightning_rod": "Շանթարգել",
  "block.minecraft.lilac": "Յասաման",
  "block.minecraft.lily_of_the_valley": "Հովտաշուշան",
  "block.minecraft.lily_pad": "Ջրաշուշան",
  "block.minecraft.lime_banner": "Լայմ դրոշակ",
  "block.minecraft.lime_bed": "Լայմ մահճակալ",
  "block.minecraft.lime_candle": "Լայմային մոմ",
  "block.minecraft.lime_candle_cake": "Թխվածք Լայմ Մոմով",
  "block.minecraft.lime_carpet": "Լայմ գորգ",
  "block.minecraft.lime_concrete": "Բաց կանաչ բետոն",
  "block.minecraft.lime_concrete_powder": "Բաց կանաչ փոշի բետոն",
  "block.minecraft.lime_glazed_terracotta": "Բաց Կանաչ Թրծած Տեռակոտա",
  "block.minecraft.lime_shulker_box": "Բաց Կանաչ Շալքերի Տուփ",
  "block.minecraft.lime_stained_glass": "Լայմ ապակի",
  "block.minecraft.lime_stained_glass_pane": "Լայմ ապակու պատուհան",
  "block.minecraft.lime_terracotta": "Բաց Կանաչ Տեռակոտա",
  "block.minecraft.lime_wool": "Լայմ բուրդ",
  "block.minecraft.lodestone": "Մագնիս",
  "block.minecraft.loom": "Ջուլհակահաստոց",
  "block.minecraft.magenta_banner": "Մորեգույն դրոշակ",
  "block.minecraft.magenta_bed": "Բաց վարդագույն մահճակալ",
  "block.minecraft.magenta_candle": "Մորեգույն մոմ",
  "block.minecraft.magenta_candle_cake": "Թխվածք Ծիրանի Մոմով",
  "block.minecraft.magenta_carpet": "Մորեգույն Գորգ",
  "block.minecraft.magenta_concrete": "Մորեգույն բետոն",
  "block.minecraft.magenta_concrete_powder": "Մորեգույն փոշի բետոն",
  "block.minecraft.magenta_glazed_terracotta": "Մորեգույն Թրծած Տեռակոտա",
  "block.minecraft.magenta_shulker_box": "Մորեգույն Շալքերի Տուփ",
  "block.minecraft.magenta_stained_glass": "Մորեգույն ապակի",
  "block.minecraft.magenta_stained_glass_pane": "Մորեգույն ապակու շերտ",
  "block.minecraft.magenta_terracotta": "Մորեգույն Տեռակոտա",
  "block.minecraft.magenta_wool": "Մորեգույն բուրդ",
  "block.minecraft.magma_block": "Մագմայի բլոկ",
  "block.minecraft.mangrove_button": "Մանգրայից կոճակ",
  "block.minecraft.mangrove_door": "Մանգրային դուռ",
  "block.minecraft.mangrove_fence": "Մանգրայից ցանկապատ",
  "block.minecraft.mangrove_fence_gate": "Մանգրայից ցանկապատի դարպաս",
  "block.minecraft.mangrove_hanging_sign": "Մանգրային կախվող ցուցանակ",
  "block.minecraft.mangrove_leaves": "Մանգրային տերևներ",
  "block.minecraft.mangrove_log": "Մանգրայի գերան",
  "block.minecraft.mangrove_planks": "Մանգրային տախտակներ",
  "block.minecraft.mangrove_pressure_plate": "Մանգրայից սեղմակ",
  "block.minecraft.mangrove_propagule": "Մանգրային տնկի",
  "block.minecraft.mangrove_roots": "Մանգրայի արմատներ",
  "block.minecraft.mangrove_shelf": "Մանգրային դարակ",
  "block.minecraft.mangrove_sign": "Մանգրային ցուցանակ",
  "block.minecraft.mangrove_slab": "Մանգրային Սալիկ",
  "block.minecraft.mangrove_stairs": "Մանգրային աստիճաններ",
  "block.minecraft.mangrove_trapdoor": "Մանգրայից ծուղակային դռնակ",
  "block.minecraft.mangrove_wall_hanging_sign": "Մանգրային պատից կախվող ցուցանակ",
  "block.minecraft.mangrove_wall_sign": "Մանգրային պատի ցուցանակ",
  "block.minecraft.mangrove_wood": "Մանգրային փայտ",
  "block.minecraft.medium_amethyst_bud": "Միջին մեղեսիկային բողբոջ",
  "block.minecraft.melon": "Սեխ",
  "block.minecraft.melon_stem": "Ձմերուկի կոռն",
  "block.minecraft.moss_block": "Մամուռի բլոկ",
  "block.minecraft.moss_carpet": "Մամռոտ ծածկույթ",
  "block.minecraft.mossy_cobblestone": "Մամռոտած սալաքար",
  "block.minecraft.mossy_cobblestone_slab": "Մամռակալած Սալաքարե Սալիկ",
  "block.minecraft.mossy_cobblestone_stairs": "Մամռակալած սալաքարե աստիճաններ",
  "block.minecraft.mossy_cobblestone_wall": "Մամռոտ Սալաքարե Պատ",
  "block.minecraft.mossy_stone_brick_slab": "Մամռակալած Քարաղյուսե Սալիկ",
  "block.minecraft.mossy_stone_brick_stairs": "Մամռակալած քարե աղյուսե աստիճաններ",
  "block.minecraft.mossy_stone_brick_wall": "Մամռակալած քարաղյուսե պատ",
  "block.minecraft.mossy_stone_bricks": "Մամռոտ Քարաղյուս",
  "block.minecraft.moving_piston": "Շարժվող մխոց",
  "block.minecraft.mud": "Ցեխ",
  "block.minecraft.mud_brick_slab": "Ցեխից աղյուսի սալիկ",
  "block.minecraft.mud_brick_stairs": "Ցեխից աղյուսի աստիճաններ",
  "block.minecraft.mud_brick_wall": "Ցեխից աղյուսի պատ",
  "block.minecraft.mud_bricks": "Ցեխից աղյուս",
  "block.minecraft.muddy_mangrove_roots": "Ցեխոտ մանգրայի արմատներ",
  "block.minecraft.mushroom_stem": "Սնկի Ցողուն",
  "block.minecraft.mycelium": "Բորբոսահող",
  "block.minecraft.nether_brick_fence": "Նեզերի աղուսից ցանկապատ",
  "block.minecraft.nether_brick_slab": "Նեզերի աղյուսից սալիկ",
  "block.minecraft.nether_brick_stairs": "Նեզերի աղուսից աստիճաններ",
  "block.minecraft.nether_brick_wall": "Նեզերի աղյուսից պատ",
  "block.minecraft.nether_bricks": "Նեզերի աղյուսներ",
  "block.minecraft.nether_gold_ore": "Նեզերի Ոսկու Հանք",
  "block.minecraft.nether_portal": "Նեզերի դարպաս",
  "block.minecraft.nether_quartz_ore": "Կվարցի Հանքաքար",
  "block.minecraft.nether_sprouts": "Նեզերի Ծիլեր",
  "block.minecraft.nether_wart": "Նեզերի աճվածք",
  "block.minecraft.nether_wart_block": "Նեզերի աճվածքի բլոկ",
  "block.minecraft.netherite_block": "Նեզերիտի բլոկ",
  "block.minecraft.netherrack": "Նեզերաքար",
  "block.minecraft.note_block": "Մեղեդու բլոկ",
  "block.minecraft.oak_button": "Կաղնու փայտից կոճակ",
  "block.minecraft.oak_door": "Կաղնե դուռ",
  "block.minecraft.oak_fence": "Կաղնու ցանկապատ",
  "block.minecraft.oak_fence_gate": "Կաղնու դարպաս",
  "block.minecraft.oak_hanging_sign": "Կաղնու կախովի ցուցանակ",
  "block.minecraft.oak_leaves": "Կաղնու տերեւներ",
  "block.minecraft.oak_log": "Կաղնու գերան",
  "block.minecraft.oak_planks": "Կաղնու տախտակներ",
  "block.minecraft.oak_pressure_plate": "Կաղնու փայտից ճնշաթիթեղ",
  "block.minecraft.oak_sapling": "Կաղնու տնկի",
  "block.minecraft.oak_shelf": "Մուգ կաղնու փայտից դարակ",
  "block.minecraft.oak_sign": "Կաղնու ցուցանակ",
  "block.minecraft.oak_slab": "Կաղնու սալիկ",
  "block.minecraft.oak_stairs": "Կաղնու աստիճաններ",
  "block.minecraft.oak_trapdoor": "Կաղնու փայտից ծուղակե դռնակ",
  "block.minecraft.oak_wall_hanging_sign": "Կաղնուց պատից կախովի ցուցանակ",
  "block.minecraft.oak_wall_sign": "Կաղնու ափսե",
  "block.minecraft.oak_wood": "Կաղնու փայտ",
  "block.minecraft.observer": "Դիտորդիչ",
  "block.minecraft.obsidian": "Օբսիդիան",
  "block.minecraft.ochre_froglight": "Օքրային գորտալույս",
  "block.minecraft.ominous_banner": "Չարագույժ դրոշակ",
  "block.minecraft.open_eyeblossom": "Բաց ակնածաղիկ",
  "block.minecraft.orange_banner": "Նարնջագույն դրոշակ",
  "block.minecraft.orange_bed": "Նարնջագույն մահճակալ",
  "block.minecraft.orange_candle": "Նարնջագույն մոմ",
  "block.minecraft.orange_candle_cake": "Թխվածք Նարնջագույն Մոմով",
  "block.minecraft.orange_carpet": "Նարնջագույն Գորգ",
  "block.minecraft.orange_concrete": "Նարնջագույն բետոն",
  "block.minecraft.orange_concrete_powder": "Նարնջագույն փոշի բետոն",
  "block.minecraft.orange_glazed_terracotta": "Նարնջագույն Թրծած Տեռակոտա",
  "block.minecraft.orange_shulker_box": "Նարնջագույն Շալքերի Տուփ",
  "block.minecraft.orange_stained_glass": "Նարնջագույն ապակի",
  "block.minecraft.orange_stained_glass_pane": "Նարնջագույն ապակու շերտ",
  "block.minecraft.orange_terracotta": "Նարնջագույն Տեռակոտա",
  "block.minecraft.orange_tulip": "Նարնջագույն Վարդակակաչ",
  "block.minecraft.orange_wool": "Նարնջագույն բուրդ",
  "block.minecraft.oxeye_daisy": "Մարգարտածաղիկ",
  "block.minecraft.oxidized_chiseled_copper": "Օքսիդացված մանրացված պղինձ",
  "block.minecraft.oxidized_copper": "Օքսիդացված պղինձ",
  "block.minecraft.oxidized_copper_bars": "Օքսիդացված պղնձե ճաղեր",
  "block.minecraft.oxidized_copper_bulb": "Օքսիդացված պղնձե լամպ",
  "block.minecraft.oxidized_copper_chain": "Օքսիդացված պղնձե շղթա",
  "block.minecraft.oxidized_copper_chest": "Օքսիդացված պղնձե սնդուկ",
  "block.minecraft.oxidized_copper_door": "Օքսիդացված պղնձե դուռ",
  "block.minecraft.oxidized_copper_golem_statue": "Օքսիդացված պղնձե գոլեմի քանդակ",
  "block.minecraft.oxidized_copper_grate": "Օքսիդացված պղնձե ցանց",
  "block.minecraft.oxidized_copper_lantern": "Օքսիդացված պղնձե լապտեր",
  "block.minecraft.oxidized_copper_trapdoor": "Օքսիդացված պղնձե դուռ",
  "block.minecraft.oxidized_cut_copper": "Օքսիդացված Կտրտված Պղինձ",
  "block.minecraft.oxidized_cut_copper_slab": "Օքսիդացված կտրտված պղնձե սալիկ",
  "block.minecraft.oxidized_cut_copper_stairs": "Օքսիդացված կտրտված պղնձե աստիճաններ",
  "block.minecraft.oxidized_lightning_rod": "Օքսիդացված շանթարգել",
  "block.minecraft.packed_ice": "Խիտ Սառույց",
  "block.minecraft.packed_mud": "Խիտ ցեխ",
  "block.minecraft.pale_hanging_moss": "Դժգույն կախված մամուռ",
  "block.minecraft.pale_moss_block": "Դժգույն մամուռի բլոկ",
  "block.minecraft.pale_moss_carpet": "Դժգույն մամռոտ ծածկույթ",
  "block.minecraft.pale_oak_button": "Դժգույն կաղնու փայտից կոճակ",
  "block.minecraft.pale_oak_door": "Դժգույն կաղնե դուռ",
  "block.minecraft.pale_oak_fence": "Դժգույն կաղնու ցանկապատ",
  "block.minecraft.pale_oak_fence_gate": "Դժգույն կաղնուց դարպաս",
  "block.minecraft.pale_oak_hanging_sign": "Դժգույն կաղնուց կախովի ցուցանակ",
  "block.minecraft.pale_oak_leaves": "Դժգույն կաղնու տերևներ",
  "block.minecraft.pale_oak_log": "Դժգույն կաղնու գերան",
  "block.minecraft.pale_oak_planks": "Դժգույն կաղնու տախտակներ",
  "block.minecraft.pale_oak_pressure_plate": "Դժգույն կաղնու փայտից ճնշաթիթեղ",
  "block.minecraft.pale_oak_sapling": "Դժգույն կաղնու տնկի",
  "block.minecraft.pale_oak_shelf": "Դժգույն կաղնու դարակ",
  "block.minecraft.pale_oak_sign": "Դժգույն կաղնու ցուցանակ",
  "block.minecraft.pale_oak_slab": "Դժգույն կաղնու սալիկ",
  "block.minecraft.pale_oak_stairs": "Դժգույն կաղնու աստիճաններ",
  "block.minecraft.pale_oak_trapdoor": "Դժգույն կաղնու փայտից ծուղակե դռնակ",
  "block.minecraft.pale_oak_wall_hanging_sign": "Դժգույն կաղնուց պատից կախովի ցուցանակ",
  "block.minecraft.pale_oak_wall_sign": "Դժգույն կաղնուց պատի ցուցանակ",
  "block.minecraft.pale_oak_wood": "Դժգույն կաղնու փայտ",
  "block.minecraft.pearlescent_froglight": "Մարգարտյա գորտալույս",
  "block.minecraft.peony": "Պիոն",
  "block.minecraft.petrified_oak_slab": "Քարացրած Կաղնու Սալիկ",
  "block.minecraft.piglin_head": "Պիգլինի գլխիկ",
  "block.minecraft.piglin_wall_head": "Պիգլինի պատի գլխիկ",
  "block.minecraft.pink_banner": "Վարդագույն դրոշակ",
  "block.minecraft.pink_bed": "Վարդագույն մահճակալ",
  "block.minecraft.pink_candle": "Վարդագույն մոմ",
  "block.minecraft.pink_candle_cake": "Թխվածք Վարդագույն Մոմով",
  "block.minecraft.pink_carpet": "Վարդագույն Գորգ",
  "block.minecraft.pink_concrete": "Վարդագույն բետոն",
  "block.minecraft.pink_concrete_powder": "Վարդագույն փոշի բետոն",
  "block.minecraft.pink_glazed_terracotta": "Վարդագույն Թրծած Տեռակոտա",
  "block.minecraft.pink_petals": "Վարդագույն ծաղկաթերթիկներ",
  "block.minecraft.pink_shulker_box": "Վարդագույն Շալքերի Տուփ",
  "block.minecraft.pink_stained_glass": "Վարդագույն ապակի",
  "block.minecraft.pink_stained_glass_pane": "Վարդագույն ապակու պատուհան",
  "block.minecraft.pink_terracotta": "Վարդագույն Տեռակոտա",
  "block.minecraft.pink_tulip": "Վարդագույն վարդակակաչ",
  "block.minecraft.pink_wool": "Վարդագույն բուրդ",
  "block.minecraft.piston": "Մխոց",
  "block.minecraft.piston_head": "Մխոցի գլխիկ",
  "block.minecraft.pitcher_crop": "Կուժաբույսի ծիլ",
  "block.minecraft.pitcher_plant": "Կուժաբույս",
  "block.minecraft.player_head": "Խաղացողի գլուխ",
  "block.minecraft.player_head.named": "%s-ի Գլուխ",
  "block.minecraft.player_wall_head": "Խաղացողի պատի գլուխ",
  "block.minecraft.podzol": "Մոխրահող",
  "block.minecraft.pointed_dripstone": "Սուր շթաքար",
  "block.minecraft.polished_andesite": "Հղկված անդեզիտ",
  "block.minecraft.polished_andesite_slab": "Հարթեցված անդեզիտե սալիկ",
  "block.minecraft.polished_andesite_stairs": "Հղկված անդեզիտե աստիճաններ",
  "block.minecraft.polished_basalt": "Հղկված Բազալտ",
  "block.minecraft.polished_blackstone": "Հարթեցված սևքար",
  "block.minecraft.polished_blackstone_brick_slab": "Հարթեցված սևքարե աղյուսե սալիկ",
  "block.minecraft.polished_blackstone_brick_stairs": "Հարթեցված սևքարե աղյուսե աստիճաններ",
  "block.minecraft.polished_blackstone_brick_wall": "Հարթեցված սևքարե աղյուսե պատ",
  "block.minecraft.polished_blackstone_bricks": "Հարթեցված սևքարե աղյուսներ",
  "block.minecraft.polished_blackstone_button": "Հարթեցված սևքարե կոճակ",
  "block.minecraft.polished_blackstone_pressure_plate": "Հարթեցված սևքարե ճնշաթիթեղ",
  "block.minecraft.polished_blackstone_slab": "Հարթեցված սևքարե սալիկ",
  "block.minecraft.polished_blackstone_stairs": "Հարթեցված սևքարե աստիճաններ",
  "block.minecraft.polished_blackstone_wall": "Հարթեցված սևքարե պատ",
  "block.minecraft.polished_deepslate": "Ողորկ խորը շերտաքար",
  "block.minecraft.polished_deepslate_slab": "Հղկված խորը շերտաքարի սալիկ",
  "block.minecraft.polished_deepslate_stairs": "Հղկված խորը շերտաքարի աստիճաններ",
  "block.minecraft.polished_deepslate_wall": "Հղկված խորը շերտաքարի պատ",
  "block.minecraft.polished_diorite": "Հղկված դիորիտ",
  "block.minecraft.polished_diorite_slab": "Հարթեցված Դիորիտե Սալիկ",
  "block.minecraft.polished_diorite_stairs": "Հարթեցված դիորիտե աստիճաններ",
  "block.minecraft.polished_granite": "Հղկված գրանիտ",
  "block.minecraft.polished_granite_slab": "Հարթեցված Գրանիտե Սալիկ",
  "block.minecraft.polished_granite_stairs": "Հարթեցված գրանիտե աստիճաններ",
  "block.minecraft.polished_tuff": "Ողորկ տուֆ",
  "block.minecraft.polished_tuff_slab": "Ողորկ տուֆ սալաքար",
  "block.minecraft.polished_tuff_stairs": "Ողորկ տուֆից աստիճաններ",
  "block.minecraft.polished_tuff_wall": "Ողորկ տուֆի պատ",
  "block.minecraft.poppy": "Կակաչ",
  "block.minecraft.potatoes": "Կարտոֆիլներ",
  "block.minecraft.potted_acacia_sapling": "Ակացիայի սածիլ ծաղկամանի մեջ",
  "block.minecraft.potted_allium": "Ծաղկամանով ալլիում",
  "block.minecraft.potted_azalea_bush": "Տնկած լեռնավարդ",
  "block.minecraft.potted_azure_bluet": "Երկնագույն Տերեփուկ Ամանի Մեջ",
  "block.minecraft.potted_bamboo": "Բամբուկ",
  "block.minecraft.potted_birch_sapling": "Կեչու սածիլ ծաղկամանի մեջ",
  "block.minecraft.potted_blue_orchid": "Ծաղկամանով խոլորձ",
  "block.minecraft.potted_brown_mushroom": "Ծաղկամանով շագանակագույն սունկ",
  "block.minecraft.potted_cactus": "Ծաղկամանով կակտուս",
  "block.minecraft.potted_cherry_sapling": "Բալենու տնկիով ծաղկաման",
  "block.minecraft.potted_closed_eyeblossom": "Կաթսայի փակ ակնածաղիկ",
  "block.minecraft.potted_cornflower": "Վասիլեկ",
  "block.minecraft.potted_crimson_fungus": "Բոսորային Սունկ Ծաղկամանում",
  "block.minecraft.potted_crimson_roots": "Ալ կարմիր արմատներ ծաղկամանի մեջ",
  "block.minecraft.potted_dandelion": "Ծաղկամանով խատուտիկ",
  "block.minecraft.potted_dark_oak_sapling": "Մուգ կաղնու տնկի ծաղկամանում",
  "block.minecraft.potted_dead_bush": "Ծաղկամանով փոշիացած թուփ",
  "block.minecraft.potted_fern": "Ծաղկամանով պտեր",
  "block.minecraft.potted_flowering_azalea_bush": "Ծաղկող տնկված լեռնավարդ",
  "block.minecraft.potted_golden_dandelion": "Ոսկե խատուտիկ ծաղկամանում",
  "block.minecraft.potted_jungle_sapling": "Արևադարձային սածիլ ծաղկամանի մեջ",
  "block.minecraft.potted_lily_of_the_valley": "Հովտաշուշան\n",
  "block.minecraft.potted_mangrove_propagule": "Potted Mangrove Propagule",
  "block.minecraft.potted_oak_sapling": "Կաղնու տնկի ծաղկամանում",
  "block.minecraft.potted_open_eyeblossom": "Կաթսայի բաց ակնածաղիկ",
  "block.minecraft.potted_orange_tulip": "Նարնջագույն Վարդակակաչ ծաղկամանում",
  "block.minecraft.potted_oxeye_daisy": "Ծաղկամանով երիցուկ",
  "block.minecraft.potted_pale_oak_sapling": "Դժգույն կաղնու տնկի ծաղկամանում",
  "block.minecraft.potted_pink_tulip": "Վարդագույն Վարդակակաչ ծաղկամանում",
  "block.minecraft.potted_poppy": "Ծաղկամանով կակաչ",
  "block.minecraft.potted_red_mushroom": "Ծաղկամանով կարմիր սունկ",
  "block.minecraft.potted_red_tulip": "Կարմիր Վարդակակաչ ծաղկամանում",
  "block.minecraft.potted_spruce_sapling": "Եղևնու սածիլ ծաղկամանի մեջ",
  "block.minecraft.potted_torchflower": "Ծաղկամանով ջահածաղիկ",
  "block.minecraft.potted_warped_fungus": "Աղավաղված սունկ ծաղկամանի մեջ",
  "block.minecraft.potted_warped_roots": "Աղավաղված արմատներ ծաղկամանի մեջ",
  "block.minecraft.potted_white_tulip": "Սպիտակ Վարդակակաչ ծաղկամանում",
  "block.minecraft.potted_wither_rose": "Ծաղկամանով Թառամած Վարդ",
  "block.minecraft.powder_snow": "Փոշի ձյուն",
  "block.minecraft.powder_snow_cauldron": "Փոշե ձնով դույլ",
  "block.minecraft.powered_rail": "Էներգակիր Ռելս",
  "block.minecraft.prismarine": "Պրիզմարին",
  "block.minecraft.prismarine_brick_slab": "Պրիզմարինե Աղյուսի Սալիկ",
  "block.minecraft.prismarine_brick_stairs": "Պրիզմարինե աղյուսի աստիճաններ",
  "block.minecraft.prismarine_bricks": "Պրիզմարինե աղյուս",
  "block.minecraft.prismarine_slab": "Պրիզմարինե Սալիկ",
  "block.minecraft.prismarine_stairs": "Պրիզմարինե աստիճաններ",
  "block.minecraft.prismarine_wall": "Պրիզմարինե պատ",
  "block.minecraft.pumpkin": "Դդում",
  "block.minecraft.pumpkin_stem": "Դդմի Ցողուն",
  "block.minecraft.purple_banner": "Մանուշակագույն դրոշակ",
  "block.minecraft.purple_bed": "Մանուշակագույն մահճակալ",
  "block.minecraft.purple_candle": "Մանուշակագույն մոմ",
  "block.minecraft.purple_candle_cake": "Թխվածք Մանուշակագույն Մոմով",
  "block.minecraft.purple_carpet": "Մանուշակագույն Գորգ",
  "block.minecraft.purple_concrete": "Մանուշակագույն բետոն",
  "block.minecraft.purple_concrete_powder": "Մանուշակագույն փոշի բետոն",
  "block.minecraft.purple_glazed_terracotta": "Մանուշակագույն Թրծած Տեռակոտա",
  "block.minecraft.purple_shulker_box": "Մանուշակագույն Շալքերի Տուփ",
  "block.minecraft.purple_stained_glass": "Մանուշակագույն ապակի",
  "block.minecraft.purple_stained_glass_pane": "Մանուշակագույն ապակու պատուհան",
  "block.minecraft.purple_terracotta": "Մանուշակագույն Տեռակոտա",
  "block.minecraft.purple_wool": "Մանուշակագույն բուրդ",
  "block.minecraft.purpur_block": "Պուրպուրե բլոկ",
  "block.minecraft.purpur_pillar": "Սյունաձև պուրպուրե բլոկ",
  "block.minecraft.purpur_slab": "Պուրպուրե Սալիկ",
  "block.minecraft.purpur_stairs": "Պուրպուրե աստիճաներ",
  "block.minecraft.quartz_block": "Կվարցի Բլոկ",
  "block.minecraft.quartz_bricks": "Կվարցե աղյուսներ",
  "block.minecraft.quartz_pillar": "Կվարցե սյուն",
  "block.minecraft.quartz_slab": "Կվարցե Սալիկ",
  "block.minecraft.quartz_stairs": "Կվարցե Աստիճաններ",
  "block.minecraft.rail": "Ռելս",
  "block.minecraft.raw_copper_block": "Հում պղնձի բլոկ",
  "block.minecraft.raw_gold_block": "Հում ոսկու բլոկ",
  "block.minecraft.raw_iron_block": "Հում երկաթի բլոկ",
  "block.minecraft.red_banner": "Կարմիր դրոշակ",
  "block.minecraft.red_bed": "Կարմիր մահճակալ",
  "block.minecraft.red_candle": "Կարմիր մոմ",
  "block.minecraft.red_candle_cake": "Թխվածք Կարմիր Մոմով",
  "block.minecraft.red_carpet": "Կարմիր Գորգ",
  "block.minecraft.red_concrete": "Կարմիր բետոն",
  "block.minecraft.red_concrete_powder": "Կարմիր փոշի բետոն",
  "block.minecraft.red_glazed_terracotta": "Կարմիր Թրծած Տեռակոտա",
  "block.minecraft.red_mushroom": "Կարմիր սունկ",
  "block.minecraft.red_mushroom_block": "Կարմիր Ճանճասպանի բլոկ",
  "block.minecraft.red_nether_brick_slab": "Նեզերի կարմիր աղյուսից սալիկ",
  "block.minecraft.red_nether_brick_stairs": "Կարմիր Նեզերի աղյուսից աստիճաններ",
  "block.minecraft.red_nether_brick_wall": "Կարմիր Նեզերի աղյուսից պատ",
  "block.minecraft.red_nether_bricks": "Կարմիր Նեզերի աղյուսներ",
  "block.minecraft.red_sand": "Կարմիր ավազ",
  "block.minecraft.red_sandstone": "Կարմիր ավազաքար",
  "block.minecraft.red_sandstone_slab": "Կարմիր Ավազաքարե Սալիկ",
  "block.minecraft.red_sandstone_stairs": "Կարմիր Ավազաքարե Աստիճաններ",
  "block.minecraft.red_sandstone_wall": "Կարմիր ավազաքարի պատ",
  "block.minecraft.red_shulker_box": "Կարմիր Շալքերի Տուփ",
  "block.minecraft.red_stained_glass": "Կարմիր ապակի",
  "block.minecraft.red_stained_glass_pane": "Կարմիր ապակու պատուհան",
  "block.minecraft.red_terracotta": "Կարմիր Տեռակոտա",
  "block.minecraft.red_tulip": "Կարմիր Վարդակակաչ",
  "block.minecraft.red_wool": "Կարմիր բուրդ",
  "block.minecraft.redstone_block": "Ռեդստունի բլոկ",
  "block.minecraft.redstone_lamp": "Ռեդստունե լամպ",
  "block.minecraft.redstone_ore": "Ռեդստունե հանքաքար",
  "block.minecraft.redstone_torch": "Ռեդստունե ջահ",
  "block.minecraft.redstone_wall_torch": "Պատի կարմրաքարի ջահ",
  "block.minecraft.redstone_wire": "Ռեդստունե Լար",
  "block.minecraft.reinforced_deepslate": "Ամրացված խորքային թերթաքար",
  "block.minecraft.repeater": "Ռեդստունե կրկնիչ",
  "block.minecraft.repeating_command_block": "Կրկնվող Հրամանների բլոկ",
  "block.minecraft.resin_block": "Խեժի բլոկ",
  "block.minecraft.resin_brick_slab": "Խեժի աղյուսից սալիկ",
  "block.minecraft.resin_brick_stairs": "Խեժի աղյուսից աստիճան",
  "block.minecraft.resin_brick_wall": "Խեժի աղյուսից պատ",
  "block.minecraft.resin_bricks": "Խեժի աղյուս",
  "block.minecraft.resin_clump": "Խեժի կույտ",
  "block.minecraft.respawn_anchor": "Վերածնման Խարիսխ",
  "block.minecraft.rooted_dirt": "Արմատավորված հող",
  "block.minecraft.rose_bush": "Վարդի Թուփ",
  "block.minecraft.sand": "Ավազ",
  "block.minecraft.sandstone": "Ավազաքար",
  "block.minecraft.sandstone_slab": "Ավազաքարե Սալիկ",
  "block.minecraft.sandstone_stairs": "Ավազաքարե աստիճաններ",
  "block.minecraft.sandstone_wall": "Ավազաքարի պատ",
  "block.minecraft.scaffolding": "Լաստակ",
  "block.minecraft.sculk": "Սքալկ",
  "block.minecraft.sculk_catalyst": "Սքալկի կատալիզատոր",
  "block.minecraft.sculk_sensor": "Սկալկ Սենսոռ",
  "block.minecraft.sculk_shrieker": "Սքալկի ծղրիդ",
  "block.minecraft.sculk_vein": "Սքալկի երակ",
  "block.minecraft.sea_lantern": "Ջրային լապտեր",
  "block.minecraft.sea_pickle": "Ծովային Վարունգ",
  "block.minecraft.seagrass": "Ծովախոտ",
  "block.minecraft.set_spawn": "Վերահայտնության կետը նշվեց",
  "block.minecraft.short_dry_grass": "Կարճ չորացած խոտ",
  "block.minecraft.short_grass": "Կարճ խոտ",
  "block.minecraft.shroomlight": "Սնկալույս",
  "block.minecraft.shulker_box": "Շալքերի տուփ",
  "block.minecraft.skeleton_skull": "Կմախքի Գանգ",
  "block.minecraft.skeleton_wall_skull": "Պատի կմաղքի գանգ",
  "block.minecraft.slime_block": "Լորձի բլոկ",
  "block.minecraft.small_amethyst_bud": "Փոքր մեղեսիկային բողբոջ",
  "block.minecraft.small_dripleaf": "Փոքր կաթլատերեւ",
  "block.minecraft.smithing_table": "Դարբնի սեղան",
  "block.minecraft.smoker": "Ծխանոց",
  "block.minecraft.smooth_basalt": "Հարթ Բազալտ",
  "block.minecraft.smooth_quartz": "Հարթ կվարցի բլոկ",
  "block.minecraft.smooth_quartz_slab": "Հարթ Կվարցե Սալիկ",
  "block.minecraft.smooth_quartz_stairs": "Հարթ կվարցի աստիճաններ",
  "block.minecraft.smooth_red_sandstone": "Հարթ Կարմիր Ավազաքար",
  "block.minecraft.smooth_red_sandstone_slab": "Հարթ Կարմիր Ավազաքարե Սալիկ",
  "block.minecraft.smooth_red_sandstone_stairs": "Հարթեցված կարմիր ավազաքարե աստիճաններ",
  "block.minecraft.smooth_sandstone": "Հարթ Ավազաքար",
  "block.minecraft.smooth_sandstone_slab": "Հարթ Ավազաքարե Սալիկ",
  "block.minecraft.smooth_sandstone_stairs": "Հարթեցված ավազաքարե աստիճաններ",
  "block.minecraft.smooth_stone": "Հարթ Քար",
  "block.minecraft.smooth_stone_slab": "Հարթ Քարե Սալիկ",
  "block.minecraft.sniffer_egg": "Հոտոտիկի ձու",
  "block.minecraft.snow": "Ձյուն",
  "block.minecraft.snow_block": "Ձյան բլոկ",
  "block.minecraft.soul_campfire": "Հոգու Խարույկ",
  "block.minecraft.soul_fire": "Հոգու Կրակ",
  "block.minecraft.soul_lantern": "Հոգու Լապտեր",
  "block.minecraft.soul_sand": "Հոգիների Ավազ",
  "block.minecraft.soul_soil": "Հոգու Հող",
  "block.minecraft.soul_torch": "Հոգու Ջահ",
  "block.minecraft.soul_wall_torch": "Պատի Հոգու Ջահ",
  "block.minecraft.spawn.not_valid": "Դուք չունեք մահճակալ կամ վերածնման խարիսխ, կամ այն անհասանելի է։",
  "block.minecraft.spawner": "Հրեշի Ծնարան",
  "block.minecraft.spawner.desc1": "Փոխազդել ծնելու ձվի հետ․",
  "block.minecraft.spawner.desc2": "Սահամնել Մոբի Տեսկաը",
  "block.minecraft.sponge": "Սպունգ",
  "block.minecraft.spore_blossom": "Բեղմնածաղիկ",
  "block.minecraft.spruce_button": "Եղևնու կոճակ",
  "block.minecraft.spruce_door": "Եղևնու դուռ",
  "block.minecraft.spruce_fence": "Եղևնու ցանկապատ",
  "block.minecraft.spruce_fence_gate": "Եղևնու փայտից ցանկապատի դարպաս",
  "block.minecraft.spruce_hanging_sign": "Եղևնուց կախովի ցուցանակ",
  "block.minecraft.spruce_leaves": "Եղևնու տերեւներ",
  "block.minecraft.spruce_log": "Եղեւնու գերան",
  "block.minecraft.spruce_planks": "Եղեւնու տախտակներ",
  "block.minecraft.spruce_pressure_plate": "Եղևնու փայտից ճնշաթիթեղ",
  "block.minecraft.spruce_sapling": "Եղեւնու տնկի",
  "block.minecraft.spruce_shelf": "Եղևնու փայտից դարակ",
  "block.minecraft.spruce_sign": "Եղևնու ցուցանակ",
  "block.minecraft.spruce_slab": "Եղևնու սալիկ",
  "block.minecraft.spruce_stairs": "Եղևնու աստիճաններ",
  "block.minecraft.spruce_trapdoor": "Եղևնու ծուղակե դռնակ",
  "block.minecraft.spruce_wall_hanging_sign": "Եղևնուց պատից կախովի ցուցանակ",
  "block.minecraft.spruce_wall_sign": "Եղևնու պատե ցւուցանակ",
  "block.minecraft.spruce_wood": "Եղևնու փայտ",
  "block.minecraft.sticky_piston": "Կպչուն Մխոց",
  "block.minecraft.stone": "Քար",
  "block.minecraft.stone_brick_slab": "Քարե աղյուսի սալիկ",
  "block.minecraft.stone_brick_stairs": "Աղյուսաքարե Աստիճաններ",
  "block.minecraft.stone_brick_wall": "Քարաղյուսե պատ",
  "block.minecraft.stone_bricks": "Քարաղյուս",
  "block.minecraft.stone_button": "Քարե կոճակ",
  "block.minecraft.stone_pressure_plate": "Քարե Ճնշաթիթեղ",
  "block.minecraft.stone_slab": "Քարե Սալիկ",
  "block.minecraft.stone_stairs": "Քարե աստիճաններ",
  "block.minecraft.stonecutter": "Քարհատիչ",
  "block.minecraft.stripped_acacia_log": "Կեղեւազրկած ակացիայի գերան",
  "block.minecraft.stripped_acacia_wood": "Կլպած ակացիայի փայտ",
  "block.minecraft.stripped_bamboo_block": "Մերկացած բամբուկի բլոկ",
  "block.minecraft.stripped_birch_log": "Կեղեւազրկած կեչու գերան",
  "block.minecraft.stripped_birch_wood": "Կլպած կեչու փայտ",
  "block.minecraft.stripped_cherry_log": "Բալենու կլպած գերան",
  "block.minecraft.stripped_cherry_wood": "Բալենու կլպած տախտակ",
  "block.minecraft.stripped_crimson_hyphae": "Կեղևազրկած ալ կարմիր հիֆեր",
  "block.minecraft.stripped_crimson_stem": "Կեղևազրկած ալ կարմիր ծառի գերան",
  "block.minecraft.stripped_dark_oak_log": "Կլպած մուգ կաղնու գերան",
  "block.minecraft.stripped_dark_oak_wood": "Կլպած մուգ կաղնու փայտ",
  "block.minecraft.stripped_jungle_log": "Կլպած արևադարձային ծառի գերան",
  "block.minecraft.stripped_jungle_wood": "Կլպած արևադարձային ծառի փայտ",
  "block.minecraft.stripped_mangrove_log": "Կլպած մանգրայի գերան",
  "block.minecraft.stripped_mangrove_wood": "Կլպած մանգրայի փայտ",
  "block.minecraft.stripped_oak_log": "Կեղեւազրկած կաղնու գերան",
  "block.minecraft.stripped_oak_wood": "Կլպած կաղնու փայտ",
  "block.minecraft.stripped_pale_oak_log": "Կլպած դժգույն կաղնու գերան",
  "block.minecraft.stripped_pale_oak_wood": "Կլպած դժգույն կաղնու փայտ",
  "block.minecraft.stripped_spruce_log": "Կեղեւազրկած եղեւնու գերան",
  "block.minecraft.stripped_spruce_wood": "Կլպած եղևնու փայտ",
  "block.minecraft.stripped_warped_hyphae": "Կեղևազրկած աղավաղված հիֆեր",
  "block.minecraft.stripped_warped_stem": "Կեղևազրկած աղավաղված գերան",
  "block.minecraft.structure_block": "Կառուցվածքի բլոկ",
  "block.minecraft.structure_void": "Դատարկ բլոկ",
  "block.minecraft.sugar_cane": "Եղեգնաշաքար",
  "block.minecraft.sunflower": "Արեւածաղիկ",
  "block.minecraft.suspicious_gravel": "Կասկածելի կոպիճ",
  "block.minecraft.suspicious_sand": "Կասկածելի ավազ",
  "block.minecraft.sweet_berry_bush": "Քաղցր Հատապտուղների Թուփ",
  "block.minecraft.tall_dry_grass": "Բարձրահասակ չորացած խոտ",
  "block.minecraft.tall_grass": "Բարձրահասակ Խոտ",
  "block.minecraft.tall_seagrass": "Բարձրահասակ Ծովախոտ",
  "block.minecraft.target": "Թիրախ",
  "block.minecraft.terracotta": "Տեռակոտա",
  "block.minecraft.test_block": "Փորձերի բլոկ",
  "block.minecraft.test_instance_block": "Փորձի օրինակի բլոկ",
  "block.minecraft.tinted_glass": "Մգեցված ապակի",
  "block.minecraft.tnt": "Պայթուցիկ",
  "block.minecraft.tnt.disabled": "Պայթուցիկի պայթյուններն անջատված են",
  "block.minecraft.torch": "Ջահ",
  "block.minecraft.torchflower": "Ջահածաղիկ",
  "block.minecraft.torchflower_crop": "Ջահածաղիկի բերք",
  "block.minecraft.trapped_chest": "Թակարդված գանձարկղ",
  "block.minecraft.trial_spawner": "Փորձության Ծնարան",
  "block.minecraft.tripwire": "Թակարդալար",
  "block.minecraft.tripwire_hook": "Կեռիկ",
  "block.minecraft.tube_coral": "Խողովակային մարջան",
  "block.minecraft.tube_coral_block": "Գլանային մարջանի բլոկ",
  "block.minecraft.tube_coral_fan": "Հովհարային խողովակային մարջան",
  "block.minecraft.tube_coral_wall_fan": "Պատի հովհարային խողովակային մարջան",
  "block.minecraft.tuff": "Տուֆ",
  "block.minecraft.tuff_brick_slab": "Տուֆ Աղյուս Սալ",
  "block.minecraft.tuff_brick_stairs": "Տուֆի աղյուսով աստիճաններ",
  "block.minecraft.tuff_brick_wall": "Տուֆի աղյուս պատ",
  "block.minecraft.tuff_bricks": "Տուֆի աղյուսներ",
  "block.minecraft.tuff_slab": "Տուֆ Սալ",
  "block.minecraft.tuff_stairs": "Տուֆի աստիճաններ",
  "block.minecraft.tuff_wall": "Տուֆի պատ",
  "block.minecraft.turtle_egg": "Կրիայի ձու",
  "block.minecraft.twisting_vines": "Գալարաձև որթատունկ",
  "block.minecraft.twisting_vines_plant": "Գալարաձև որթատնկի բույս",
  "block.minecraft.vault": "Պահոց",
  "block.minecraft.verdant_froglight": "Կանաչավուն գորտալույս",
  "block.minecraft.vine": "Որթատունկ",
  "block.minecraft.void_air": "Վակկուում",
  "block.minecraft.wall_torch": "Պատի ջահ",
  "block.minecraft.warped_button": "Աղավաղված Կոճակ",
  "block.minecraft.warped_door": "Աղավաղված Դուռ",
  "block.minecraft.warped_fence": "Աղավաղված Ցանկապատ",
  "block.minecraft.warped_fence_gate": "Աղավաղված ցանկապատի դարպաս",
  "block.minecraft.warped_fungus": "Աղավաղված Սունկ",
  "block.minecraft.warped_hanging_sign": "Շեղված կախովի ցուցանակ",
  "block.minecraft.warped_hyphae": "Աղավաղված Հիֆեր",
  "block.minecraft.warped_nylium": "Աղավաղած նիլիում",
  "block.minecraft.warped_planks": "Աղավաղված տախտակներ",
  "block.minecraft.warped_pressure_plate": "Աղավաղված Ճնշաթիթեղ",
  "block.minecraft.warped_roots": "Աղավաղված Արմատներ",
  "block.minecraft.warped_shelf": "Աղավաղված դարակ",
  "block.minecraft.warped_sign": "Աղավաղված Ցուցանակ",
  "block.minecraft.warped_slab": "Աղավաղված Սալիկ",
  "block.minecraft.warped_stairs": "Աղավաղված Աստիճաններ",
  "block.minecraft.warped_stem": "Աղավաղված Գերան",
  "block.minecraft.warped_trapdoor": "Աղավաղված ծուղակի դռնակ",
  "block.minecraft.warped_wall_hanging_sign": "Շեղված պատից կախովի ցուցանակ",
  "block.minecraft.warped_wall_sign": "Աղավաղված Պատի Ցուցանակ",
  "block.minecraft.warped_wart_block": "Աղավաղված Աճվածքի բլոկ",
  "block.minecraft.water": "Ջուր",
  "block.minecraft.water_cauldron": "Ջրով կաթսա",
  "block.minecraft.waxed_chiseled_copper": "Մոմով պատված պղինձ",
  "block.minecraft.waxed_copper_bars": "Մոմապատ պղնձե ճաղեր",
  "block.minecraft.waxed_copper_block": "Մոմապատված պղնձե բլոկ",
  "block.minecraft.waxed_copper_bulb": "Էպիլյացված պղնձե լամպ",
  "block.minecraft.waxed_copper_chain": "Մոմապատ պղնձե շղթա",
  "block.minecraft.waxed_copper_chest": "Մոմապատ պղնձե սնդուկ",
  "block.minecraft.waxed_copper_door": "Մոմապատ պղնձե դուռ",
  "block.minecraft.waxed_copper_golem_statue": "Մոմապատ պղնձե գոլեմի քանդակ",
  "block.minecraft.waxed_copper_grate": "Մոմապատ պղնձե ցանց",
  "block.minecraft.waxed_copper_lantern": "Մոմապատ պղնձե լապտեր",
  "block.minecraft.waxed_copper_trapdoor": "Մոմով պատված պղնձե դուռ",
  "block.minecraft.waxed_cut_copper": "Մոմապատված կտրտված պղինձ",
  "block.minecraft.waxed_cut_copper_slab": "Մոմապատված կտրտված պղնձե սալիկ",
  "block.minecraft.waxed_cut_copper_stairs": "Մոմապատված կտրտված պղնձե աստիճաններ",
  "block.minecraft.waxed_exposed_chiseled_copper": "Մոմով բացված սալահատակ պղինձ",
  "block.minecraft.waxed_exposed_copper": "Մոմապատված Մգացած Պղինձ",
  "block.minecraft.waxed_exposed_copper_bars": "Մոմապատ մգացած պղնձե ճաղեր",
  "block.minecraft.waxed_exposed_copper_bulb": "Մոմապատ մգացած պղնձե լամպ",
  "block.minecraft.waxed_exposed_copper_chain": "Մոմապատ սևացած պղնձե շղթա",
  "block.minecraft.waxed_exposed_copper_chest": "Մոմապատ սևացած պղնձե սնդուկ",
  "block.minecraft.waxed_exposed_copper_door": "Էքսացված պղնձե դուռ",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Մոմապատ սևացած պղնձե գոլեմի քանդակ",
  "block.minecraft.waxed_exposed_copper_grate": "Մոմապատ սևացած պղնձե ցանց",
  "block.minecraft.waxed_exposed_copper_lantern": "Մոմապատ մգացած պղնձե լապտեր",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Մոմապատ սևացած պղնձե ծուղակե դռնակ",
  "block.minecraft.waxed_exposed_cut_copper": "Մոմապատված մգացած կտրտված պղինձ",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Մոմապատված մգացած հատած պղնձե սալիկ",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Մոմապատված մգացած հատած պղնձե աստիճաններ",
  "block.minecraft.waxed_exposed_lightning_rod": "Մոմապատ մգացած շանթարգել",
  "block.minecraft.waxed_lightning_rod": "Մոմապատ շանթարգել",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Մոմով օքսիդացված մանրացված պղինձ",
  "block.minecraft.waxed_oxidized_copper": "Մոմով օքսիդացված պղինձ",
  "block.minecraft.waxed_oxidized_copper_bars": "Մոմապատ օքսիդացված պղնձե ճաղեր",
  "block.minecraft.waxed_oxidized_copper_bulb": "Մոմապատ օքսիդացված պղնձի լամպ",
  "block.minecraft.waxed_oxidized_copper_chain": "Մոմապատ օքսիդացած պղնձե շզթա",
  "block.minecraft.waxed_oxidized_copper_chest": "Մոմապատ օքսիդացած պղնձե սնդուկ",
  "block.minecraft.waxed_oxidized_copper_door": "Մոմով օքսիդացված պղնձե դուռ",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Մոմապատ օքսիդացված պղնձե գոլեմի քանդակ",
  "block.minecraft.waxed_oxidized_copper_grate": "Մոմապատ օքսիդացված պղնձե ցանց",
  "block.minecraft.waxed_oxidized_copper_lantern": "Մոմապատ օքսիդացված պղնձե լապտեր",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Մոմապատ օքսիդացված պղնձե ծուղակե դռնակ",
  "block.minecraft.waxed_oxidized_cut_copper": "Մոմով օքսիդացված կտրված պղինձ",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Մոմով օքսիդացված հատած պղնձե սալիկ",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Մոմապատված օքսիդացված հատած պղնձե աստիճաններ",
  "block.minecraft.waxed_oxidized_lightning_rod": "Մոմապատ օքսիդացված շանթարգել",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waxed Weathered Chiseled Copper",
  "block.minecraft.waxed_weathered_copper": "Մոմապատված Օքսիդացված Պղինձ",
  "block.minecraft.waxed_weathered_copper_bars": "Մոմապատ քայքայված պղնձե ճաղեր",
  "block.minecraft.waxed_weathered_copper_bulb": "Մոմապատ քայքայված պղնձե լամպ",
  "block.minecraft.waxed_weathered_copper_chain": "Մոմապատ քայքայված պղնձե շղթա",
  "block.minecraft.waxed_weathered_copper_chest": "Մոմապատ քայքայված պղնձե սնդուկ",
  "block.minecraft.waxed_weathered_copper_door": "Էպիլյացիայի ենթարկված պղնձե դուռ",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Մոմապատ քայքայված պղնձե գոլեմի քանդակ",
  "block.minecraft.waxed_weathered_copper_grate": "Մոմապատ քայքայված պղնձե ցանց",
  "block.minecraft.waxed_weathered_copper_lantern": "Մոմապատ քայքայված պղնձե լապտեր",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waxed Weathered Copper Trapdoor",
  "block.minecraft.waxed_weathered_cut_copper": "Մոմապատ քայքայված հատած պղինձ",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Մոմապատված քայքայված հատած պղնձե սալիկ",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Մոմապատված քայքայված հատած պղնձե աստիճաններ",
  "block.minecraft.waxed_weathered_lightning_rod": "Մոմապատ քայքայված շանթարգել",
  "block.minecraft.weathered_chiseled_copper": "Քաշված պղինձ",
  "block.minecraft.weathered_copper": "Քայքայված պղինձ",
  "block.minecraft.weathered_copper_bars": "Քայքայված պղնձե ճաղեր",
  "block.minecraft.weathered_copper_bulb": "Եղանակացած պղնձե լամպ",
  "block.minecraft.weathered_copper_chain": "Քայքայված պղնձե շղթա",
  "block.minecraft.weathered_copper_chest": "Քայքայված պղնձե սնդուկ",
  "block.minecraft.weathered_copper_door": "Չորացված պղնձե դուռ",
  "block.minecraft.weathered_copper_golem_statue": "Քայքայված պղնձե գոլեմի քանդակ",
  "block.minecraft.weathered_copper_grate": "Քայքայված պղնձե ցանց",
  "block.minecraft.weathered_copper_lantern": "Քայքայված պղնձե լապտեր",
  "block.minecraft.weathered_copper_trapdoor": "Քայքայված պղնձե դուռ",
  "block.minecraft.weathered_cut_copper": "Քայքայված կտրտված պղինձ",
  "block.minecraft.weathered_cut_copper_slab": "Քայքայված կտրտված պղնձե սալիկ",
  "block.minecraft.weathered_cut_copper_stairs": "Քայքայված կտրտված պղնձից աստիճաններ",
  "block.minecraft.weathered_lightning_rod": "Քայքայված շանթարգել",
  "block.minecraft.weeping_vines": "Լացող Որթատունկ",
  "block.minecraft.weeping_vines_plant": "Լացող Որթատնկի Բույս",
  "block.minecraft.wet_sponge": "Թաց սպունգ",
  "block.minecraft.wheat": "Ցորենի բերք",
  "block.minecraft.white_banner": "Սպիտակ դրոշակ",
  "block.minecraft.white_bed": "Սպիտակ մահճակալ",
  "block.minecraft.white_candle": "Սպիտակ մոմ",
  "block.minecraft.white_candle_cake": "Թխվածք Սպիտակ Մոմով",
  "block.minecraft.white_carpet": "Սպիտակ գորգ",
  "block.minecraft.white_concrete": "Սպիտակ բետոն",
  "block.minecraft.white_concrete_powder": "Սպիտակ փոշի բետոն",
  "block.minecraft.white_glazed_terracotta": "Սպիտակ Թրծած Տեռակոտա",
  "block.minecraft.white_shulker_box": "Սպիտակ Շալքերի Տուփ",
  "block.minecraft.white_stained_glass": "Սպիտակ ապակի",
  "block.minecraft.white_stained_glass_pane": "Սպիտակ ապակու շերտ",
  "block.minecraft.white_terracotta": "Սպիտակ տեռակոտա",
  "block.minecraft.white_tulip": "Սպիտակ Վարդակակաչ",
  "block.minecraft.white_wool": "Սպիտակ բուրդ",
  "block.minecraft.wildflowers": "Վայրի ծաղիկներ",
  "block.minecraft.wither_rose": "Թառամած Վարդ",
  "block.minecraft.wither_skeleton_skull": "Սև Կմախքի Գանգ",
  "block.minecraft.wither_skeleton_wall_skull": "Վիզեր-կմաղքի պատի գանգ",
  "block.minecraft.yellow_banner": "Դեղին դրոշակ",
  "block.minecraft.yellow_bed": "Դեղին մահճակալ",
  "block.minecraft.yellow_candle": "Դեղին մոմ",
  "block.minecraft.yellow_candle_cake": "Թխվածք Դեղին Մոմով",
  "block.minecraft.yellow_carpet": "Դեղին Գորգ",
  "block.minecraft.yellow_concrete": "Դեղին բետոն",
  "block.minecraft.yellow_concrete_powder": "Դեղին փոշի բետոն",
  "block.minecraft.yellow_glazed_terracotta": "Դեղին Թրծած Տեռակոտա",
  "block.minecraft.yellow_shulker_box": "Դեղին Շալքերի Տուփ",
  "block.minecraft.yellow_stained_glass": "Դեղին ապակի",
  "block.minecraft.yellow_stained_glass_pane": "Դեղին ապակու շերտ",
  "block.minecraft.yellow_terracotta": "Դեղին Տեռակոտա",
  "block.minecraft.yellow_wool": "Դեղին բուրդ",
  "block.minecraft.zombie_head": "Զոմբիի Գլուխ",
  "block.minecraft.zombie_wall_head": "Զոմբիի պատի գլուխ",
  "item.minecraft.acacia_boat": "Ակացիայի փայտից Նավակ",
  "item.minecraft.acacia_chest_boat": "Բեռնատար նավակ ակացիայից",
  "item.minecraft.allay_spawn_egg": "Մունջիկ ծնելու ձու",
  "item.minecraft.amethyst_shard": "Մեղեսիկի կտոր",
  "item.minecraft.angler_pottery_shard": "Ձկնորսական խեցեղեն բեկոր",
  "item.minecraft.angler_pottery_sherd": "Կավագործական «Ձկնորս» բեկոր",
  "item.minecraft.apple": "Խնձոր",
  "item.minecraft.archer_pottery_shard": "Աղեղնաձիգ կերամիկական բեկոր",
  "item.minecraft.archer_pottery_sherd": "Աղեղնավոր Խեցեգործարան Շերդ",
  "item.minecraft.armadillo_scute": "Զրահամորթի Պատյան",
  "item.minecraft.armadillo_spawn_egg": "Զրահակիր ստեղծելու ձու",
  "item.minecraft.armor_stand": "Զրահի Հենարան",
  "item.minecraft.arms_up_pottery_shard": "Ձեռքերը վեր կավե բեկոր",
  "item.minecraft.arms_up_pottery_sherd": "Զենք վերև Խեցեգործարան Շերդ",
  "item.minecraft.arrow": "Նետ",
  "item.minecraft.axolotl_bucket": "Աքսոլոտլով դույլ",
  "item.minecraft.axolotl_spawn_egg": "Աքսոլոտլի ծնելու ձու",
  "item.minecraft.baked_potato": "Թխված Կարտոֆիլ",
  "item.minecraft.bamboo_chest_raft": "Հնդկեղեգից լաստանավ Սնդուկի հետ",
  "item.minecraft.bamboo_raft": "Հնդկեղեգից լաստանավ",
  "item.minecraft.bat_spawn_egg": "Չղջիկ ստեղծելու ձու",
  "item.minecraft.bee_spawn_egg": "Մեղու ստեղծելու ձու",
  "item.minecraft.beef": "Հում Տավարի Միս",
  "item.minecraft.beetroot": "Բողկ",
  "item.minecraft.beetroot_seeds": "Բողկի Սերմեր",
  "item.minecraft.beetroot_soup": "Բողկի Ապուր",
  "item.minecraft.birch_boat": "Կեչու ծառից Նավակ",
  "item.minecraft.birch_chest_boat": "Բեռնատար նավ կեչիից",
  "item.minecraft.black_bundle": "Սև պարկ",
  "item.minecraft.black_dye": "Սեւ ներկ",
  "item.minecraft.black_harness": "Սև սանձ",
  "item.minecraft.blade_pottery_shard": "Սայր կավե բեկոր",
  "item.minecraft.blade_pottery_sherd": "Սայր Խեցեգործարան Շերդ",
  "item.minecraft.blaze_powder": "Բոցավարի Փոշի",
  "item.minecraft.blaze_rod": "Բոցավառի Ձող",
  "item.minecraft.blaze_spawn_egg": "Բոցավառ ստեղծելու ձու",
  "item.minecraft.blue_bundle": "Կապույտ պարկ",
  "item.minecraft.blue_dye": "Կապույտ ներկ",
  "item.minecraft.blue_egg": "Կապույտ ձու",
  "item.minecraft.blue_harness": "Կապույտ սանձ",
  "item.minecraft.bogged_spawn_egg": "Ճահճած Ծնելու Ձու",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Կաղապար",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Զրահի «Լիցք» նախշ",
  "item.minecraft.bone": "Ոսկոր",
  "item.minecraft.bone_meal": "Ոսկորի փոշի",
  "item.minecraft.book": "Գիրք",
  "item.minecraft.bordure_indented_banner_pattern": "Ատամաձև դրոշի նախշ",
  "item.minecraft.bow": "Աղեղ",
  "item.minecraft.bowl": "Աման",
  "item.minecraft.bread": "Հաց",
  "item.minecraft.breeze_rod": "Զեփյուռի ձող",
  "item.minecraft.breeze_spawn_egg": "Զեփյուռ ստեղծելու ձու",
  "item.minecraft.brewer_pottery_shard": "կավե բեկոր",
  "item.minecraft.brewer_pottery_sherd": "Գարեջուր Խեցեգործարան Շերդ",
  "item.minecraft.brewing_stand": "Դեղապատրաստման կայարան",
  "item.minecraft.brick": "Աղյուս",
  "item.minecraft.brown_bundle": "Շագանակագույն պարկ",
  "item.minecraft.brown_dye": "Շագանակագույն ներկ",
  "item.minecraft.brown_egg": "Շագանակագույն ձու",
  "item.minecraft.brown_harness": "Շագանակագույն լծասարք",
  "item.minecraft.brush": "Վրձին",
  "item.minecraft.bucket": "Դույլ",
  "item.minecraft.bundle": "Պարկ",
  "item.minecraft.bundle.empty": "Դատարկ",
  "item.minecraft.bundle.empty.description": "Կարող է պահել տարբեր առարկաների կույտ",
  "item.minecraft.bundle.full": "Լցված",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Կրակի կավագործական կտոր",
  "item.minecraft.burn_pottery_sherd": "այրել Խեցեգործարան Շերդ",
  "item.minecraft.camel_husk_spawn_egg": "Ննջեցյալ ուղտ ծնելու ձու",
  "item.minecraft.camel_spawn_egg": "Ուղտ ծնելու ձու",
  "item.minecraft.carrot": "Գազար",
  "item.minecraft.carrot_on_a_stick": "Գազար Փայտիկի Վրա",
  "item.minecraft.cat_spawn_egg": "Կատու ծնելու ձու",
  "item.minecraft.cauldron": "Կաթսա",
  "item.minecraft.cave_spider_spawn_egg": "Քարանձավային սարդ ծնելու ձու",
  "item.minecraft.chainmail_boots": "Օղազրահե Կոշիկներ",
  "item.minecraft.chainmail_chestplate": "Օղազրահ Կրծքապանակ",
  "item.minecraft.chainmail_helmet": "Օղազրահե Սաղավարտ",
  "item.minecraft.chainmail_leggings": "Օղազրահ Տապաթ",
  "item.minecraft.charcoal": "Փայտացուխ",
  "item.minecraft.cherry_boat": "Բալենու նավակ",
  "item.minecraft.cherry_chest_boat": "Բեռնատար նավակ բալենիից",
  "item.minecraft.chest_minecart": "Վագոն Սնդուկով",
  "item.minecraft.chicken": "Հում Հավ",
  "item.minecraft.chicken_spawn_egg": "Հավ ծնելու ձու",
  "item.minecraft.chorus_fruit": "Քորուզի պտուղ",
  "item.minecraft.clay_ball": "Կավե գնդիկ",
  "item.minecraft.clock": "Ժամացույց",
  "item.minecraft.coal": "Ածուխ",
  "item.minecraft.coast_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Զրահի «Ափ» նախշ",
  "item.minecraft.cocoa_beans": "Կակաո-լոբի",
  "item.minecraft.cod": "Հում Ձողաձուկ",
  "item.minecraft.cod_bucket": "Ձողաձկան Դույլ",
  "item.minecraft.cod_spawn_egg": "Ձողաձկան ծնելու ձու",
  "item.minecraft.command_block_minecart": "Վագոն Հրամանի Բլոկով",
  "item.minecraft.compass": "Կողմնացույց",
  "item.minecraft.cooked_beef": "Բիֆշտեքս",
  "item.minecraft.cooked_chicken": "Հավի խորոված",
  "item.minecraft.cooked_cod": "Եփված Ձողաձուկ",
  "item.minecraft.cooked_mutton": "Ոչխարի խորոված",
  "item.minecraft.cooked_porkchop": "Խոզի խորոված",
  "item.minecraft.cooked_rabbit": "պատրաստված նապաստակ",
  "item.minecraft.cooked_salmon": "Պատրաստված Սաղմոն",
  "item.minecraft.cookie": "Թխվածք",
  "item.minecraft.copper_axe": "Պղնձե կացին",
  "item.minecraft.copper_boots": "Պղնձե Կոշիկներ",
  "item.minecraft.copper_chestplate": "Պղնձե Կրծքապանակ",
  "item.minecraft.copper_golem_spawn_egg": "Պղնձե գոլեմ ստեղծելու ձու",
  "item.minecraft.copper_helmet": "Պղնձե Սաղավարտ",
  "item.minecraft.copper_hoe": "Պղնձե թոխր",
  "item.minecraft.copper_horse_armor": "Ձիու Պղնձե Զրահ",
  "item.minecraft.copper_ingot": "Պղնձե ձույլ",
  "item.minecraft.copper_leggings": "Պղնձե Վարտիկ",
  "item.minecraft.copper_nautilus_armor": "Պղնձե Նաուտիլուս զրահ",
  "item.minecraft.copper_nugget": "Պղնձի կտոր",
  "item.minecraft.copper_pickaxe": "Պղնձե Քլունգ",
  "item.minecraft.copper_shovel": "Պղնձե բահ",
  "item.minecraft.copper_spear": "Պղնձե նիզակ",
  "item.minecraft.copper_sword": "Պղնձե թուր",
  "item.minecraft.cow_spawn_egg": "Կով ծնելու ձու",
  "item.minecraft.creaking_spawn_egg": "Ճռինչ ծնելու ձու",
  "item.minecraft.creeper_banner_pattern": "Դրոշի նախշ",
  "item.minecraft.creeper_banner_pattern.desc": "Քրիփեր",
  "item.minecraft.creeper_banner_pattern.new": "Դրոշակի «Քրիփեր» նախշ",
  "item.minecraft.creeper_spawn_egg": "Քրիփեր ստեղծելու ձու",
  "item.minecraft.crossbow": "Խաչաղեղ",
  "item.minecraft.crossbow.projectile": "Արկ.",
  "item.minecraft.crossbow.projectile.multiple": "Արկ՝ %s-ը %s-ի",
  "item.minecraft.crossbow.projectile.single": "Արկ՝ %s",
  "item.minecraft.cyan_bundle": "Փիրուզագույն պարկ",
  "item.minecraft.cyan_dye": "Փիրուզագույն ներկ",
  "item.minecraft.cyan_harness": "Փիրուզագույն լծասարք",
  "item.minecraft.danger_pottery_shard": "Վտանգի կավագործական կտոր",
  "item.minecraft.danger_pottery_sherd": "Վտանգ Խեցեգործարան Շերդ",
  "item.minecraft.dark_oak_boat": "Մուգ Կաղնե Նավակ",
  "item.minecraft.dark_oak_chest_boat": "Բեռնատար նավակ մուգ կաղնուց",
  "item.minecraft.debug_stick": "կարգաբերման փայտ",
  "item.minecraft.debug_stick.empty": "%s չունի հատկություններ",
  "item.minecraft.debug_stick.select": "ընտրված \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "«%s»-ում %s",
  "item.minecraft.diamond": "Ադամանդ",
  "item.minecraft.diamond_axe": "Ադամանդե Կացին",
  "item.minecraft.diamond_boots": "Ադամանդե Կոշիկներ",
  "item.minecraft.diamond_chestplate": "Ադամանդե Կրծքապանակ",
  "item.minecraft.diamond_helmet": "Ադամանդե Սաղավարտ",
  "item.minecraft.diamond_hoe": "Ադամանդե թոխր",
  "item.minecraft.diamond_horse_armor": "Ձիու Ադամանդե Զրահ",
  "item.minecraft.diamond_leggings": "Ադամանդե Վարտիկ",
  "item.minecraft.diamond_nautilus_armor": "Ադամանդե Նաուտիլուսի զրահ",
  "item.minecraft.diamond_pickaxe": "Ադամանդե Քլունգ",
  "item.minecraft.diamond_shovel": "Ադամանդե Թիակ",
  "item.minecraft.diamond_spear": "Ադամանդի նիզակ",
  "item.minecraft.diamond_sword": "Ադամանդե Սուր",
  "item.minecraft.disc_fragment_5": "Թիթեղի բեկոր",
  "item.minecraft.disc_fragment_5.desc": "Ձայնասկավառակ - 5",
  "item.minecraft.dolphin_spawn_egg": "Դելֆին ծնելու ձու",
  "item.minecraft.donkey_spawn_egg": "Ավանակ ստեղծելու ձու",
  "item.minecraft.dragon_breath": "Վիշապի Շնչառաց",
  "item.minecraft.dried_kelp": "Չորացրած Լամինարիյա",
  "item.minecraft.drowned_spawn_egg": "Խեղդյալ ծնելու ձու",
  "item.minecraft.dune_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Զրահի «Ավազաբլուր» նախշ",
  "item.minecraft.echo_shard": "Արձագանքի բեկոր",
  "item.minecraft.egg": "Ձու",
  "item.minecraft.elder_guardian_spawn_egg": "Հնագույն Պահապան ստեղծելու ձու",
  "item.minecraft.elytra": "Վերնաթևեր",
  "item.minecraft.emerald": "Զմրուխտ",
  "item.minecraft.enchanted_book": "Կախարդական Գիրք",
  "item.minecraft.enchanted_golden_apple": "Կախարդված ոսկե խնձոր",
  "item.minecraft.end_crystal": "Էնդի բյուրեղ",
  "item.minecraft.ender_dragon_spawn_egg": "Էնդեր Վիշապ ծնելու ձու",
  "item.minecraft.ender_eye": "Էնդերի Աչք",
  "item.minecraft.ender_pearl": "Էնդերի Մարգարիտ",
  "item.minecraft.enderman_spawn_egg": "Էնդերմարդ ծնելու ձու",
  "item.minecraft.endermite_spawn_egg": "Էնդերմիտ ծնելու ձու",
  "item.minecraft.evoker_spawn_egg": "Կախարդիչ ստեղծելու ձու",
  "item.minecraft.experience_bottle": "Փորձառությունների Շիշ",
  "item.minecraft.explorer_pottery_shard": "Shard O' Angler Pottery",
  "item.minecraft.explorer_pottery_sherd": "Հետախույզներ Խեցեգործարան Շերդ",
  "item.minecraft.eye_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Զրահի «Աչք» նախշ",
  "item.minecraft.feather": "Փետուր",
  "item.minecraft.fermented_spider_eye": "Սարդի Ֆերմենտացված Աչք",
  "item.minecraft.field_masoned_banner_pattern": "Դրոշակի «Աղյուս» նախշ",
  "item.minecraft.filled_map": "Քարտեզ",
  "item.minecraft.fire_charge": "Կրակի Գունդ",
  "item.minecraft.firework_rocket": "Հրավառություն",
  "item.minecraft.firework_rocket.flight": "Թռիչքի Տեվողություն։",
  "item.minecraft.firework_rocket.multiple_stars": "%s-ը %s-ի",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Հրավառության Աստղ",
  "item.minecraft.firework_star.black": "Սև",
  "item.minecraft.firework_star.blue": "Կապույտ",
  "item.minecraft.firework_star.brown": "Դարչնագույն",
  "item.minecraft.firework_star.custom_color": "Անհատական",
  "item.minecraft.firework_star.cyan": "Փիրուզագույն",
  "item.minecraft.firework_star.fade_to": "Մարել երբ",
  "item.minecraft.firework_star.flicker": "Առկայծել",
  "item.minecraft.firework_star.gray": "Մոխրագույն",
  "item.minecraft.firework_star.green": "Կանաչ",
  "item.minecraft.firework_star.light_blue": "Բաց Կապույտ",
  "item.minecraft.firework_star.light_gray": "Բաց Մոխրագույն",
  "item.minecraft.firework_star.lime": "Լայմ",
  "item.minecraft.firework_star.magenta": "Մորեգույն",
  "item.minecraft.firework_star.orange": "Նարնջագույն",
  "item.minecraft.firework_star.pink": "Վարդագույն",
  "item.minecraft.firework_star.purple": "Մանուշակագույն",
  "item.minecraft.firework_star.red": "Կարմիր",
  "item.minecraft.firework_star.shape": "Անհայտ Ձև",
  "item.minecraft.firework_star.shape.burst": "Պայթյուն",
  "item.minecraft.firework_star.shape.creeper": "Քրիփերանման",
  "item.minecraft.firework_star.shape.large_ball": "Խոշոր Գնդակ",
  "item.minecraft.firework_star.shape.small_ball": "Փոքր Գնդակ",
  "item.minecraft.firework_star.shape.star": "Աստղաձև",
  "item.minecraft.firework_star.trail": "Հետք",
  "item.minecraft.firework_star.white": "Սպիտակ",
  "item.minecraft.firework_star.yellow": "Դեղին",
  "item.minecraft.fishing_rod": "Կարթաձող",
  "item.minecraft.flint": "Կայծքար",
  "item.minecraft.flint_and_steel": "Վառիչ",
  "item.minecraft.flow_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Զրահի «Հոսանք» նախշ",
  "item.minecraft.flow_banner_pattern": "Դրոշի նախշ",
  "item.minecraft.flow_banner_pattern.desc": "Հոսք",
  "item.minecraft.flow_banner_pattern.new": "Դրոշակի «Հոսք» նախշ",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Դրոշի նախշ",
  "item.minecraft.flower_banner_pattern.desc": "Ծաղիկ",
  "item.minecraft.flower_banner_pattern.new": "Դրոշակի «Ծաղիկ» նախշ",
  "item.minecraft.flower_pot": "Ծաղկաման",
  "item.minecraft.fox_spawn_egg": "Աղվես ծնելու ձու",
  "item.minecraft.friend_pottery_shard": "Մրցանակային կավե բեկոր",
  "item.minecraft.friend_pottery_sherd": "Ընկեր Խեցեգործարան Շերդ",
  "item.minecraft.frog_spawn_egg": "Գորտ ծնելու ձու",
  "item.minecraft.furnace_minecart": "Շարժիչով Վագոն",
  "item.minecraft.ghast_spawn_egg": "Գաստ ստեղծելու ձու",
  "item.minecraft.ghast_tear": "Գաստի արցունք",
  "item.minecraft.glass_bottle": "Ապակե շիշ",
  "item.minecraft.glistering_melon_slice": "Շողացող ձմերուկի դիլիմ",
  "item.minecraft.globe_banner_pattern": "Դրոշի նախշ",
  "item.minecraft.globe_banner_pattern.desc": "Երկրագունդ",
  "item.minecraft.globe_banner_pattern.new": "Դրոշակի «Գլոբուս» նախշ",
  "item.minecraft.glow_berries": "Փայլփլուն հատապտուղներ",
  "item.minecraft.glow_ink_sac": "Փայլփլուն թանակի պարկ",
  "item.minecraft.glow_item_frame": "Փայլփլուն իրի շրջանակ",
  "item.minecraft.glow_squid_spawn_egg": "Փայլփլուն ութոտնուկի ծնելու ձու",
  "item.minecraft.glowstone_dust": "Լուսարձակող Քարի Փոշի",
  "item.minecraft.goat_horn": "Այծի եղջյուր",
  "item.minecraft.goat_spawn_egg": "Այծ ծնելու ձու",
  "item.minecraft.gold_ingot": "Ոսկե Ձուլակտոր",
  "item.minecraft.gold_nugget": "Ոսկու Բնակտոր",
  "item.minecraft.golden_apple": "Ոսկե Խնձորր",
  "item.minecraft.golden_axe": "Ոսկե Կացին",
  "item.minecraft.golden_boots": "Ոսկե Կոշիկներ",
  "item.minecraft.golden_carrot": "Ոսկե Գազար",
  "item.minecraft.golden_chestplate": "Ոսկե Կրծքապանակ",
  "item.minecraft.golden_helmet": "Ոսկե Սաղավարտ",
  "item.minecraft.golden_hoe": "Ոսկե Թոխր",
  "item.minecraft.golden_horse_armor": "Ձիու Ոսկե Զրահ",
  "item.minecraft.golden_leggings": "Ոսկե Վարտիկ",
  "item.minecraft.golden_nautilus_armor": "Ոսկե Նաուտիլուսի զրահ",
  "item.minecraft.golden_pickaxe": "Ոսկե Քլունգ",
  "item.minecraft.golden_shovel": "Ոսկե Բահ",
  "item.minecraft.golden_spear": "Ոսկե նիզակ",
  "item.minecraft.golden_sword": "Ոսկե թուր",
  "item.minecraft.gray_bundle": "Մոխրագույն պարկ",
  "item.minecraft.gray_dye": "Մոխրագույն Ներկ",
  "item.minecraft.gray_harness": "Մոխրագույն լծասարք",
  "item.minecraft.green_bundle": "Կանաչ պարկ",
  "item.minecraft.green_dye": "Կանաչ ներկ",
  "item.minecraft.green_harness": "Կանաչ լծասարք",
  "item.minecraft.guardian_spawn_egg": "Պահապան ստեղծելու ձու",
  "item.minecraft.gunpowder": "Վառոդ",
  "item.minecraft.guster_banner_pattern": "Դրոշի նախշ",
  "item.minecraft.guster_banner_pattern.desc": "Պոռթկում",
  "item.minecraft.guster_banner_pattern.new": "Դրոշակի «Մրրիկ» նախշ",
  "item.minecraft.guster_pottery_sherd": "Կավե կտոր «Մրրիկ»",
  "item.minecraft.happy_ghast_spawn_egg": "Ուրախ գաստ ստեղծելու ձու",
  "item.minecraft.harness": "Լծասարք",
  "item.minecraft.heart_of_the_sea": "Ծովի սիրտ",
  "item.minecraft.heart_pottery_shard": "Սիրտ Խեցեգործարան Շերդ",
  "item.minecraft.heart_pottery_sherd": "Սիրտ Խեցեգործարան Շերդ",
  "item.minecraft.heartbreak_pottery_shard": "Սայր կավե բեկոր",
  "item.minecraft.heartbreak_pottery_sherd": "Սրտի կոտրվածք Խեցեգործարան Շերդ",
  "item.minecraft.hoglin_spawn_egg": "Հոգլին ծնելու ձու",
  "item.minecraft.honey_bottle": "Մեղրով շիշ",
  "item.minecraft.honeycomb": "Մեղրամոմ",
  "item.minecraft.hopper_minecart": "Ձագարով Վագոն",
  "item.minecraft.horse_spawn_egg": "Ձի ծնելու ձու",
  "item.minecraft.host_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.host_armor_trim_smithing_template.new": "Զրահի «Վարող» նախշ",
  "item.minecraft.howl_pottery_shard": "Սայր կավե բեկոր",
  "item.minecraft.howl_pottery_sherd": "Ողբալ Խեցեգործարան Շերդ",
  "item.minecraft.husk_spawn_egg": "Ննջեցյալ ստեղծելու ձու",
  "item.minecraft.ink_sac": "Թանաք",
  "item.minecraft.iron_axe": "Երկաթե Կացին",
  "item.minecraft.iron_boots": "Երկաթե Կոշիկներ",
  "item.minecraft.iron_chestplate": "Երկաթե Կրծքապանակ",
  "item.minecraft.iron_golem_spawn_egg": "Երկաթյա Գոլեմ ստեղծելու ձու",
  "item.minecraft.iron_helmet": "Երկաթե Սաղավարտ",
  "item.minecraft.iron_hoe": "Երկաթե թոխր",
  "item.minecraft.iron_horse_armor": "Ձիու Երկաթե Զրահ",
  "item.minecraft.iron_ingot": "Երկաթե Ձուլակտոր",
  "item.minecraft.iron_leggings": "Երկաթե Անդրավարտիկ",
  "item.minecraft.iron_nautilus_armor": "Երկաթե Նաուտիլուս զրահ",
  "item.minecraft.iron_nugget": "երկաթյա Կտոր",
  "item.minecraft.iron_pickaxe": "Երկաթե Քլունգ",
  "item.minecraft.iron_shovel": "Երկաթե Բահ",
  "item.minecraft.iron_spear": "Երկաթե նիզակ",
  "item.minecraft.iron_sword": "Երկաթե թուր",
  "item.minecraft.item_frame": "Առարկայի Շրջանակ",
  "item.minecraft.jungle_boat": "Արևադարձային ծառի փայտից նավակ",
  "item.minecraft.jungle_chest_boat": "Բեռնատար նավ արեւադարձային փայտից",
  "item.minecraft.knowledge_book": "Գիտելիքների Գիրք",
  "item.minecraft.lapis_lazuli": "Լաջվարդե",
  "item.minecraft.lava_bucket": "Լավայով Դույլ",
  "item.minecraft.lead": "Սանձ",
  "item.minecraft.leather": "Կաշի",
  "item.minecraft.leather_boots": "Կաշվե Կոշիկներ",
  "item.minecraft.leather_chestplate": "Կաշվե Կրծքապանակ",
  "item.minecraft.leather_helmet": "Կաշվե Սաղավարտ",
  "item.minecraft.leather_horse_armor": "Ձիու Կաշվե Զրահ",
  "item.minecraft.leather_leggings": "Կաշվե Տաբատ",
  "item.minecraft.light_blue_bundle": "Երկնագույն պարկ",
  "item.minecraft.light_blue_dye": "Բաց կապույտ ներկ",
  "item.minecraft.light_blue_harness": "Բաց կապույտ լծասարք",
  "item.minecraft.light_gray_bundle": "Բաց մոխրագույն պարկ",
  "item.minecraft.light_gray_dye": "Բաց մոխրագույն ներկ",
  "item.minecraft.light_gray_harness": "Բաց մոխրագույն լծասարք",
  "item.minecraft.lime_bundle": "Լայմային պարկ",
  "item.minecraft.lime_dye": "Լայմ ներկ",
  "item.minecraft.lime_harness": "Լայմի գույնով լծասարք",
  "item.minecraft.lingering_potion": "Մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.awkward": "Պղտոր մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.empty": "Անսարքելի երկարատեւ դեղ",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Հրակայունության մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.harming": "Վնասի մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.healing": "Բուժման մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.infested": "Վարակման Մշուշոտ Թուրմ",
  "item.minecraft.lingering_potion.effect.invisibility": "Անտեսանելիության մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.leaping": "Ցատկոտության մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.levitation": "Լեվիտացիայի մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.luck": "Հաջողության մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.mundane": "Սովորական մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.night_vision": "Գիշերային տեսողության մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.oozing": "Կպչունության Մշուշոտ Թուրմ",
  "item.minecraft.lingering_potion.effect.poison": "Թույնի մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.regeneration": "Վերականգնման մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.slow_falling": "Դանդաղ ընկնելու մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.slowness": "Դանդաղության մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.strength": "Ուժի մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.swiftness": "Ջրային շնչառության մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.thick": "Թավ մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.turtle_master": "Կրիայի հզորության երկարատև դեղորայք",
  "item.minecraft.lingering_potion.effect.water": "Երկարատև ջրի շիշ",
  "item.minecraft.lingering_potion.effect.water_breathing": "Ջրային շնչառության մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.weakness": "Թուլության մշուշոտ թուրմ",
  "item.minecraft.lingering_potion.effect.weaving": "Հյուսվածքի Մշուշոտ Թուրմ",
  "item.minecraft.lingering_potion.effect.wind_charged": "Քամու Լիցքով Մշուշոտ Թուրմ",
  "item.minecraft.llama_spawn_egg": "Լամա ծնելու ձու",
  "item.minecraft.lodestone_compass": "Մագնիսացված կոմպաս",
  "item.minecraft.mace": "Լախտ",
  "item.minecraft.magenta_bundle": "Մորեգույն պարկ",
  "item.minecraft.magenta_dye": "Մորեգույն ներկ",
  "item.minecraft.magenta_harness": "Մորեգույն լծասարք",
  "item.minecraft.magma_cream": "Մագմայի գունդ",
  "item.minecraft.magma_cube_spawn_egg": "Մագմային խորանարդ ստեղծելու ձու",
  "item.minecraft.mangrove_boat": "Մանգրենային նավակ",
  "item.minecraft.mangrove_chest_boat": "Բեռնատար նավակ մանգրենիից",
  "item.minecraft.map": "Դատարկ Քարտեզ",
  "item.minecraft.melon_seeds": "Ձմերուկի սերմեր",
  "item.minecraft.melon_slice": "Ձմերուկի կտոր",
  "item.minecraft.milk_bucket": "Կաթով դույլ",
  "item.minecraft.minecart": "Վագոն",
  "item.minecraft.miner_pottery_shard": "Հանքագործով Խեցեգործական Կտոր",
  "item.minecraft.miner_pottery_sherd": "Հանքագործ Խեցեգործարան Շերդ",
  "item.minecraft.mojang_banner_pattern": "Դրոշի նախշ",
  "item.minecraft.mojang_banner_pattern.desc": "Բան",
  "item.minecraft.mojang_banner_pattern.new": "Դրոշակի «Բան» նախշ",
  "item.minecraft.mooshroom_spawn_egg": "Անասուունկը ծնելու ձու",
  "item.minecraft.mourner_pottery_shard": "Սգավոր Խեցեգործարան Շերդ",
  "item.minecraft.mourner_pottery_sherd": "Սգավոր Խեցեգործարան Շերդ",
  "item.minecraft.mule_spawn_egg": "Մուլա ծնելու ձու",
  "item.minecraft.mushroom_stew": "Շոգեխաշած Սունկ",
  "item.minecraft.music_disc_11": "Ձայնասկավառակ",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Ձայնասկավառակ",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Ձայնասկավառակ",
  "item.minecraft.music_disc_5.desc": "Սեմյուել Էյբերգ - 5",
  "item.minecraft.music_disc_blocks": "Ձայնասկավառակ",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Ձայնասկավառակ",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Ձայնասկավառակ",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Ձայնասկավառակ",
  "item.minecraft.music_disc_creator.desc": "Լենա Ռեյն - Creator",
  "item.minecraft.music_disc_creator_music_box": "Ձայնասկավառակ",
  "item.minecraft.music_disc_creator_music_box.desc": "Լենա Ռեյն - Creator (երաժշտական արկղ)",
  "item.minecraft.music_disc_far": "Ձայնասկավառակ",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Ձայնասկավառակ",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Ձայնասկավառակ",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Ձայնասկավառակ",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Ձայնասկավառակ",
  "item.minecraft.music_disc_otherside.desc": "Լենա Ռեյն - otherside",
  "item.minecraft.music_disc_pigstep": "Ձայնասկավառակ",
  "item.minecraft.music_disc_pigstep.desc": "Լենա Ռեյն - Pigstep",
  "item.minecraft.music_disc_precipice": "Ձայնասկավառակ",
  "item.minecraft.music_disc_precipice.desc": "Ահարոն Շերոֆ - Precipice",
  "item.minecraft.music_disc_relic": "Երաժշտության սկավառակ",
  "item.minecraft.music_disc_relic.desc": "Ահարոն Շերոֆ - Relic",
  "item.minecraft.music_disc_stal": "Ձայնասկավառակ",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Ձայնասկավառակ",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Սկավառակ",
  "item.minecraft.music_disc_tears.desc": "Էյմոս Ռոդդի - Tears",
  "item.minecraft.music_disc_wait": "Ձայնասկավառակ",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Ձայնասկավառակ",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Հում ոչխարի միս",
  "item.minecraft.name_tag": "Անվանապիտակ",
  "item.minecraft.nautilus_shell": "Նաուտիլուսի խխունջ",
  "item.minecraft.nautilus_spawn_egg": "Նաուտիլուսի ձվադրման ձու",
  "item.minecraft.nether_brick": "Դժոխքային Աղյուս",
  "item.minecraft.nether_star": "Նեզերի աստղ",
  "item.minecraft.nether_wart": "Նեզերի աճվածք",
  "item.minecraft.netherite_axe": "Նեզերիտե Կացին",
  "item.minecraft.netherite_boots": "Նեզերիտե կոշիկներ",
  "item.minecraft.netherite_chestplate": "Նեզերիտե Կրծքապանակ",
  "item.minecraft.netherite_helmet": "Նեզերիտե սաղավարտ",
  "item.minecraft.netherite_hoe": "Նեզերիտե թոխր",
  "item.minecraft.netherite_horse_armor": "Նեթերիտային ձիու զրահ",
  "item.minecraft.netherite_ingot": "Նեզերիտե ձուլակտոր",
  "item.minecraft.netherite_leggings": "Նեզերիտե Տապաթ",
  "item.minecraft.netherite_nautilus_armor": "Նեթերիտ Նաուտիլուսի զրահ",
  "item.minecraft.netherite_pickaxe": "Նեզերիտե քլունգ",
  "item.minecraft.netherite_scrap": "Նեզերիտի կտոր",
  "item.minecraft.netherite_shovel": "Նեզերիտե բահ",
  "item.minecraft.netherite_spear": "Նեզերիտե նիզակ",
  "item.minecraft.netherite_sword": "Նեզերիտե թուր",
  "item.minecraft.netherite_upgrade_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Նեզերիտային թարմացում",
  "item.minecraft.oak_boat": "Կաղնե Նավակ",
  "item.minecraft.oak_chest_boat": "Բեռնատար նավակ կաղնուց",
  "item.minecraft.ocelot_spawn_egg": "Օցելոտ Ստեղծելու Ձու",
  "item.minecraft.ominous_bottle": "Չարագույժ Շիշ",
  "item.minecraft.ominous_trial_key": "Փորձության Չարագույժ Բանալի",
  "item.minecraft.orange_bundle": "Նարնջագույն պարկ",
  "item.minecraft.orange_dye": "Նարնջագույն ներկ",
  "item.minecraft.orange_harness": "Նարնջագույն լծասարք",
  "item.minecraft.painting": "Նկար",
  "item.minecraft.pale_oak_boat": "Դժգույն կաղնե նավակ",
  "item.minecraft.pale_oak_chest_boat": "Բեռնատար նավակ դժգույն կաղնուց",
  "item.minecraft.panda_spawn_egg": "Պանդա ծնելու ձու",
  "item.minecraft.paper": "Թուղթ",
  "item.minecraft.parched_spawn_egg": "Չորացած ստեղծելու ձու",
  "item.minecraft.parrot_spawn_egg": "Թութակ ծնելու ձու",
  "item.minecraft.phantom_membrane": "Ֆանտոմի թաղանթ",
  "item.minecraft.phantom_spawn_egg": "Ֆանտոմ ծնելու ձու",
  "item.minecraft.pig_spawn_egg": "Խոզ ծնելու ձու",
  "item.minecraft.piglin_banner_pattern": "Դրոշի նմուշ",
  "item.minecraft.piglin_banner_pattern.desc": "Մռութ",
  "item.minecraft.piglin_banner_pattern.new": "Դրոշակի «Մռութ» նախշ",
  "item.minecraft.piglin_brute_spawn_egg": "Գազանացած փիգլին ստեղծելու ձու",
  "item.minecraft.piglin_spawn_egg": "Փիգլին Ծնելու Ձու",
  "item.minecraft.pillager_spawn_egg": "Ավազակ ստեղծելու ձու",
  "item.minecraft.pink_bundle": "Վարդագույն պարկ",
  "item.minecraft.pink_dye": "Վարդագույն ներկ",
  "item.minecraft.pink_harness": "Վարդագույն լծասարք",
  "item.minecraft.pitcher_plant": "Կուժաբույս",
  "item.minecraft.pitcher_pod": "Կուժաբույսի պատիճ",
  "item.minecraft.plenty_pottery_shard": "Շատ Խեցեգործարան Շերդ",
  "item.minecraft.plenty_pottery_sherd": "Շատ Խեցեգործարան Շերդ",
  "item.minecraft.poisonous_potato": "Թունավոր Կարտոֆիլ",
  "item.minecraft.polar_bear_spawn_egg": "Սպիտակ արջ ծնելու ձու",
  "item.minecraft.popped_chorus_fruit": "Տապակած քորուզի պտուղ",
  "item.minecraft.porkchop": "Հում Խոզի Միս",
  "item.minecraft.potato": "Կարտոֆիլ",
  "item.minecraft.potion": "Թուրմ",
  "item.minecraft.potion.effect.awkward": "Պղտոր թուրմ",
  "item.minecraft.potion.effect.empty": "Անսարքելի դեղ",
  "item.minecraft.potion.effect.fire_resistance": "Հրակայունության թուրմ",
  "item.minecraft.potion.effect.harming": "Վնասի Թուրմ",
  "item.minecraft.potion.effect.healing": "Բուժման Թուրմ",
  "item.minecraft.potion.effect.infested": "Վարակման Թուրմ",
  "item.minecraft.potion.effect.invisibility": "Անտեսանելիության թուրմ",
  "item.minecraft.potion.effect.leaping": "Ցատկոտության թուրմ",
  "item.minecraft.potion.effect.levitation": "Լեւիտացիայի թուրմ",
  "item.minecraft.potion.effect.luck": "Հաջողություն Թուրմ",
  "item.minecraft.potion.effect.mundane": "Սովորական թուրմ",
  "item.minecraft.potion.effect.night_vision": "Գիշերային տեսողության թուրմ",
  "item.minecraft.potion.effect.oozing": "Կպչունության Թուրմ",
  "item.minecraft.potion.effect.poison": "Թունավորող Թուրմ",
  "item.minecraft.potion.effect.regeneration": "Վերականգնման թուրմ",
  "item.minecraft.potion.effect.slow_falling": "Դանդաղ ընկման թուրմ",
  "item.minecraft.potion.effect.slowness": "Դանդաղության Թուրմ",
  "item.minecraft.potion.effect.strength": "Ուժի թուրմ",
  "item.minecraft.potion.effect.swiftness": "Արագության թուրմ",
  "item.minecraft.potion.effect.thick": "Թավ թուրմ",
  "item.minecraft.potion.effect.turtle_master": "Կրիայի ուժի թուրմ",
  "item.minecraft.potion.effect.water": "Ջրի Շիշ",
  "item.minecraft.potion.effect.water_breathing": "Ջրային շնչառության թուրմ",
  "item.minecraft.potion.effect.weakness": "Թուլության Թուրմ",
  "item.minecraft.potion.effect.weaving": "Հյուսվածքի Թուրմ",
  "item.minecraft.potion.effect.wind_charged": "Քամու Լիցքով Թուրմ",
  "item.minecraft.pottery_shard_archer": "Աղեղնաձիգով Խեցեգործական Կտոր",
  "item.minecraft.pottery_shard_arms_up": "Աղեղնաձիգով Խեցեգործական Կտոր",
  "item.minecraft.pottery_shard_prize": "Մրցանակի խեցեգործական կտոր",
  "item.minecraft.pottery_shard_skull": "Գանգի կերամիկական բեկոր",
  "item.minecraft.powder_snow_bucket": "Փոշի ձնով դույլ",
  "item.minecraft.prismarine_crystals": "Պրիզմարինի բյուրեղ",
  "item.minecraft.prismarine_shard": "Պրիզմարինի Շեղ",
  "item.minecraft.prize_pottery_shard": "Մրցանակի կավագործական կտոր",
  "item.minecraft.prize_pottery_sherd": "Մրցանակի կավագործական կտոր",
  "item.minecraft.pufferfish": "Փքաձուկ",
  "item.minecraft.pufferfish_bucket": "Փքաձուկը դույլի մեջ",
  "item.minecraft.pufferfish_spawn_egg": "Փքաձուկ ծնելու ձու",
  "item.minecraft.pumpkin_pie": "Դդմով Կարկանդակ",
  "item.minecraft.pumpkin_seeds": "Դդմի Սերմեր",
  "item.minecraft.purple_bundle": "Մանուշակագույն պարկ",
  "item.minecraft.purple_dye": "Մանուշակագույն ներկ",
  "item.minecraft.purple_harness": "Մանուշակագույն լծասարք",
  "item.minecraft.quartz": "Կվարց",
  "item.minecraft.rabbit": "Հում նապաստակ",
  "item.minecraft.rabbit_foot": "Ճագարի ոտք",
  "item.minecraft.rabbit_hide": "Ճագարի մորթի",
  "item.minecraft.rabbit_spawn_egg": "Ճագար ծնելու ձու",
  "item.minecraft.rabbit_stew": "Շոգեխաշած նապաստակ",
  "item.minecraft.raiser_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Զրահի «Բարձրացնող» նախշ",
  "item.minecraft.ravager_spawn_egg": "Ավերիչ ծնելու ձու",
  "item.minecraft.raw_copper": "Հում պղինձ",
  "item.minecraft.raw_gold": "Հում ոսկի",
  "item.minecraft.raw_iron": "Հում երկաթ",
  "item.minecraft.recovery_compass": "Վերադարձի կողմնացույց",
  "item.minecraft.red_bundle": "Կարմիր պարկ",
  "item.minecraft.red_dye": "Կարմիր ներկ",
  "item.minecraft.red_harness": "Կարմիր լծասարք",
  "item.minecraft.redstone": "Կարմիր Փոշի",
  "item.minecraft.resin_brick": "Խեժի աղյուս",
  "item.minecraft.resin_clump": "Խեժի կույտ",
  "item.minecraft.rib_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Զրահի «Կող» նախշ",
  "item.minecraft.rotten_flesh": "Փտած Միս",
  "item.minecraft.saddle": "Թամբ",
  "item.minecraft.salmon": "Հում Սաղմոն",
  "item.minecraft.salmon_bucket": "Դույլով սաղմոն",
  "item.minecraft.salmon_spawn_egg": "Սաղմոն ծնելու ձու",
  "item.minecraft.scrape_pottery_sherd": "Կավե Կտոր «Տաշում»",
  "item.minecraft.scute": "Թեփազրահ",
  "item.minecraft.sentry_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Զրահի «Պահապան» նախշ",
  "item.minecraft.shaper_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Զրահի «Ձեւավորող» նախշ",
  "item.minecraft.sheaf_pottery_shard": "Սայր կավե բեկոր",
  "item.minecraft.sheaf_pottery_sherd": "Շեյֆ Խեցեգործարան Շերդ",
  "item.minecraft.shears": "Մկրատ",
  "item.minecraft.sheep_spawn_egg": "Ոչխար ծնելու ձու",
  "item.minecraft.shelter_pottery_shard": "Սայր կավե բեկոր",
  "item.minecraft.shelter_pottery_sherd": "Ապաստան Խեցեգործարան Շերդ",
  "item.minecraft.shield": "Վահան",
  "item.minecraft.shield.black": "Սև վահան",
  "item.minecraft.shield.blue": "Կապույտ վահան",
  "item.minecraft.shield.brown": "Դառչագույն վահան",
  "item.minecraft.shield.cyan": "Փիրուզագույն վահան",
  "item.minecraft.shield.gray": "Մոխրագույն վահան",
  "item.minecraft.shield.green": "Կանաչ վահան",
  "item.minecraft.shield.light_blue": "Բաց կապուտ վահան",
  "item.minecraft.shield.light_gray": "Բաց մոխրագույն վահան",
  "item.minecraft.shield.lime": "Բաց կանաչ վահան",
  "item.minecraft.shield.magenta": "Մորեգույն վահան",
  "item.minecraft.shield.orange": "Նարնջագույն վահան",
  "item.minecraft.shield.pink": "Վարդագույն վահան",
  "item.minecraft.shield.purple": "Մանուշակագույն վահան",
  "item.minecraft.shield.red": "Կարմիր վահան",
  "item.minecraft.shield.white": "Սպիտակ վահան",
  "item.minecraft.shield.yellow": "Դեղին վահան",
  "item.minecraft.shulker_shell": "Շալքերի Խեցի",
  "item.minecraft.shulker_spawn_egg": "Շալկեր ծնելու ձու",
  "item.minecraft.sign": "Ցուցանակ",
  "item.minecraft.silence_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Զրահի «Լռություն» նախշ",
  "item.minecraft.silverfish_spawn_egg": "Արծաթաթեփուկ ստեղծելու ձու",
  "item.minecraft.skeleton_horse_spawn_egg": "Կմախք-ձի ծնելու ձու",
  "item.minecraft.skeleton_spawn_egg": "Կմախք ծնելու ձու",
  "item.minecraft.skull_banner_pattern": "Դրոշի նախշ",
  "item.minecraft.skull_banner_pattern.desc": "Գանգ",
  "item.minecraft.skull_banner_pattern.new": "Դրոշակի «Գանգ» նախշ",
  "item.minecraft.skull_pottery_shard": "Գանգի կավագործական կտոր",
  "item.minecraft.skull_pottery_sherd": "Գանգի կավագործական կտոր",
  "item.minecraft.slime_ball": "Լորձագնդակ",
  "item.minecraft.slime_spawn_egg": "Լորձ ծնելու ձու",
  "item.minecraft.smithing_template": "Դարբնի կաղապար",
  "item.minecraft.smithing_template.applies_to": "Նշանակվում է.",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Ավելացնել ձույլ կամ բյուրեղ",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Զրահ",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Ավելացնել զրահ",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ձուլակներ և բյուրեղներ",
  "item.minecraft.smithing_template.ingredients": "Բաղադրիչներ:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Ավելացնել նեզերիտե ձուլակտոր",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Ադամանդե հանդերձանք",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Ավելացնել ադամանդե զրահ, զենք կամ գործիք",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Նեզերիտե ձուլակտոր",
  "item.minecraft.smithing_template.upgrade": "Բարձրադրել․ ",
  "item.minecraft.sniffer_spawn_egg": "Հոտոտիկի ծնման ձու",
  "item.minecraft.snort_pottery_shard": "Սայր կավե բեկոր",
  "item.minecraft.snort_pottery_sherd": "Խռռոց Խեցեգործարան Շերդ",
  "item.minecraft.snout_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Զրահի «Մռութ» նախշ",
  "item.minecraft.snow_golem_spawn_egg": "Ձնեմարդ ստեղծելու ձու",
  "item.minecraft.snowball": "Ձնագնդիկ",
  "item.minecraft.spectral_arrow": "Սպեկտրալ Աղեղ",
  "item.minecraft.spider_eye": "Սարդի Աչք",
  "item.minecraft.spider_spawn_egg": "Սարդ ծնելու ձու",
  "item.minecraft.spire_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Զրահի «Սրաձող» նախշ",
  "item.minecraft.splash_potion": "Պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.awkward": "Պայթուցիկ պղտոր թուրմ",
  "item.minecraft.splash_potion.effect.empty": "Պայթուցիկ անսարքելի դեղ",
  "item.minecraft.splash_potion.effect.fire_resistance": "Հրակայունության պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.harming": "Վնասի պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.healing": "Բուժման պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.infested": "Վարակման Պայթուցիչ Թուրմ",
  "item.minecraft.splash_potion.effect.invisibility": "Անտեսանելիության պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.leaping": "Ցատկոտության պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.levitation": "Լեվիտացիայի պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.luck": "Հաջողության պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.mundane": "Սովորական պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.night_vision": "Գիշերային տեսողության պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.oozing": "Կպչունության Պայթուցիչ Թուրմ",
  "item.minecraft.splash_potion.effect.poison": "Թույնի պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.regeneration": "Վերականգնման պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.slow_falling": "Դանդաղ ընկման պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.slowness": "Պայթուցիկ դանդաղության թուրմ",
  "item.minecraft.splash_potion.effect.strength": "Ուժի պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.swiftness": "Արագության պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.thick": "Թավ պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.turtle_master": "Կրիայի հզորության պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.water": "Պայթուցիկ ջրի շիշ",
  "item.minecraft.splash_potion.effect.water_breathing": "Ջրային շնչառության պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.weakness": "Թուլության պայթուցիկ թուրմ",
  "item.minecraft.splash_potion.effect.weaving": "Հյուսվածքի Պայթուցիչ Թուրմ",
  "item.minecraft.splash_potion.effect.wind_charged": "Քամու Լիցքով Պայթուցիչ Թուրմ",
  "item.minecraft.spruce_boat": "Եղևնու ծառից Նավակ",
  "item.minecraft.spruce_chest_boat": "Բեռնատար նավակ եղևնիիից",
  "item.minecraft.spyglass": "Հեռադիտակ",
  "item.minecraft.squid_spawn_egg": "Ութոտնուկ ծնելու ձու",
  "item.minecraft.stick": "Փայտիկ",
  "item.minecraft.stone_axe": "Քարե Կացին",
  "item.minecraft.stone_hoe": "Քարե թոխր",
  "item.minecraft.stone_pickaxe": "Քարե Քլունգ",
  "item.minecraft.stone_shovel": "Քարե Թիակ",
  "item.minecraft.stone_spear": "Քարե նիզակ",
  "item.minecraft.stone_sword": "Քարե Սուր",
  "item.minecraft.stray_spawn_egg": "Թափառող ստեղծելու ձու",
  "item.minecraft.strider_spawn_egg": "Լավաքայլիկ ծնելու ձու",
  "item.minecraft.string": "Թել",
  "item.minecraft.sugar": "Շաքար",
  "item.minecraft.suspicious_stew": "Կասկածելի շոգեխաշել",
  "item.minecraft.sweet_berries": "Քաղցր հատապտուղներ",
  "item.minecraft.tadpole_bucket": "Շերեփուկը դույլում",
  "item.minecraft.tadpole_spawn_egg": "Շերեփուկ ծնելու ձու",
  "item.minecraft.tide_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Զրահի «Մակընթացություն» նախշ",
  "item.minecraft.tipped_arrow": "Վերամշակված Աղեղ",
  "item.minecraft.tipped_arrow.effect.awkward": "Վերամշակված նետ",
  "item.minecraft.tipped_arrow.effect.empty": "Անսարքելի դեղով նետը",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Հրդեհային դիմադրության աղեղ",
  "item.minecraft.tipped_arrow.effect.harming": "Վնասի աղեղ",
  "item.minecraft.tipped_arrow.effect.healing": "Բուժման աղեղ",
  "item.minecraft.tipped_arrow.effect.infested": "Վարակման Նետ",
  "item.minecraft.tipped_arrow.effect.invisibility": "Անտեսանելիության նետ",
  "item.minecraft.tipped_arrow.effect.leaping": "Ցատկելու Աղեղ",
  "item.minecraft.tipped_arrow.effect.levitation": "Լևիտացիայի աղեղ",
  "item.minecraft.tipped_arrow.effect.luck": "Բախտի նետ",
  "item.minecraft.tipped_arrow.effect.mundane": "Վերամշակված նետ",
  "item.minecraft.tipped_arrow.effect.night_vision": "Գիշերային տեսողության նետ",
  "item.minecraft.tipped_arrow.effect.oozing": "Կպչունության Նետ",
  "item.minecraft.tipped_arrow.effect.poison": "Թույնի աղեղ",
  "item.minecraft.tipped_arrow.effect.regeneration": "Վերականգնման աղեղ",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Դանդաղ ընկման աղեղ",
  "item.minecraft.tipped_arrow.effect.slowness": "Դանդաղաշարժության աղեղ",
  "item.minecraft.tipped_arrow.effect.strength": "Ուժի աղեղ",
  "item.minecraft.tipped_arrow.effect.swiftness": "Արագության աղեղ",
  "item.minecraft.tipped_arrow.effect.thick": "Վերամշակված նետ",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Կրիայի ուժի աղեղ",
  "item.minecraft.tipped_arrow.effect.water": "Պայթուցիկ նետ",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Ջրային շնչառության աղեղ",
  "item.minecraft.tipped_arrow.effect.weakness": "Թուլության աղեղ",
  "item.minecraft.tipped_arrow.effect.weaving": "Հյուսվածքի Նետ",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Քամու Լիցքով Նետ",
  "item.minecraft.tnt_minecart": "Պայթուցիկով Վագոն",
  "item.minecraft.torchflower_seeds": "Ջահածաղիկի սերմեր",
  "item.minecraft.totem_of_undying": "Անմահության տոտեմ",
  "item.minecraft.trader_llama_spawn_egg": "Առևտրականի լամա ծնելու ձու",
  "item.minecraft.trial_key": "Փորձության Բանալի",
  "item.minecraft.trident": "Եռաժանի",
  "item.minecraft.tropical_fish": "Արևադարձային ձուկ",
  "item.minecraft.tropical_fish_bucket": "Արևադարձային ձուկը դույլի մեջ",
  "item.minecraft.tropical_fish_spawn_egg": "Արևադարձային ձուկ ծնելու ձու",
  "item.minecraft.turtle_helmet": "Կրիայի պատյան",
  "item.minecraft.turtle_scute": "Կրիայի Պատյան",
  "item.minecraft.turtle_spawn_egg": "Կրիա ծնելու ձու",
  "item.minecraft.vex_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Զրահի «Վնասող» նախշ",
  "item.minecraft.vex_spawn_egg": "Վնասող ստեղծելու ձու",
  "item.minecraft.villager_spawn_egg": "Գյուղացի ստեղծելու ձու",
  "item.minecraft.vindicator_spawn_egg": "Վինդիկատր ստեղծելու ձու",
  "item.minecraft.wandering_trader_spawn_egg": "Թափառող առևտրական ստեղծելու ձու",
  "item.minecraft.ward_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Զրահի «Պահապան» նախշ",
  "item.minecraft.warden_spawn_egg": "Հսկիչ ստեղծելու ձու",
  "item.minecraft.warped_fungus_on_a_stick": "Աղավաղված սունկ փայտի վրա",
  "item.minecraft.water_bucket": "Ջրով Դույլ",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Զրահի «Որոնող» նախշ",
  "item.minecraft.wheat": "Ցորեն",
  "item.minecraft.wheat_seeds": "Ցորենի սերմեր",
  "item.minecraft.white_bundle": "Սպիտակ պարկ",
  "item.minecraft.white_dye": "Սպիտակ ներկ",
  "item.minecraft.white_harness": "Սպիտակ լծասարք",
  "item.minecraft.wild_armor_trim_smithing_template": "Դարբնի Կաղապար",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Զրահի «Վայրի» նախշ",
  "item.minecraft.wind_charge": "Քամու Գունդ",
  "item.minecraft.witch_spawn_egg": "Վհուկ ստեղծելու ձու",
  "item.minecraft.wither_skeleton_spawn_egg": "Ոչնչացնող կմախք ստեղծելու ձու",
  "item.minecraft.wither_spawn_egg": "Վհուկ ստեղծելու ձու",
  "item.minecraft.wolf_armor": "Գայլի Զրահ",
  "item.minecraft.wolf_spawn_egg": "Գայլ ստեղծելու ձու",
  "item.minecraft.wooden_axe": "Փայտե Կացին",
  "item.minecraft.wooden_hoe": "Փայտե թոխր",
  "item.minecraft.wooden_pickaxe": "Փայտե Քլունգ",
  "item.minecraft.wooden_shovel": "Փայտե Բահ",
  "item.minecraft.wooden_spear": "Փայտե նիզակ",
  "item.minecraft.wooden_sword": "Փայտե թուր",
  "item.minecraft.writable_book": "Գիրք և Փետուր",
  "item.minecraft.written_book": "Գրված Գիրք",
  "item.minecraft.yellow_bundle": "Դեղին պարկ",
  "item.minecraft.yellow_dye": "Դեղին ներկ",
  "item.minecraft.yellow_harness": "Դեղին լծասարք",
  "item.minecraft.zoglin_spawn_egg": "Զոմբիացված հոգլին ստեղծելու ձու",
  "item.minecraft.zombie_horse_spawn_egg": "Զոմբիացած ձի ստեղծելու ձու",
  "item.minecraft.zombie_nautilus_spawn_egg": "Զոմբի Նաուտիլուսի ձվադրման ձու",
  "item.minecraft.zombie_spawn_egg": "Զոմբի ստեղծելու ձու",
  "item.minecraft.zombie_villager_spawn_egg": "Չոմբիացված գյուղացի ստեղծելու ձու",
  "item.minecraft.zombified_piglin_spawn_egg": "Զոմբիֆիկացված փիգլին ստեղծման ձու"
}
export const hy_am = items; 
